export const Arabic = () => {
    return {
        dashboard: "لوحة القيادة",
        cms_dashboard: "ج م ق",
        content_dashboard: "المحتوى",
        sales_dashboard: "المبيعات",
        booking_status_dashboard: "حالة الحجز",
        booking_summary_dashboard: "ملخص الحجز",
        Contract_menu: "عقد",
        Contract_sub_menu: "عقد",
        media_management_menu: "إدارة الوسائط",
        media_others_menu: "أخرى",
        series_sub_menu: "السلسلة الأصلية",
        season_sub_menu: "سلسلة",
        events_sub_menu: "حلقة مستقلة",
        Program_sub_menu: "البرنامج",
        movie_sub_menu: "فيلم",
        Trailer_sub_menu: "مقطورة",
        interstitial_sub_menu: "بيني",
        Commercial_sub_menu: "تجاري",
        filler_sub_menu: "حشو",
        music_sub_menu: "موسيقى",
        Break_sub_menu: "استراحة",
        media_episode_group_sub_menu: "مجموعة حلقات الوسائط",
        Planning_menu: "التخطيط",
        Planning_sub_menu: "التخطيط",
        formats_sub_menu: "التنسيقات",
        Program_schedule_clash_sub_menu: "تعارض جدول البرامج",
        scheduling_menu: "الجدولة",
        curate_menu: "تنظيم",
        timeline_sub_menu: "المخطط الزمني",
        Rails_sub_menu: "القضبان",
        pages_sub_menu: "الصفحات",
        assets_sub_menu: "الأصول",
        tv_preview_sub_menu: "معاينة التلفاز",
        web_preview_sub_menu: "معاينة الويب",
        mobile_preview_sub_menu: "معاينة الجوال",
        ingestion_menu: "الابتلاع",
        Posters_sub_menu: "الملصقات",
        ingestion_template_sub_menu: "نموذج العرض",
        Partner_ingestion_sub_menu: "عرض الشريك",
        jobs_sub_menu: "الوظائف",
        sales_menu: "المبيعات",
        Agency_sub_menu: "الوكالة",
        Client_sub_menu: "العميل",
        Campaign_sub_menu: "الحملة",
        booking_sub_menu: "الحجز",
        booking_transfer_sub_menu: "نقل الحجز",
        update_booking_line_number_sub_menu: "تحديث رقم سطر الحجز",
        sales_team_sub_menu: "فريق المبيعات",
        sales_executive_sub_menu: "مدير مبيعات",
        reconciliation_menu: "المصالحة",
        as_run_reconciliation_sub_menu: "كما يتم تشغيل التسوية",
        import_planning_sub_menu: "تخطيط الاستيراد",
        import_asRun_sub_menu: "استيراد كما تشغيل",
        Manage_asRun_sub_menu: "إدارة كما تشغيل",
        export_menu: "تصدير",
        epg_sub_menu: "دليل البرامج الإلكتروني",
        epg_template_sub_menu: "قالب دليل البرامج الإلكتروني",
        Second_event_menu: "حدث ثانوي",
        Prototype_sub_menu: "النموذج الأولي",
        styleSheet_sub_menu: "ورقة الأنماط",
        default_prototype_sub_menu: "النموذج الأولي الافتراضي",
        protoType_source_sub_menu: "مصدر النموذج الأولي",
        Secondary_event_dynamic_rule_sub_menu: "قاعدة ديناميكية للحدث الثانوي",
        billing_menu: "الفوترة",
        billing_sub_menu: "الفوترة",
        generator_bills_sub_menu: "الفواتير المُنشأة",
        masters_menu: "الماجستير",
        master_menu_title: "الرئيسي",
        language_sub_menu: "اللغة",
        content_sub_menu: "المحتوى",
        Assets_type_sub_menu: "نوع الأصول",
        Rails_type_sub_menu: "نوع القضبان",
        Posters_type_sub_menu: "نوع الملصقات",
        users_sub_menu: "المستخدمون",
        Department_sub_menu: "القسم",
        role_sub_menu: "الدور",
        content_category_sub_menu: "فئة المحتوى",
        Region_sub_menu: "المنطقة",
        Brand_sub_menu: "العلامة التجارية",
        Product_sub_menu: "المنتج",
        bank_account_sub_menu: "الحساب البنكي",
        Tax_sub_menu: "الضريبة",
        licensor_sub_menu: "المرخص",
        channel_sub_menu: "القناة",
        currency_sub_menu: "العملة",
        time_range_sub_menu: "النطاق الزمني",
        Repeat_pattern_sub_menu: "نمط التكرار",
        bill_content_sub_menu: "محتوى الفاتورة",
        segemnt_type_sub_menu: "نوع المقطع",
        variation_sub_menu: "التنوع",
        Break_format_sub_menu: "تنسيق الفاصل",
        Payment_provider_sub_menu: "موفر الدفع",
        ott_period_type_sub_menu: "نوع فترة أوت",
        Payment_type_sub_menu: "نوع الدفع",
        table_constraints_sub_menu: "قيود الجدول الزمني",
        monetization_menu: "تحقيق الدخل",
        ott_period_sub_menu: "الفترة",
        subscriber_sub_menu: "المشترك",
        ott_campaign_sub_menu: "الحملة",
        Coupon_sub_menu: "القسيمة",
        data_migration_menu: "ترحيل البيانات",
        form_fields_menu: "حقول النموذج",
        save_button_tooltip: "حفظ",
        save_button_text: "حفظ",
        back_button_tooltip: "رجوع",
        add_button_tooltip: "إضافة",
        add_button_text: "إضافة",
        add_multiple_button_text: "إضافة متعددة",
        add_dialog_header: "إضافة",
        new_button_dialog_header: "جديد",
        new_title_editpageheader: "جديد",
        edit_button_tooltip: "تحرير",
        update_button_tooltip: "تحديث",
        Remove_button_tooltip: "إزالة",
        delete_button_tooltip: "حذف",
        Select_button_tooltip: "اختر",
        Select_button_text: "اختر",
        Cancel_button_tooltip: "إلغاء",
        Cancel_button_text: "إلغاء",
        Preference_button_tooltip: "التفضيل",
        options: "خيارات",
        Refresh_button_tooltip: "تحديث",
        archive: "أرشيف",
        ExportBreaksOnly: "فواصل التصدير فقط",
        loading_pleasewait: "جارٍ التحميل برجاء الانتظار...",
        no_records_found: "لم يتم العثور على سجلات!!",
        Contract_number_label: "رقم العقد",
        Platform_type_label: "نوع النظام الأساسي",
        licensor_label: "المرخص",
        payee_label: "المدفوع لأمره",
        start_date_label: "تاريخ البدء",
        end_Date_label: "تاريخ الانتهاء",
        channel_label: "القناة",
        Platform_label: "النظام الأساسي",
        Region_label: "المنطقة",
        Exhibition_label: "معرض",
        Repeat_label: "كرر",
        play_time_number_label: "رقم وقت التشغيل",
        playTime_label: "وقت اللعب",
        is_unlimited_label: "غير محدود",
        add_media_episode_button_tooltip: "إضافة حلقة إعلامية",
        Remove_media_episode_button_tooltip: "إزالة حلقة الوسائط",
        assetId_column: "معرف الأصل",
        title_column: "العنوان",
        media_category_column: "فئة الوسائط",
        start_date_column: "تاريخ البدء",
        end_date_column: "تاريخ الانتهاء",
        is_unlimited_column: "غير محدود",
        Exhibition_column: "المعرض",
        Repeat_column: "كرر",
        play_time_number_column: "رقم وقت اللعب",
        playTime_column: "وقت اللعب",
        media_library_dialog_header: "مكتبة الوسائط",
        summary: "ملخص",
        create_series_dialog_header: "إنشاء سلسلة أصلية",
        title_label: "العنوان",
        content_label: "المحتوى",
        asset_id_label: "معرف الأصل",
        description_label: "الوصف",
        Synopsis_label: "ملخص",
        islive_label: "مباشر",
        seasons_title: "مسلسل",
        series_cardlist_header: "مسلسل",
        season_cardlist_header: "الحلقة",
        Sidefix_season_tooltip: "الموسم",
        s_content_label: "S. محتوى",
        season_no_label: "رقم الموسم",
        ep_content_label: "Ep. محتوى",
        no_of_episodes_label: "لا. من الحلقات",
        Duration_label: "المدة (س:د:ثث:فف)",
        playlist_duration_label: "المدة (ساعة:دقيقة:ثانية ثانية)",
        Total_block_duration_label: "إجمالي مدة الكتلة (ساعة:دقيقة:ثانية ثانية:ff)",
        season_number_column: "رقم الموسم",
        no_of_episodes_column: "لا. من الحلقات",
        season_content_column: "محتوى الموسم",
        Episode_content_column: "محتوى الحلقة",
        Duration_column: "المدة",
        timerangefrom_column: "من",
        timerangeto_column: "إلى",
        Select_image_collection_header: "اختر صورة",
        description_column: "الوصف",
        meta_data_label: "بيانات التعريف",
        Posters_label: "ملصقات",
        Publishing_label: "النشر",
        search_by_title: "البحث حسب العنوان",
        type_label: "النوع",
        language_label: "اللغة",
        pg_rated_label: "تقييم ص",
        Keywords_label: "الكلمات الرئيسية",
        add_poster_button_tooltip: "أضف ملصقًا",
        Poster_type_column: "نوع الملصق",
        image_column: "صورة",
        edit_poster_dialog_header: "تحرير الملصق",
        Poster_type_label: "نوع الملصق",
        url_label: "عنوان يو آر إل",
        Select_url_tooltip: "اختر عنوان يو آر إل",
        add_publishing_button_tooltip: "إضافة نشر",
        Unlimited_rights_grid: "حقوق غير محدودة",
        tba_label: "سيتم تحديده لاحقًا",
        tba_column: "سيتم تحديده لاحقًا",
        Publishing_dialog_header: "النشر",
        Platform_type_column: "نوع النظام الأساسي",
        channel_column: "القناة",
        source_column: "المصدر",
        enter_title: "أدخل العنوان",
        create_season_dialog_header: "إنشاء سلسلة",
        season_number_label: "رقم الموسم",
        series_label: "السلسلة الأصلية",
        start_episode_label: "بدء الحلقة",
        Select_series_collection_header: "حدد السلسلة الأصلية",
        video_label: "فيديو",
        videos_label: "مقاطع الفيديو",
        add_video_button_tooltip: "إضافة فيديو",
        video_type_column: "نوع الفيديو",
        video_type_label: "نوع الفيديو",
        url_column: "عنوان يو آر إل",
        edit_video_dialog_header: "تحرير الفيديو",
        create_video_dialog_header: "إنشاء فيديو",
        Episode_title_label: "عنوان الحلقة",
        Episode_number_label: "رقم الحلقة",
        Episode_number_labelshort: "رقم إب.",
        Release_date_label: "تاريخ الإصدار",
        version_label: "الإصدار",
        content_category_label: "فئة المحتوى",
        format_label: "التنسيق",
        cast_and_crew_label: "الممثلون وطاقم العمل",
        dynamic_fields_label: "الحقول الديناميكية",
        censer_ating_label: "تقييم الرقيب",
        technic_prototype_label: "النموذج الأولي الفني",
        production_year_label: "سنة الإنتاج",
        language_column: "اللغة",
        Synopsis_column: "ملخص",
        cast_column: "إرسال",
        name_column: "الاسم",
        name_label: "الاسم",
        cast_type_label: "نوع الإرسال",
        section_type_column: "النوع",
        Material_id_column: "معرف المادة",
        actual_duration_column: "المدة الفعلية",
        is_default_column: "افتراضي",
        is_hard_parted_column: "من الصعب الفصل",
        edit_version_dialog_header: "تحرير الإصدار",
        create_version_dialog_header: "إنشاء إصدار",
        section_type_label: "نوع المقطع",
        Material_id_label: "معرف المادة",
        is_hard_parted_label: "من الصعب الانفصال",
        is_default_label: "افتراضي",
        generator_segments_button_text: "إنشاء شرائح",
        auto_distribute_button_text: "التوزيع التلقائي",
        sequence_column: "تسلسل",
        media_id_column: "معرف الوسائط",
        start_time_column: "وقت البدء",
        end_time_column: "وقت الانتهاء",
        Previewed_column: "تمت معاينته",
        parent_content_category_column: "فئة المحتوى الأصلي",
        Select_format_collection: "حدد التنسيق",
        Select_content_category_collection_header: "حدد فئة المحتوى",
        manual_assetid_label: "معرف الأصل اليدوي",
        media_category_label: "فئة الوسائط",
        media_category_type_label: "نوع فئة الوسائط",
        tc_in_label: "ح في (س:د:ثث:فف)",
        tc_out_label: "ح خارج (س:د:ثث:فف)",
        media_episode_group_dialog_header: "إنشاء مجموعة حلقات إعلامية",
        Program_group_dialog_header: "إنشاء مجموعة برامج",
        interstital_group_dialog_header: "إنشاء مجموعة بينية",
        media_category_type_column: "نوع فئة الوسائط",
        media_category_type_collection_header: "نوع فئة الوسائط",
        Episode_dialog_header: "الحلقة",
        Sidefixmenu_rails_asset_tooltip: "الأصول",
        Cardlist_rails_title: "الأصول",
        Cardlist_rails_assets_title: "مكتبة الأصول",
        Rails_title_editpageheader: "القضبان",
        Display_title_label: "عرض العنوان",
        Rails_type_label: "النوع",
        Rails_note_label: "ملاحظة: يمكن للمستخدم الاختيار",
        Publish_label: "نشر",
        Published_label: "منشور",
        unpublished_label: "غير منشور",
        Rails_p_label: "ص",
        Rails_up_label: "أعلى",
        ott_assets_collection_header: "أصول أوت",
        options_actionbutton_menutext: "الخيارات",
        delete_actionbutton_option: "حذف",
        moveup_actionbutton_option: "تحريك لأعلى",
        movedown_actionbutton_option: "تحريك للأسفل",
        Sidefixmenu_rails_tooltip: "السكك الحديدية",
        Cardlist_page_rails_title: "القضبان",
        Cardlist_rails_page_title: "مكتبة السكك الحديدية",
        theme_label: "الموضوع",
        icon_url_label: "رمز يو آر إل",
        Please_fill_out_details_label: "يرجى ملء هذا الحقل.",
        assets_dialog_header: "إنشاء الأصول",
        validation: "الرجاء تحديد القيمة",
        asset_type_label: "نوع الأصل",
        Portrait_image_url_label: "عنوان يو آر إل للصورة الشخصية",
        Landscape_image_url_label: "عنوان يو آر إل للصورة الطبيعية",
        video_playback_url_label: "عنوان يو آر إل لتشغيل الفيديو",
        Select_portal_image_url_collection_header: "تحديد عنوان يو آر إل للصورة الشخصية",
        Select_landscape_image_url_collection_header: "تحديد عنوان يو آر إل للصورة الطبيعية",
        create_poster_dialog_header: "إنشاء ملصق",
        image_url_label: "عنوان يو آر إل للصورة",
        file_path_label: "مسار الملف",
        Poster_note_label: "ملاحظة: سيتم تحميل الصورة عند الحفظ وسيتم تعيين عنوان يو آر إل",
        template_name_label: "اسم القالب",
        Module_type_label: "نوع الوحدة النمطية",
        ingestion_template_type_label: "نوع قالب العرض",
        save_template_text: "حفظ القالب",
        send_text: "إرسال",
        send_button_tooltip: "إرسال",
        body_label: "الجسم",
        Response_label: "الاستجابة",
        Select_file_label: "حدد ملف",
        Load_button_text: "تحميل",
        ingestion_template_note_label: "حسنًا، سنستبدل القيمة المعلمة الأولى بنص البحث أثناء الحفظ",
        key_column: "مفتاح",
        value_column: "القيمة",
        key_label: "مفتاح",
        value_label: "القيمة",
        template_details_label: "تفاصيل القالب",
        template_label: "القالب",
        search_title_label: "عنوان البحث",
        ingest_button_text: "الاستيعاب",
        ingest_button_tooltip: "الاستيعاب",
        Load_button_tooltip: "تحميل",
        ingestion_details_label: "تفاصيل العرض",
        pg_rated_column: "تصنيف بي جي",
        genres_column: "الأنواع",
        show_response_label: "إظهار الاستجابة",
        Response_dialog_header: "الاستجابة",
        Eye_tooltip: "عين",
        Agency_dialog_header: "إنشاء وكالة",
        address_label: "العنوان",
        pincode_label: "الرمز السري",
        email_label: "البريد الإلكتروني",
        Credit_limit_label: "حد الائتمان",
        pan_label: "مِقلاة",
        gst_number_label: "رقم ضريبة السلع والخدمات",
        default_tax_label: "الضريبة الافتراضية",
        is_credit_unlimited_label: "هل الرصيد غير محدود",
        client_dialog_header: "إنشاء عميل",
        Agency_label: "وكالة",
        Campaign_number_label: "رقم الحملة",
        order_date_label: "تاريخ الطلب *",
        period_from_label: "من",
        period_to_label: "إلى",
        Campaign_type_label: "النوع",
        Deal_type_label: "نوع الصفقة",
        Client_label: "العميل",
        location_label: "الموقع",
        Product_label: "المنتج",
        Commission_label: "العمولة",
        target_budget_label: "الميزانية المستهدفة",
        target_spots_label: "المواقع المستهدفة",
        target_thans_label: "ثواني الهدف",
        currency_label: "العملة",
        Discount_label: "الخصم",
        Tax_applicable_label: "الضريبة المطبقة",
        actual_booking_label: "الحجز الفعلي",
        Commercial_label: "تجاري",
        fct_label: "واو سي تي",
        billing_label: "الفوترة",
        channel_tab_label: "القناة",
        channel_name_column: "اسم القناة",
        epg_code_column: "رمز دليل البرامج الإلكتروني",
        asrun_code_column: "رمز كما تشغيل",
        content_column: "المحتوى",
        add_channel_button_tooltip: "إضافة قناة",
        add_commercial_button_tooltip: "إضافة إعلان تجاري",
        add_fct_button_tooltip: "إضافة واو سي تي",
        add_billing_button_tooltip: "إضافة الفواتير",
        channel_collection_header: "القنوات",
        Commercials_collection_header: "الإعلانات التجارية",
        fct_column: "واو سي تي",
        from_date_column: "من التاريخ",
        to_date_column: "حتى الآن",
        Campaign_type_column: "نوع الحملة",
        rate10sec_column: "معدل 10 ثواني",
        days_column: "الأيام",
        fct_dialog_header: "واو سي تي",
        billing_dialog_header: "الفوترة",
        from_date_label: "من تاريخ",
        to_date_label: "حتى الآن",
        Rate10sec_label: "معدل 10 ثانية",
        Rate30sec_label: "معدل 30 ثانية",
        day_label: "اليوم",
        Select_all_label: "تحديد الكل",
        sun_label: "الشمس",
        my_label: "بلدي",
        tue_label: "الثلاثاء",
        wed_label: "الأربعاء",
        thu_label: "الخميس",
        fri_label: "مجاني",
        sat_label: "السبت",
        amount_column: "المبلغ",
        amount_label: "المبلغ",
        booking_label: "الحجز",
        Campaign_label: "الحملة",
        year_label: "السنة",
        Months_label: "الأشهر",
        booking_collection_header: "اختر حملة للحجز",
        from_label: "من:",
        to_label: "إلى:",
        Total_spot_label: "إجمالي النقاط",
        Total_thans_label: "إجمالي الثواني",
        Total_budget_label: "الميزانية الإجمالية:",
        download_template_tooltip: "تنزيل القالب",
        file_tooltip: "اختر ملف",
        line_no_column: "رقم السطر",
        Commercial_column: "تجاري",
        Program_column: "البرنامج",
        house_number_column: "رقم المنزل",
        type_column: "النوع",
        Deal_type_column: "نوع الصفقة",
        Spot_rate_column: "السعر الفوري",
        Position_column: "الموضع",
        from_time_column: "من",
        to_time_column: "إلى",
        Product_code_column: "رمز المنتج",
        Total_spot_column: "إجمالي البقعة",
        Total_fct_column: "إجمالي واو سي تي",
        Total_amount_column: "المبلغ الإجمالي",
        booking_spots_lable: "الأماكن المحجوزة :",
        current_spots_label: "المواقع الحالية :",
        booking_thans_label: "الثواني المحجوزة :",
        current_thans_label: "الثواني الحالية :",
        booking_amount_label: "المبلغ المحجوز :",
        current_amount_label: "المبلغ الحالي :",
        add_booking_dialog_header: "إضافة حجز",
        from_time_label: "من الوقت",
        Spot_per_day_label: "البقعة (لكل يوم)",
        Spot_per_week_label: "البقعة (لكل أسبوع)",
        Rate_label: "السعر",
        estimate_code_label: "الرمز التقديري",
        mark_label: "ملاحظات",
        count_label: "العد",
        Transfer_from_label: "التحويل من",
        Transfer_to_label: "التحويل إلى",
        Transfer_button_tooltip: "نقل",
        Transfer_button_text: "نقل",
        Campaign_column: "الحملة",
        booking_date_column: "تاريخ الحجز",
        time_range_from_column: "النطاق الزمني من",
        time_range_to_column: "النطاق الزمني إلى",
        edit_actionbutton_menutext: "تحرير",
        Select_all_Header_menutext: "تحديد كل الرؤوس",
        delete_actionbutton_menutext: "حذف",
        editduration_actionbutton_menutext: "تعديل المدة",
        Cut_actionbutton_menutext: "قص",
        update_booking_line_number_label: "تحديث رقم سطر الحجز",
        Select_campaign_collection_text: "اختر حملة",
        edit_campaign_collection_text: "تعديل الحملة",
        Select_campaign_collection_tooltip: "اختر",
        already_scheduled_label: "مجدول بالفعل",
        not_scheduled_label: "غير مجدولة",
        edit_booking_dialog_header: "تحرير الحجز",
        Spot_rate_label: "السعر الفوري",
        time_range_from_label: "النطاق الزمني من",
        time_range_to_label: "النطاق الزمني إلى",
        auto_reconcile_button_tooltip: "التسوية التلقائية",
        auto_reconcile_button_text: "تسوية تلقائية",
        import_as_run_button_text: "استيراد كتشغيل",
        import_as_run_button_tooltip: "استيراد كتشغيل",
        reconciled_r_label: "ر",
        reconciled_label: "مصالحة",
        Non_reconciled_label: "لم تتم التسوية",
        non_reconciled_nr_label: "ن.ر",
        Total_label: "الإجمالي",
        Total_commercial: "إجمالي التجاري:",
        sno_column: "رقم.",
        Slot_date_time_column: "التاريخ والوقت",
        Episode_number_column: "رقم الحلقة",
        category_column: "الفئة",
        reconciled_status_column: "حالة التسوية",
        is_reconciled_column: "تمت التسوية",
        reconsilation_by_column: "التسوية حسب",
        Status_column: "الحالة",
        ref_force_match_label: "مطابقة القوة",
        force_match_label: "مطابقة القوة",
        force_match_fm_label: "إف إم",
        ref_force_unmatch_label: "فرض عدم التطابق",
        ref_cancel_label: "إلغاء",
        purge_button_tooltip: "تطهير",
        unpurge_button_tooltip: "إلغاء التطهير",
        Campaign_no_label: "الحملة رقم",
        fic_dxb_0002486_label: "FIC-DXB-0002486",
        Total_spot_857_label: "857",
        Total_amount_label: "المبلغ الإجمالي",
        Total_thans_19935_label: "19935",
        Total_cast_2478_label: "2478.00",
        purged_label: "تم التطهير",
        date_column: "التاريخ",
        is_purged_column: "يتم تطهيرها",
        ref_purged_label: "تطهير",
        ref_unpurged_label: "إلغاء التطهير",
        ref_calculate_spot_rate_label: "حساب السعر الفوري",
        Total_fct_label: "إجمالي واو سي تي",
        Total_spot_rate: "إجمالي السعر الفوري",
        ref_calculate_fct_label: "حساب واو سي تي",
        ref_change_time_range_label: "تغيير النطاق الزمني",
        ref_transfer_label: "نقل",
        ref_update_estimate_code_label: "تحديث رمز التقدير",
        ref_change_commercial_label: "تغيير التجاري",
        ref_change_spot_rate_label: "تغيير السعر الفوري",
        Change_time_range_dialog_header: "تغيير النطاق الزمني",
        start_time_label: "وقت البدء",
        to_time_label: "إلى الوقت",
        Transfer_dialog_header: "نقل",
        Transfer_to_date_label: "النقل إلى التاريخ",
        Change_spot_rate_dialog_header: "تغيير السعر الفوري",
        Change_spot_rate_label: "تغيير السعر الفوري",
        Change_commercial_dialog_header: "تغيير الإعلانات التجارية",
        Change_commercial_label: "تغيير التجاري",
        update_product_estimate_code_dialog_header: "تحديث رمز تقدير المنتج",
        update_button_text: "تحديث",
        update_all_button_text: "تحديث الكل",
        add_file_label: "إضافة ملف",
        import_file_label: "استيراد الملفات",
        file_name_column: "اسم الملف",
        message_column: "رسالة",
        file_upload_tooltip: "تحميل الملف",
        import_file_name_column: "استيراد اسم الملف",
        comment_load_data_label: "انقر فوق تحميل لتحميل البيانات",
        Program_label: "البرنامج",
        Select_program_booking_collection_header: "اختر برنامج الحجز",
        Export_report_dialog_header: "تصدير دليل البرامج الإلكتروني",
        import_template_dialog_heade: "استيراد القالب",
        Filters_label: "المرشحات",
        operator_label: "المشغل",
        operator_column: "عامل التشغيل",
        export_button_tooltip: "تصدير",
        Export_button_text: "تصدير",
        Export_playlist_button_tooltip: "تصدير قائمة التشغيل",
        export_and_sftp_playlist_button_tooltip: "تصدير وقائمة تشغيل سفتب",
        Export_playlist_button_text: "تصدير قائمة التشغيل",
        up_button_tooltip: "أعلى",
        down_button_tooltip: "لأسفل",
        export_template_editpageheader: "تصدير قالب دليل البرامج الإلكتروني",
        save_template_as_label: "حفظ القالب باسم",
        Module_name_label: "اسم الوحدة النمطية",
        Select_Columns_label: "الأعمدة المحددة",
        available_Column_label: "العمود المتاح",
        Display_name_label: "اسم العرض",
        add_blank_button_tooltip: "إضافة فارغ",
        add_blank_button_text: "إضافة فارغ",
        add_column_button_tooltip: "إضافة عمود",
        add_column_button_text: "إضافة عمود",
        available_Column: "العمود المتاح",
        Display_column: "اسم العرض",
        format_name_column: "التنسيق",
        id_label: "المعرف",
        source_label: "المصدر",
        section_position_label: "موضع المقطع",
        group_label: "المجموعة",
        Select_media_episode_collection_header: "اختر حلقة الوسائط",
        start_type_label: "نوع البدء",
        start_offset_label: "بدء الإزاحة",
        time_hh_mm_ss_ff_label: "سه:د:ثث:صص",
        Negative_label: "سلبي",
        end_type_label: "نوع النهاية",
        end_offset_label: "إزاحة النهاية",
        add_Secondary_event_button_toottip: "إضافة أحداث ثانوية",
        text_number_column: "رقم النص",
        prefix_column: "البادئة",
        Rule_column: "القاعدة",
        text_number_label: "رقم النص",
        prefix_label: "بادئة",
        Rule_label: "القاعدة",
        style_sheet_editpageheader: "ورقة الأنماط",
        add_prototype_button_tooltip: "إضافة نموذج أولي",
        id_column: "المعرف",
        protoType_source_column: "مصدر النموذج الأولي",
        group_column: "المجموعة",
        Select_prototype_collection_header: "حدد النموذج الأولي",
        default_prototype_editpageheader: "النموذج الأولي الافتراضي",
        create_Secondary_event_dynamic_rule_dialog_header: "إنشاء قاعدة ديناميكية لحدث ثانوي",
        Formula_label: "الصيغة",
        Secondary_event_overview_dialog_header: "نظرة عامة على الحدث الثانوي",
        start_type_column: "نوع البدء",
        start_offset_column: "بدء الإزاحة",
        end_type_column: "نوع النهاية",
        end_offset_column: "إزاحة النهاية",
        Confirm_button_text: "تأكيد",
        billing_period_label: "فترة الفاتورة",
        upto_label: "حتى",
        generator_bill_button_tooltip: "إنشاء فاتورة",
        generator_bill_button_text: "إنشاء فاتورة",
        Agency_column: "الوكالة",
        Client_column: "العميل",
        comission_column: "العمولة %",
        from_column: "من",
        to_column: "إلى",
        Total_budget_spot_column: "الأماكن المستهدفة",
        Total_booked_spot_column: "إجمالي الأماكن المحجوزة",
        Missing_spot_column: "المواقع المفقودة",
        reconciled_spots_column: "المواقع التوفيقية",
        generator_bill_Spots_column: "نقاط الفاتورة المُنشأة",
        contact_label: "اتصل",
        contact_info_label: "معلومات الاتصال",
        phone_label: "هاتف",
        address1_label: "العنوان1",
        address2_label: "العنوان2",
        Agency_info_label: "معلومات الوكالة",
        Spots_label: "البقع",
        amounts_label: "المبالغ",
        Total_booked_label: "إجمالي الحجز",
        Missing_label: "مفقود",
        generator_bill_label: "الفاتورة المُنشأة",
        Payment_recived_label: "تم استلام الدفعة",
        Due_amount_label: "المبلغ المستحق",
        Credit_balance_label: "رصيد الائتمان",
        Selected_campaign_info_label: "معلومات الحملة المحددة",
        book_label: "تم الحجز",
        Detail_for_selected_date_range_and_campaign_label: "تفاصيل النطاق الزمني والحملة المحددين",
        bill_denominating_dialog_header: "فئة الفاتورة",
        bill_period_label: "فترة الفاتورة",
        bill_campaign_brabd_label: "العلامات التجارية للحملة",
        Select_period_label: "اختر الفترة",
        show_button_tooltip: "إظهار",
        show_button_text: "إظهار",
        ideas_label: "التفاصيل",
        caption_column: "تسمية توضيحية",
        Spots_column: "البقع",
        tax_column: "الضريبة",
        Tax_label: "الضريبة",
        Tax_not_applicable_label: "الضريبة غير قابلة للتطبيق",
        Discount_amount_label: "مبلغ الخصم",
        bill_date_label: "تاريخ الفاتورة",
        bank_account_label: "الحساب البنكي",
        gros_total_label: "الإجمالي الإجمالي",
        Tax_amount_label: "مبلغ الضريبة",
        Commission_amount_label: "مبلغ العمولة",
        target_amount_label: "المبلغ المستهدف",
        bill_no_column: "رقم الفاتورة",
        Campaign_no_column: "رقم الحملة",
        bill_date_column: "تاريخ الفاتورة",
        period_from_column: "الفترة من",
        period_to_column: "الفترة إلى",
        validated_amount_column: "المبلغ المعتمد",
        Discount_percentage_column: "نسبة الخصم",
        Discount_amount_column: "مبلغ الخصم",
        Company_menu: "الشركة",
        logo_url_label: "عنوان يو آر إل للشعار",
        logo_width_label: "عرض الشعار",
        suffix_label: "لاحقة",
        next_number_label: "الرقم التالي",
        full_channel_name_label: "اسم القناة بالكامل",
        short_channel_name_label: "اسم القناة القصيرة",
        epg_code_label: "رمز دليل البرامج الإلكتروني",
        as_run_code_label: "كرمز تشغيل",
        Automation_channel_name_label: "اسم قناة الأتمتة",
        color_label: "اللون",
        automation_label: "الأتمتة",
        Repeat_pattern_details_dialog_header: "تفاصيل النموذج المتكرر",
        add_repeat_button_tooltip: "إضافة تكرار",
        create_repeat_pattern_editpage_header: "إنشاء نمط متكرر",
        create_variation_editpage_header: "إنشاء شكل مختلف",
        create_break_format_editpage_header: "إنشاء تنسيق فاصل",
        edit_variation_editpage_header: "تحرير التباين",
        edit_break_format_editpage_header: "تحرير تنسيق الفاصل",
        add_primary_pattern_button_tolltip: "إضافة أساسي",
        Primary_events_no_column: "رقم الأحداث الأساسية",
        Repeat_events_no_column: "لا تكرار الأحداث",
        nominal_start_column: "البداية الاسمية",
        Primary_events_no_label: "رقم الأحداث الأساسية",
        days_label: "أيام",
        times_label: "الأوقات",
        create_invoice_content_dialog_header: "إنشاء محتوى الفاتورة",
        number_length_label: "طول الرقم",
        label: "التسمية",
        sequence_label: "التسلسل",
        entity_name_label: "اسم الكيان",
        max_length_label: "الطول الأقصى",
        width_label: "العرض",
        require_label: "مطلوب",
        edit_label: "تحرير",
        Slot_time_column: "الفترة الزمنية",
        Please_generate_segment_to_load_media_label: "يرجى إنشاء مقطع لتحميل الوسائط!",
        filter_button_tooltip: "تصفية",
        search_content_dialog_header: "محتوى البحث",
        Clear_button_tooltip: "مسح",
        Clear_button_text: "مسح",
        search_button_tooltip: "بحث",
        search_button_text: "بحث",
        Select_preference_for_dialog_header: "حدد تفضيل العمود لـ",
        available_label: "متاح",
        Preference_label: "التفضيل",
        note_preference: "ملاحظة:-بالنسبة للأعمدة الافتراضية، اترك التفضيلات فارغة",
        house_number_label: "رقم المنزل",
        Category_type_label: "نوع الفئة",
        Slot_time_label: "الفترة الزمنية",
        actual_duration_label: "المدة الفعلية",
        nominal_duration_label: "المدة الاسمية",
        parts_label: "الشرائح",
        recursive_button_text: "العودي",
        recursive_dialog_header: "العودي",
        generator_button_toottip: "إنشاء",
        include_range_label: "نطاق التضمين",
        Episode_range_label: "نطاق الحلقات",
        example_label: "مثال",
        exclusion_range_label: "نطاق الاستبعاد",
        Except_days_label: "استبعاد الأيام",
        format_icon_tooltip: "التنسيق",
        no_segment_icon_tooltip: "لا يوجد مقطع",
        Contract_icon_tooltip: "العقد",
        Slot_duration_title_label: "مدة الفتحة",
        max_button_tooltip: "تكبير",
        Copy_Schedule_button_tooltip: "نسخ",
        Planing_preference_button_tooltip: "تفضيلات التخطيط",
        export_planning_button_tooltip: "تخطيط التصدير",
        Selected_label: "محدد",
        copied_label: "منسوخ",
        Select_channels_dialog_header: "تحديد القنوات",
        date_label: "التاريخ",
        Copy_Schedule_dialog_header: "نسخ الجدول",
        Copy_from_label: "نسخ من",
        Copy_to_label: "نسخ إلى",
        Selected_date_should_be_equal_error_message: "النطاق الزمني المحدد يجب أن يكون متساويًا",
        from_channel_label: "من القناة",
        to_channel_label: "إلى القناة",
        Activity_label: "النشاط",
        create_button_tootltip: "إنشاء",
        create_button_text: "إنشاء",
        Planing_preference_dialog_header: "تفضيلات التخطيط",
        events_label: "الأحداث",
        columns_label: "الأعمدة",
        General_label: "عام",
        note_select_the_events_you_want_to_change: "حدد الأحداث التي تريد تغييرها",
        events_type_lable: "نوع الأحداث",
        foreground_Color_label: "لون المقدمة",
        background_color_label: "لون الخلفية",
        available_columns_label: "الأعمدة المتاحة",
        view_type_label: "نوع العرض",
        show_format_label: "إظهار التنسيق",
        show_no_seg_label: "إظهار عدم وجود سيج",
        show_contract_label: "إظهار العقد",
        day_Start_time_label: "وقت بدء اليوم",
        prime_end_time_label: "وقت انتهاء الذروة",
        prime_Start_time_label: "وقت البدء الرئيسي",
        Episode_Column: "الحلقة",
        season_Column: "الموسم",
        versions_column: "الإصدارات",
        search_filter_dialog_header: "فلتر البحث",
        Release_year_label: "سنة الإصدار",
        is_live_label: "IsLive",
        save_as_template_label: "حفظ كقالب",
        show_search_options_media_liberary_tooltip: "إظهار خيارات البحث",
        place_holder_dialog_header: "حامل المكان",
        Please_choose_one_publishing_rights_collection_header: "يرجى اختيار حقوق نشر واحدة",
        export_excel_dialog_header: "تصدير اكسل",
        export_excel_button_tooltip: "تصدير اكسل",
        export_csv_button_tooltip: "تصدير ملف سي إس في",
        Export_excel_button_text: "تصدير اكسل",
        History_dialog_header: "التاريخ",
        Slot_date_column: "تاريخ الفتحة",
        Exhibition_no_column: "رقم المعرض",
        Repeat_no_column: "كرر لا",
        Planning_loaded_label_note: "تم تحميل التخطيط",
        Planning_loading_label_note: "جاري تحميل التخطيط....",
        time_column: "الوقت",
        Protypes_column: "النماذج الأولية",
        info_column: "معلومات",
        cut_button_tooltip: "قص",
        Paste_button_tooltip: "لصق",
        download_pdf_button_tooltip: "تنزيل ملف قوات الدفاع الشعبي",
        open_planning_button_tooltip: "التخطيط المفتوح",
        delete_all_footer_button_tooltip: "حذف كل التذييل",
        delete_All_Secondary_events_button_tooltip: "حذف كافة الأحداث الثانوية",
        global_replacement_button_tooltip: "الاستبدال العام",
        Apply_style_sheet_button_tooltip: "تطبيق ورقة الأنماط",
        Apply_button_tooltip: "تطبيق",
        Apply_button_text: "تطبيق",
        table_preference_button_tooltip: "تفضيلات الجدول الزمني",
        auto_save_button_tooltip: "حفظ تلقائي",
        Secondary_events_label: "الأحداث الثانوية",
        text_1_column: "النص 1",
        text_2_column: "النص 2",
        text_3_column: "النص 3",
        Protypes_label: "النماذج الأولية",
        Insert_break_actionbutton_menutext: "إدراج فاصل",
        delete_header_actionbutton_menutext: "حذف الرأس",
        Program_replacement_actionbutton_menutext: "استبدال البرنامج",
        Attach_format_reload_actionbutton_menutext: "تنسيق الإرفاق",
        History_actionbutton_menutext: "التاريخ",
        Select_program_to_replace_with_collection_title: "اختر برنامجًا لاستبداله",
        global_replacement_dialog_header: "الاستبدال العام",
        replace_button_tooltip: "استبدال",
        replace_button_text: "استبدال",
        replacement_method_label: "طريقة الاستبدال",
        include_isBreak_label: "تضمين الفاصل",
        replace_with_same_duration_only: "الاستبدال بنفس المدة فقط",
        Enable_cross_category_replacement: "تمكين الفئات المشتركة",
        replacement_material_label: "المواد البديلة",
        delete_all_button_tooltip: "حذف الكل",
        delete_all_button_text: "حذف الكل",
        group_all_button_tooltip: "حلقة وسائط المجموعة",
        group_all_button_text: "حلقة الوسائط الجماعية",
        Select_media_episode_dialoag_header: "اختر حلقة الوسائط",
        Select_media_episode_group_dialoag_header: "حدد مجموعة حلقات الوسائط",
        Remove_filter_actionbutton_menutext: "إزالة الفلتر",
        filter_actionbutton_menutext: "تصفية",
        Copy_actionbutton_menutext: "نسخ",
        Paste_actionbutton_menutext: "لصق",
        se_overview_actionbutton_menutext: "نظرة عامة على SE",
        global_replacement_actionbutton_menutext: "الاستبدال العام",
        sales_team_label: "فريق المبيعات",
        Department_label: "القسم",
        password_label: "كلمة المرور",
        phone_no_label: "رقم الهاتف",
        pobox_label: "صندوق بريد",
        Reporting_to_lable: "تقديم التقارير إلى",
        issalesexecutive_label: "هو مدير المبيعات",
        sales_executive_editpageheader: "مسؤول مبيعات",
        email_column: "البريد الإلكتروني",
        phone_no_column: "رقم الهاتف",
        Select_sales_executive_colllection_header: "اختر مسؤول المبيعات",
        Select_collection_button_text: "اختر",
        export_planet_cast_button_tooltip: "تصدير كوكب الزهر",
        check_list_button_tooltip: "قوائم التحقق",
        check_lists_dialog_header: "قوائم التحقق",
        Success_label: "نجاح",
        Fail_lable: "فشل",
        Module_menu: "الوحدة النمطية",
        sales_team_dailog_header: "إنشاء فريق مبيعات",
        Module_dialog_header: "الوحدة النمطية",
        role_dialog_header: "الدور",
        admin_label: "المسؤول",
        sales_label: "المبيعات",
        media_management_label: "إدارة الوسائط",
        rights_manager_label: "مدير الحقوق",
        role_editpageheader: "الدور",
        Select_module_collection_header: "حدد الوحدة",
        users_editpage_header: "المستخدم",
        Select_Role_collection_header: "حدد الدور",
        Module_column: "الوحدة النمطية",
        role_column: "الدور",
        add_role_collection_text: "إضافة دور",
        add_role_button_text: "إضافة من الدور",
        add_module_collection_text: "إضافة وحدة",
        sales_executive_editpage_header: "مدير مبيعات",
        timeline_page_breadcrumb: "الخط الزمني",
        Assets_type_page_breadcrumb: "نوع الأصول",
        Rails_type_page_breadcrumb: "نوع القضبان",
        Posters_type_page_breadcrumb: "نوع الملصقات",
        Department_page_breadcrumb: "القسم",
        users_page_breadcrumb: "المستخدمون",
        role_page_breadcrumb: "الدور",
        Assets_page_breadcrumb: "الأصول",
        Posters_page_breadcrumb: "الملصقات",
        client_page_breadcrumb: "العميل",
        Agency_page_breadcrumb: "الوكالة",
        sales_team_page_breadcrumb: "فريق المبيعات",
        Trailer_page_breadcrumb: "مقطورة",
        sales_executive_page_breadcrumb: "مسؤول مبيعات",
        content_page_breadcrumb: "المحتوى",
        channel_page_breadcrumb: "القناة",
        currency_page_breadcrumb: "العملة",
        Repeat_pattern_page_breadcrumb: "نمط التكرار",
        bill_content_page_breadcrumb: "محتوى الفاتورة",
        section_type_page_breadcrumb: "نوع المقطع",
        Contract_page_breadcrumb: "عقد",
        series_page_breadcrumb: "السلسلة الأصلية",
        season_page_breadcrumb: "سلسلة",
        Programs_page_breadcrumb: "البرامج",
        Episode_page_breadcrumb: "الحلقة",
        movie_page_breadcrumb: "أفلام",
        interstitial_page_breadcrumb: "إعلان بيني",
        Commercial_page_breadcrumb: "تجاري",
        music_page_breadcrumb: "موسيقى",
        filler_page_breadcrumb: "حشو",
        Break_page_breadcrumb: "استراحة",
        group_page_breadcrumb: "المجموعة",
        Program_group_page_breadcrumb: "مجموعة البرامج",
        interstital_group_page_breadcrumb: "المجموعة البينية",
        table_constraints_page_breadcrumb: "قيود الجدول الزمني",
        Campaign_page_breadcrumb: "الحملة",
        utilisied_label: "مُستفاد",
        over_booked_label: "محجوز أكثر من اللازم",
        counts_label: "التهم",
        active_label: "نشط",
        top_10_agency_label: "أفضل 10 وكالات",
        top_10_client_label: "أفضل 10 عملاء",
        hanging_vs_on_air_booking_label: "معلق مقابل على إير بوكينج",
        Revenue_by_location_label: "الإيرادات حسب الموقع",
        Revenue_by_months_label: "الإيرادات حسب الأشهر",
        booking_by_deal_type_label: "الحجز حسب نوع الصفقة",
        time_range_label: "النطاق الزمني",
        language_page_breadcrumb: "اللغة",
        Region_page_breadcrumb: "المنطقة",
        Brand_page_breadcrumb: "العلامة التجارية",
        Product_page_breadcrumb: "المنتج",
        Rails_page_breadcrumb: "القضبان",
        page_breadcrumb: "الصفحات",
        content_caegory_page_breadcrumb: "فئة المحتوى",
        ingestion_page_breadcrumb: "الابتلاع",
        jobs_page_breadcrumb: "الوظائف",
        Prototype_page_breadcrumb: "النموذج الأولي",
        Prototype_style_sheet_page_breadcrumb: "ورقة أنماط النموذج الأولي",
        default_prototype_style_sheet_page_breadcrumb: "ورقة أنماط النموذج الأولي الافتراضية",
        Prototype_source_page_breadcrumb: "مصدر النموذج الأولي",
        Export_template_page_breadcrumb: "تصدير القالب",
        form_fields_page_breadcrumb: "حقول النموذج",
        Secondary_event_dynamic_rule_page_breadcrumb: "قاعدة ديناميكية للحدث الثانوي",
        format_page_breadcrumb: "التنسيق",
        time_range_page_breadcrumb: "النطاق الزمني",
        Company_page_breadcrumb: "الشركة",
        bank_account_page_breadcrumb: "الحساب البنكي",
        Tax_page_breadcrumb: "الضريبة",
        licensor_page_breadcrumb: "المرخص",
        delete_successously_grid_data_success_toast_message: "تم الحذف بنجاح",
        delete_all_successously_grid_data_success_toast_message: "تم حذف الكل بنجاح",
        Please_select_first_contract_collection_error_message: "يرجى التحديد أولاً!!",
        Please_enter_contarct_number_contract_error_message: "الرجاء إدخال رقم العقد",
        Please_select_platform_type_error_message: "الرجاء تحديد نوع النظام الأساسي",
        Please_select_license_error_message: "الرجاء تحديد المرخص",
        Please_select_payee_error_message: "الرجاء تحديد المدفوع لأمره",
        Please_select_platform_error_message: "الرجاء تحديد النظام الأساسي",
        Please_select_channel_error_message: "الرجاء تحديد القناة",
        Please_select_region_error_message: "الرجاء تحديد المنطقة",
        Please_select_content_error_message: "الرجاء تحديد المحتوى",
        Please_select_play_time_error_message: "الرجاء تحديد وقت التشغيل",
        Please_select_media_category_type_error_message: "الرجاء تحديد نوع فئة الوسائط",
        Please_select_genres_media_episode_error_message: "الرجاء تحديد الأنواع",
        Please_select_department_error_message: "يرجى تحديد القسم",
        Please_enter_title_error_message: "الرجاء إدخال العنوان",
        Please_enter_description_error_message: "الرجاء إدخال الوصف",
        Please_enter_name_error_message: "الرجاء إدخال الاسم",
        Please_enter_phone_no_error_message: "الرجاء إدخال رقم الهاتف",
        Please_enter_email_error_message: "الرجاء إدخال بريد إلكتروني صالح",
        Please_select_roletype_error_message: "الرجاء تحديد نوع الدور",
        Please_enter_user_name_users_error_message: "الرجاء إدخال اسم المستخدم",
        Please_enter_password_users_error_message: "الرجاء إدخال كلمة المرور",
        valid_duration_error_message: "الرجاء إدخال مدة صالحة",
        Please_attach_atleast_one_media_episode_group_error_message: "الرجاء إرفاق وسائط واحدة على الأقل",
        Please_add_atleast_one_module_rights_users_error_message: "الرجاء إضافة حقوق وحدة واحدة على الأقل",
        Please_select_reportingto_user_error_message: "الرجاء تحديد الإبلاغ إلى",
        Please_select_sales_team_error_message: "الرجاء تحديد فريق المبيعات",
        Exhibition_should_not_be_zero_error_message: "يجب أن يكون المعرض أكبر من الصفر",
        Repeat_should_not_be_zero_error_message: "يجب أن يكون التكرار أكبر من الصفر",
        play_time_number_should_not_be_zero_error_message: "يجب أن يكون رقم وقت التشغيل أكبر من الصفر",
        end_date_should_be_greater_than_start_date_error_message: "يجب أن يكون تاريخ الانتهاء أكبر من تاريخ البدء",
        Please_attach_atleast_one_media_contract_error_message: "الرجاء إرفاق وسائط واحدة على الأقل",
        Please_select_season_content_series_error_message: "الرجاء تحديد محتوى الموسم",
        value_is_not_greater_then_zero_season_number_series_error_message: "يجب أن يكون رقم الموسم أكبر من الصفر",
        Please_select_epiosde_content_series_error_message: "الرجاء تحديد محتوى الحلقة",
        value_is_not_greater_then_zero_episode_number_series_error_message: "يجب أن يكون رقم الحلقة أكبر من الصفر",
        Please_attach_series_season_error_message: "الرجاء إرفاق السلسلة",
        Please_add_atleast_one_season_series_error_message: "الرجاء إضافة موسم واحد على الأقل",
        enter_same_season_number_twice_series_error_message: "إدخال رقم الموسم نفسه مرتين",
        enter_title_expender: "أدخل العنوان",
        Please_select_poster_type_first_media_episode_poster_error_message: "الرجاء تحديد نوع الملصق",
        Please_select_url_first_media_episode_poster_error_message: "الرجاء تحديد عنوان يو آر إل أولاً",
        Please_select_the_value_in_start_date_media_episode_publishing_error_message: "الرجاء تحديد القيمة في تاريخ البدء",
        Please_select_the_value_in_end_date_media_episode_publishing_error_message: "الرجاء تحديد القيمة في تاريخ الانتهاء",
        you_delete_this_deal_right_from_contract_only_media_episode_publishing_error_message: "أنت تحذف هذه الصفقة مباشرة من العقد فقط!!",
        Please_select_ottvideo_type_media_episode_video_error_message: "الرجاء تحديد نوع الفيديو",
        create_dialog_header: "إنشاء",
        Synopsis_can_not_be_null_media_episode_Synopsis_error_message: "لا يمكن أن يكون الملخص خاليًا",
        Please_select_language_media_episode_Synopsis_error_message: "الرجاء تحديد اللغة",
        Please_enter_name_cast_crew_media_episode_error_message: "الرجاء إدخال الاسم",
        Please_select_casttype_cast_crew_media_episode_error_message: "الرجاء إدخال نوع الإرسال",
        Please_select_segment_type_media_episode_version_error_message: "الرجاء تحديد نوع المقطع",
        Please_generate_segments_first_media_episode_version_error_message: "الرجاء إنشاء المقاطع",
        media_episode_entity_duration_segment_error_message: "المدة الفعلية فارغة. يرجى تحديث المدة الصالحة في مدة تطبيق التقسيم",
        Please_select_brand_media_episode_error_message: "يرجى تحديد العلامة التجارية",
        Please_select_product_media_episode_error_message: "يرجى تحديد المنتج",
        Please_enter_value_media_episode_error_message: "الرجاء إدخال القيمة",
        Please_enter_valid_value_tcin_should_not_be_greater_than_tcout_media_episode_error_message: "الرجاء إدخال قيمة صالحة، يجب ألا يكون ح فيأكبر من ح خارج",
        error_while_geneating_house_number_media_episode_error_message: "حدث خطأ أثناء إنشاء رقم المنزل",
        already_exists_global_error_message: "موجود بالفعل!!",
        you_can_update_this_deal_right_from_contract_only_media_episode_publishing_error_message: "يمكنك تحديث هذه الصفقة مباشرة من العقد فقط !!",
        this_segment_is_already_been_scheduled_segmnet_media_episode_error_message: "تمت جدولة هذا المقطع بالفعل",
        Please_enter_title_display_rails_error_message: "الرجاء إدخال عرض العنوان",
        atleast_attach_one_ottassets_rails_error_message: "على الأقل قم بإرفاق OttAssets واحدة",
        Please_enter_enter_icon_uel_error_message: "الرجاء إدخال عنوان يو آر إل للرمز",
        create_label: "إنشاء",
        Edit_lable: "تحرير",
        Select_label: "اختر",
        Please_select_media_category_type_first_media_episode_group_error_message: "يرجى تحديد نوع فئة الوسائط أولاً",
        Please_select_role_users_error_message: "الرجاء تحديد الدور",
        user_name_error_message: "المستخدم/مسؤول المبيعات بنفس اسم المستخدم",
        no_data_found_scheduling_reconciliation_error_message: "لم يتم العثور على بيانات!",
        schedul_and_as_run_data_load_successously_scheduling_reconciliation_success_message: "تم تحميل بيانات الجدولة وAsRun بنجاح",
        error_while_loading_as_run_data_scheduling_reconciliation_error_message: "حدث خطأ أثناء تحميل بيانات كما تشغيل:",
        auto_recocile_successously_scheduling_reconciliation_success_message: "تمت التسوية التلقائية بنجاح!!",
        Select_first_scheduling_reconciliation_error_message: "الرجاء تحديد الجدول وتشغيل العنصر للمطابقة!",
        already_reconsiled_scheduling_reconciliation_error_message: "تمت التسوية بالفعل!",
        Select_item_have_different_assetid_scheduling_reconciliation_error_message: "العنصر المحدد له معرف أصل مختلف!",
        force_unmatch_successously_scheduling_reconciliation_success_message: "تم فرض القوة غير المتطابقة بنجاح!!",
        Please_select_schedule_and_as_run_item_scheduling_reconciliation_error_message: "الرجاء تحديد الجدول الزمني وعنصر كما تشغيل!",
        Select_item_is_not_reconsiled_scheduling_reconciliation_error_message: "لم تتم تسوية العنصر المحدد!",
        Select_schedule_and_asrun_item_not_reconciled_together_scheduling_reconciliation_error_message: "لم يتم التوفيق بين الجدول المحدد وعنصر التشغيل معًا",
        Select_schedule_item_already_billed_error_message: "تم إصدار فاتورة لعنصر الجدول المحدد بالفعل.",
        save_successously_scheduling_reconciliation_success_message: "تم الحفظ بنجاح !!!",
        role_type_label: "نوع الدور",
        Please_load_first_scheduling_reconciliation_error_message: "يرجى التحميل أولاً!!",
        tx_mode_label: "وضع تكساس",
        section_count_label: "عدد المقاطع",
        create_segment_type_dialog_header: "إنشاء نوع المقطع",
        Please_enter_type_name_segment_type_error_message: "الرجاء إدخال اسم النوع",
        Please_select_tx_mode_segment_type_error_message: "الرجاء تحديد وضع تكساس",
        Please_enter_segment_count_segment_type_error_message: "الرجاء إدخال عدد المقاطع",
        interstitial_group_sub_menu: "المجموعة البينية",
        Program_group_sub_menu: "مجموعة البرامج",
        variation_page_breadcrumb: "التنوع",
        Breakformat_page_breadcrumb: "تنسيق الفاصل",
        Payment_provider_page_breadcrumb: "موفر الدفع",
        ott_period_type_page_breadcrumb: "نوع فترة أوت",
        Payment_type_page_breadcrumb: "نوع الدفع",
        ott_period_page_breadcrumb: "الفترة",
        subscriber_page_breadcrumb: "مشترك",
        media_type_label: "نوع الوسائط",
        atleast_attach_one_item_variation_error_message: "إرفاق عنصر واحد على الأقل",
        Please_select_media_type_error_message: "الرجاء تحديد نوع الوسائط",
        season_number_should_not_be_zero_error_message: "يجب أن يكون رقم الموسم أكبر من الصفر",
        number_of_epiosde_should_not_be_zero_error_message: "يجب أن يكون عدد الحلقات أكبر من الصفر",
        start_epiosde_should_not_be_zero_error_message: "يجب أن تكون بداية الحلقة أكبر من الصفر",
        Please_select_potraitimageurl_otteditform_error_message: "يرجى تحديد عنوان يو آر إل للصورة الشخصية",
        Please_select_landscapeimageurl_otteditform_error_message: "الرجاء تحديد عنوان يو آر إل للصورة الطبيعية",
        include_pre_opening_label: "تضمين الافتتاح المسبق",
        include_closing_label: "تضمين الإغلاق",
        Break_number_column: "رقم الفاصل",
        Break_duration_column: "مدة الاستراحة",
        Commercial_duration_column: "المدة التجارية",
        promo_duration_Column: "مدة العرض الترويجي",
        Total_break_duration_label: "إجمالي مدة الاستراحة",
        section_count_should_be_zero_error_message: "يجب أن يكون عدد المقاطع أكبر من واحد",
        valid_slot_duration_error_message: "مدة الفترة الزمنية غير صالحة",
        valid_total_break_duration_error_message: "إجمالي مدة الاستراحة غير صالح",
        break_not_distribute_breakformat_error_message: "لم يتم توزيع الفواصل",
        Slot_duration_should_Be_greater_than_total_break_duration_breakformat_error_message: "يجب أن تكون مدة الفاصل الزمني أكبر من إجمالي مدة الاستراحة",
        break_count_segment_count_does_not_match_breakformat_error_message: "عدد الفواصل وعدد المقاطع غير متطابقين",
        Please_enter_template_name_error_toast: "الرجاء إدخال اسم القالب",
        Please_select_module_type_error_message: "الرجاء تحديد نوع الوحدة",
        Please_select_ingestion_template_type_error_message: "يُرجى تحديد نوع قالب العرض",
        save_successful_message: "تم الحفظ بنجاح",
        Please_enter_code_error_message: "الرجاء إدخال الرمز",
        Please_select_agency_error_message: "الرجاء تحديد الوكالة",
        Please_select_default_tax_error_message: "الرجاء تحديد الضريبة الافتراضية",
        Please_select_agency_type_error_message: "يرجى تحديد نوع الوكالة",
        please_select_atleast_one_Sales_executive: "يُرجى تحديد مسؤول مبيعات واحد على الأقل",
        add_sales_executive_button_tooltip: "إضافة مدير مبيعات",
        Please_enter_prefix_error_message: "الرجاء إدخال البادئة",
        Please_enter_suffix_error_message: "الرجاء إدخال اللاحقة",
        Please_attach_atleast_one_media_error_message: "يُرجى إرفاق وسائط واحدة على الأقل",
        Please_enter_full_Channel_name_error_message: "الرجاء إدخال اسم القناة بالكامل",
        Please_enter_short_Channel_name_error_message: "الرجاء إدخال اسم القناة المختصرة",
        Please_select_atleast_one_repeat_pattern_error_message: "يرجى تحديد تكرار واحد على الأقل!",
        Primary_delete_succesously_repeat_pattern_error_message: "تم الحذف الأساسي بنجاح",
        Repeat_delete_succesously_repeat_pattern_error_message: "كرر الحذف بنجاح",
        Please_select_atleast_one_days_repeat_pattern_error_message: "يرجى تحديد يوم واحد على الأقل!",
        Please_enter_automation_channel_name_error_message: "الرجاء إدخال اسم قناة الأتمتة",
        Please_enter_epg_code_error_message: "الرجاء إدخال رمز دليل البرامج الإلكتروني",
        Please_select_automation_error_message: "الرجاء تحديد الأتمتة",
        Please_enter_color_error_message: "الرجاء إدخال اللون",
        Please_add_atleast_one_module_role_error_message: "الرجاء إضافة وحدة واحدة على الأقل!",
        data_loaded_successously_ingestion_template_message: "تم تحميل البيانات بنجاح",
        Please_enter_positive_value_in_creditlimit_error_message: "الرجاء إدخال قيمة موجبة في حد الائتمان",
        Please_enter_gst_no_error_message: "الرجاء إدخال رقم ضريبة السلع والخدمات",
        Please_enter_campaign_no_error_message: "الرجاء إدخال رقم الحملة",
        Please_select_client_error_message: "الرجاء تحديد العميل",
        period_from_should_be_less_then_periodto_campaign_error_message: "يجب أن تكون الفترة من أقل من الفترة إلى",
        Commission_exceeded_from_limit_campaign_error_message: "العمولة تجاوزت الحد الأقصى.",
        Discount_exceeded_from_limit_campaign_error_message: "تم تجاوز الخصم عن الحد الأقصى.",
        Please_enter_target_budget_error_message: "الرجاء إدخال الميزانية المستهدفة",
        Please_enter_target_spots_error_message: "الرجاء إدخال المواقع المستهدفة",
        Please_enter_target_thans_error_message: "الرجاء إدخال الثواني المستهدفة",
        Please_attach_atleast_one_commercials_campaign_error_message: "الرجاء إرفاق إعلان تجاري واحد على الأقل",
        Please_attach_atleast_one_channel_campaign_error_message: "يُرجى إرفاق قناة واحدة على الأقل",
        Please_select_campaign_type_error_message: "يرجى تحديد نوع الحملة",
        Please_enter_rate10sec_error_message: "الرجاء تحديد معدل 10 ثواني",
        Please_enter_fct_error_message: "الرجاء إدخال واو سي تي",
        Please_enter_from_date_error_message: "الرجاء الدخول من التاريخ",
        Please_enter_to_date_error_message: "الرجاء إدخال التاريخ",
        Please_enter_amount_error_message: "الرجاء إدخال المبلغ",
        data_loading_error_message: "جاري تحميل البيانات...",
        no_record_found_error_message: "لم يتم العثور على سجل!",
        Total_sum_spot_rate_success_message: "إجمالي السعر الفوري",
        Total_fct_success_message: "إجمالي واو سي تي",
        booking_is_used_in_schedule_show_spot_error_message: "يتم استخدام الحجز في الجدول الزمني",
        Change_Will_Reflect_in_new_planned_items_only_segmenttype_error_message: "ستنعكس التغييرات في العناصر المخططة الجديدة فقط",
        Please_select_campaign_first_booking_error_message: "يُرجى تحديد الحملة أولاً",
        error_reading_file_booking_error_message: "خطأ في قراءة الملف",
        error_month_selected_booking_error_message: "تم تحديد شهر خاطئ",
        error_year_selected_booking_error_message: "تم تحديد السنة بشكل خاطئ",
        error_downloading_template_booking_error_message: "حدث خطأ أثناء تنزيل القالب",
        Please_select_a_value_to_update_booking_error_message: "الرجاء تحديد قيمة لتحديثها",
        exceding_target_spots_limit_booking_error_message: "تجاوز حد النقاط المستهدفة",
        exceding_target_budget_booking_error_message: "تجاوز الميزانية المستهدفة",
        Commercials_not_updated_in_line_no_booking_error_message: "الإعلانات التجارية لم يتم تحديثها في السطر رقم",
        exceding_target_thans_booking_error_message: "تجاوز الثواني المستهدفة",
        booking_saved_booking_error_message: "تم حفظ الحجز",
        no_data_found_booking_error_message: "لم يتم العثور على بيانات",
        from_time_should_be_less_than_To_time_booking_error_message: "من الوقت يجب أن يكون أقل من إلى الوقت",
        Please_enter_spot_booking_error_message: "الرجاء إدخال المكان",
        Please_enter_rate_booking_error_message: "الرجاء إدخال السعر",
        Please_select_transfer_from_date_booking_transfer_error_message: "يرجى تحديد النقل من التاريخ",
        Please_select_transfer_date_booking_transfer_error_message: "يرجى تحديد تاريخ النقل",
        Please_select_item_booking_transfer_error_message: "الرجاء تحديد العنصر أولاً!",
        booking_transfer_succesously_to_booking_transfer_error_message: "تم نقل الحجز بنجاح إلى",
        exceding_target_spots_limit_update_booking_line_number_error_message: "تجاوز حد النقاط المستهدفة",
        exceding_target_budget_update_booking_line_number_error_message: "تجاوز الميزانية المستهدفة",
        exceding_target_thans_update_booking_line_number_error_message: "تجاوز الثواني المستهدفة",
        Loading_data_update_booking_line_number_error_message: "جارٍ تحميل البيانات!!",
        data_loaded_update_booking_line_number_success_message: "تم تحميل البيانات بنجاح!!",
        Loading_booking_update_booking_line_number_success_message: "جارٍ تحميل الحجز...",
        bill_is_already_generated_for_this_linenumber_update_booking_line_number_success_message: "تم إنشاء الفاتورة بالفعل لرقم الخط هذا!!",
        Please_select_file_error_message: "الرجاء تحديد الملف",
        download_file_error_message: "تنزيل الملف",
        no_import_type_defense_error_message: "لم يتم تحديد نوع الاستيراد",
        upload_Successously_import_success_message: "تم التحميل بنجاح",
        asrun_Save_Successously_import_success_message: "تم حفظ كما تشغيل بنجاح",
        asrun_save_failed_import_error_message: "فشل حفظ كما تشغيل",
        update_failed_import_error_message: "فشل التحميل",
        assest_not_found_import_message: "لم يتم العثور على المساعدة",
        Planning_imported_successously_import_message: "تم استيراد التخطيط بنجاح",
        import_planning_failed_import_message: "فشل تخطيط الاستيراد",
        read_to_upload_import_message: "القراءة للتحميل",
        Please_select_from_date: "يرجى التحديد من التاريخ",
        Please_select_to_date_greater_than_from_date_error_message: "يُرجى تحديد تاريخ أكبر من تاريخ",
        Please_select_the_value_in_template_name_first_export_report_error_message: "يرجى تحديد القيمة في اسم القالب أولاً!",
        Please_select_the_value_in_format_first_export_report_error_message: "يرجى تحديد القيمة بالتنسيق أولاً",
        Please_add_at_least_one_item_list_export_report_error_message: "الرجاء إضافة قائمة عناصر واحدة على الأقل.",
        Please_select_the_value_in_filters_first_export_report_error_message: "يرجى تحديد القيمة في المرشحات أولاً.",
        Please_select_the_value_in_Operator_first_export_report_error_message: "يرجى تحديد القيمة في المشغل أولاً.",
        value_can_not_be_null_export_report_error_message: "لا يمكن أن تكون القيمة فارغة",
        report_is_exported_successously_message: "تم تصدير دليل البرامج الإلكتروني بنجاح",
        content_report_is_exported_successously_message: "تم تصدير التقرير بنجاح",
        Please_select_valid_dates_export_template_error_message: "يرجى تحديد تواريخ صالحة",
        exporting_data_please_wait_export_template_error_message: "جاري تصدير البيانات، يرجى الانتظار....",
        Success_exported_export_template_message: "تم التصدير بنجاح",
        no_data_found_to_export_template_message: "لم يتم العثور على بيانات للتصدير",
        Please_select_the_value_in_available_column_export_template_error_message: "يرجى تحديد القيمة في العمود المتاح",
        Please_enter_display_name_error_message: "الرجاء إدخال اسم العرض",
        Please_enter_savetempleteas_export_template_error_message: "الرجاء إدخال حفظ تيمبليتي باسم",
        Please_add_column_atleast_one_item_export_template_error_message: "الرجاء إضافة عمود واحد على الأقل",
        is_saved_successously_export_template_message: "تم حفظه بنجاح",
        Please_select_module_error_message: "الرجاء تحديد الوحدة النمطية",
        Please_enter_id_error_message: "الرجاء إدخال المعرف",
        Please_select_source_error_message: "الرجاء تحديد المصدر",
        Please_select_atleast_one_Secondary_events_error_message: "يُرجى تحديد حدث ثانوي واحد على الأقل",
        valid_startoffset_error_message: "إزاحة البداية غير صالحة",
        valid_endoffset_error_message: "إزاحة نهاية غير صالحة",
        Please_enter_text_no_error_message: "الرجاء إدخال رقم النص",
        Please_select_the_value_in_rule_first_error_message: "الرجاء تحديد القيمة في القاعدة أولاً",
        Please_attach_atleast_one_prototype_stylesheet_error_message: "الرجاء إرفاق نموذج أولي واحد على الأقل",
        Please_enter_formula_error_message: "الرجاء إدخال الصيغة",
        Please_wait_loading_data_billing_error_message: "الرجاء الانتظار، جارٍ تحميل البيانات...",
        data_loaded_successously_billing_template_message: "تم تحميل البيانات بنجاح",
        Please_select_a_billing_detail_first_billing_template_message: "يرجى تحديد تفاصيل الفوترة أولاً!",
        no_reconciled_spots_found_for_selected_details_billing_template_message: "لم يتم العثور على نقاط تمت تسويتها للتفاصيل المحددة!",
        Please_select_bank_billing_error_message: "الرجاء تحديد البنك!",
        Please_select_tax_billing_error_message: "الرجاء تحديد الضريبة!",
        Please_select_brand_billing_error_message: "الرجاء تحديد العلامة التجارية!",
        no_invoice_details_are_available_to_bill_billing_error_message: "لا توجد تفاصيل فاتورة متاحة للفاتورة!",
        Campaign_brands_label: "العلامة التجارية",
        all_label: "الكل",
        Selected_brand: "العلامة التجارية المختارة",
        Selected_channel: "القناة المحددة",
        Brand_label: "العلامة التجارية",
        Please_select_file_first_datamigration_error_message: "يرجى تحديد الملف أولاً !!!",
        empty_media_grid_datamigration_error_message: "يرجى تحميل البيانات في الشبكة أدناه للاستيراد !!",
        Please_select_type_datamigration_error_message: "يرجى تحديد النوع!!",
        import_successously_datamigration_success_message: "تم الاستيراد بنجاح",
        Please_select_language_error_message: "الرجاء تحديد اللغة",
        Please_select_logo_url_first_error_mesage: "يرجى تحديد عنوان يو آر إل الخاص بالشعار أولاً.",
        Please_select_segment_type_and_channel_format_error_message: "يرجى تحديد نوع المقطع والقناة",
        new_create_formfield_dialog_header: "إنشاء جديد",
        Please_select_segment_type_format_error_message: "الرجاء تحديد نوع المقطع",
        not_allowed_for_segments_format_error_message: "غير مسموح به للمقاطع",
        cannot_delete_segments_format_error_message: "لا يمكن حذف المقطع",
        Select_atleast_one_mediaDealRight_planner_error_message: "حدد صفقة وسائط واحدة على الأقل بشكل صحيح",
        first_copy_planner_items_you_want_to_paste_planner_error_message: "انسخ عناصر المخطط أولاً التي تريد لصقها.",
        Please_select_area_on_planner_where_to_paste_planner_error_message: "يرجى تحديد منطقة في المخطط للصقها.",
        from_date_cant_be_greater_than_to_date_paste_planner_error_message: "من التاريخ لا يمكن أن يكون أكبر من حتى الآن!",
        call_planner_error_message: "اتصال",
        data_copy_schedule_please_wait_copyschedule_error_message: "جارٍ التحقق من صحة جدول النسخ، يرجى الانتظار....",
        Copy_schedule_data_copyschedule_successously_message: "نسخ بيانات الجدول الزمني بنجاح....",
        no_data_found_to_copy_schedule_error_message: "لم يتم العثور على بيانات لنسخ الجدول",
        Apply_recursive_pattern_please_wait_planner_error_message: "جاري تطبيق النمط العودي، الرجاء الانتظار...",
        recursive_pattern_applied_successously_planner_success_message: "تم تطبيق النمط العودي بنجاح",
        Pasted_pattern_planner_error_message: "تم اللصق",
        items_pattern_planner_error_message: "العناصر",
        to_date_is_mandatory_recursive_error_message: "حتى الآن إلزامي",
        to_date_should_be_greater_than_base_program_start_date_recursive_error_message: "يجب أن يكون حتى التاريخ أكبر من تاريخ بدء البرنامج الأساسي",
        Select_one_item_to_open_schedule_planner_helper_error_message: "حدد عنصرًا واحدًا لفتح الجدول الزمني",
        Copy_button_text: "نسخ",
        open_schedule_button_text: "فتح الجدول",
        Paste_button_text: "لصق",
        delete_button_text: "حذف",
        error_fetching_channel_list_planning_wrapper_error_message: "حدث خطأ أثناء جلب قائمة القنوات",
        Please_select_planning_item_planning_wrapper_error_message: "الرجاء تحديد عنصر التخطيط",
        recursive_applied_successously_planning_wrapper_message: "تم تطبيق العودية بنجاح!!",
        Select_program_group_label: "حدد مجموعة البرامج",
        Select_break_format__label: "حدد تنسيق الفاصل",
        Please_enter_template_name_to_save_template_planningfilter_error_message: "الرجاء إدخال اسم القالب لحفظ القالب",
        Selected_content_text_planning_footer: "المحتوى المحدد",
        copied_content_text_planning_footer: "المحتوى المنسوخ",
        first_copy_planner_items_you_want_to_paste_planning_performance_error_message: "انسخ أولاً عناصر المخطط التي تريد لصقها.",
        Please_select_area_on_planner_where_to_paste_planning_performance_error_message: "يرجى تحديد منطقة في المخطط للصقها.",
        Select_atleast_one_mediadealright_planning_performance_error_message: "حدد صفقة واحدة صحيحة على الأقل",
        first_select_replace_items_global_replacement_error_message: "حدد أولاً استبدال العناصر",
        Please_select_content_to_delete_planning_performance_error_message: "الرجاء تحديد المحتوى المراد حذفه",
        not_allowed_Control_with_schedule_planning_performance_error_message: "غير مسموح به، التحكم بالجدول الزمني",
        Entry_already_exist_try_with_different_values_collection_error_message: "الإدخال موجود بالفعل، حاول باستخدام قيم مختلفة.",
        Please_select_first_collection_error_message: "يرجى التحديد أولاً!",
        already_attached_collection_error_message: "مرفق بالفعل !!",
        export_current_booking_tooltip: "تصدير الحجز الحالي",
        Export_saved_booking_tooltip: "تصدير الحجز المحفوظ",
        Please_select_poster_type_error_message: "الرجاء تحديد نوع الملصق",
        browser_button_text: "تصفح",
        file_selected_label: "تم تحديد الملف",
        Only_jpg_jpeg_and_png_files_are_allowed_msg: "يسمح فقط بملفات jpg/jpeg وpng!",
        Please_add_programs_format_error_message: "الرجاء إضافة تنسيق البرامج",
        Please_select_atleast_one_item: "يرجى تحديد عنصر واحد على الأقل.",
        Please_enter_season_number_error_message: "الرجاء إدخال رقم الموسم",
        Repeat_pattern_label: "نمط متكرر",
        Select_repeat_pattern_collection_header: "حدد نمط التكرار",
        Please_select_from_date_error_message: "الرجاء الاختيار من التاريخ",
        Please_select_to_date_error_message: "يرجى التحديد حتى الآن",
        Please_select_to_date_grater_then_from_date_error_message: "يُرجى تحديد تاريخ أكبر من تاريخ",
        parent_content_category_label: "فئة المحتوى الأصلي",
        Rail_will_be_added_soon2_label: "ستتم إضافة السكك الحديدية قريبًا 2!",
        Rail_will_be_added_soon3_label: "ستتم إضافة السكك الحديدية قريبًا3!",
        no_select_image_error_message: "لا يوجد تحديد صورة",
        Please_enter_key_error_message: "الرجاء إدخال المفتاح",
        Please_enter_value_error_message: "الرجاء إدخال القيمة",
        Please_wait_geneating_bill: "إنشاء الفاتورة. انتظر من فضلك...",
        bill_generated_successously: "تم إنشاء الفاتورة بنجاح",
        Please_select_template_error_message: "الرجاء تحديد القالب",
        Please_select_file_first_error_message: "الرجاء تحديد الملف أولاً!",
        Please_enter_first_error_message: "الرجاء إدخال أولا!",
        Please_select_channel_first: "يُرجى تحديد القناة أولاً",
        Please_select_start_date_error_message: "الرجاء تحديد تاريخ البدء",
        Please_select_end_date_error_message: "الرجاء تحديد تاريخ الانتهاء",
        Please_enter_valid_sequnce_number_error_message: "الرجاء إدخال رقم تسلسل صالح",
        Program_schedule_clash_breadcrumb: "تعارض جدول البرنامج",
        Clash_channel_column: "قناة Clash",
        Claced_time_Column: "وقت الصدام",
        source_time_Column: "وقت المصدر",
        no_data_found_error_message: "لم يتم العثور على بيانات!",
        movie_name_column: "اسم الفيلم",
        create_ott_period_type_dialog_header: "إنشاء فترة أوت",
        create_subscriber_dialog_header: "إنشاء مشترك",
        play_type_label: "نوع التشغيل",
        ott_period_type_label: "نوع فترة أوت",
        Please_enter_play_time_error_message: "يجب أن يكون وقت اللعب أكبر من الصفر",
        Please_select_play_type_error_message: "الرجاء تحديد نوع التشغيل",
        Please_select_ott_period_type_error_message: "الرجاء تحديد نوع فترة أوت",
        ott_period_label: "فترة أوت",
        Payment_type_label: "نوع الدفع",
        Trials_tab_label: "التجارب",
        Fixed_trials_tab_label: "التجارب الثابتة",
        Reminders_tab_label: "تذكيرات",
        Payment_Provider_label: "موفر الدفع",
        send_label: "تذكير",
        dayPrior_label: "يوم التذكير المسبق",
        enable: "تمكين",
        Trials_dialog_header: "المحاكمات",
        reminders_dialog_header: "تذكيرات",
        add_trial_button_tooltip: "إضافة نسخة تجريبية",
        add_reminders_button_tooltip: "إضافة تذكيرات",
        PaymentPlan_sub_menu: "خطة الدفع",
        Please_select_Payment_Provider_error_message: "يرجى تحديد مزود الدفع",
        Please_select_PlayType_error_message: "الرجاء تحديد نوع التشغيل",
        Please_select_OttPeriod_error_message: "الرجاء تحديد فترة أوت",
        Please_select_Currency_error_message: "يرجى تحديد العملة",
        Please_select_PaymentType_error_message: "يرجى تحديد نوع الدفع",
        ott_product_sub_menu: "المنتج",
        ott_product_label: "المنتج",
        sales_status_label: "حالة المبيعات",
        Geo_Region_label: "المنطقة الجغرافية",
        create_ott_product_type_dialog_header: "إنشاء منتج أوت",
        Please_select_geo_region_error_message: "يرجى تحديد المنطقة الجغرافية",
        Please_select_sales_status_error_message: "الرجاء تحديد حالة المبيعات",
        Please_select_Payment_Plan_error_message: "يرجى تحديد خطة الدفع",
        show_app_bar_label: "إظهار شريط التطبيقات",
        isHomePage_label: "هي الصفحة الرئيسية",
        Route_type_label: "نوع الطريق",
        page_label: "الصفحة",
        Rails_l_label: "L",
        Rails_uat_label: "U",
        Live_label: "مباشر",
        uat_label: "UAT",
        media_is_already_attached_with_another_asset_error_message: "الوسائط مرفقة بالفعل بأصل آخر",
        add_Payment_plan_tooltip: "أضف خطة الدفع",
        Trial_price_label: "السعر التجريبي",
        Trial_days_label: "أيام المحاكمة",
        sort_index_label: "فرز الفهرس",
        إخفاء: "إخفاء",
        Select_Payment_plan_collection: "اختر خطة الدفع",
        Payments_dialog_header: "المدفوعات",
        daysBefore_label: "الأيام السابقة",
        subscription_id_label: "معرف الاشتراك",
        package_label: "الحزمة",
        last_updated_label: "آخر تحديث",
        Please_enter_subscription_id_error_message: "الرجاء إدخال معرف الاشتراك",
        Please_enter_package_error_message: "الرجاء إدخال الحزمة",
        Please_enter_last_update_error_message: "الرجاء إدخال آخر تحديث",
        Please_select_route_type: "يُرجى تحديد نوع المسار",
        Please_select_video_playback_url: "يُرجى تحديد عنوان يو آر إل لتشغيل الفيديو",
        Please_select_page: "الرجاء تحديد الصفحة",
        ott_campaign_page_breadcrumb: "الحملة",
        edit_campaign_editpage_header: "تحرير حملة أوت",
        add_rails_button_tootip: "إضافة القضبان",
        Select_rails_collection: "اختر القضبان",
        Publish_column: "نشر",
        from_date_should_be_less_than_to_date_error_message: "من تاريخ يجب أن يكون أقل من حتى الآن",
        Please_select_rails_error_message: "يرجى تحديد سكة واحدة على الأقل",
        ott_rails_type_column: "نوع قضبان أوت",
        add_above_option: "أضف أعلاه",
        add_below_option: "أضف أدناه",
        Select_any_one_collection_selection_error_message: "اختر أي واحد",
        Please_attach_media_first: "الرجاء إرفاق الوسائط",
        Edit_actionbutton_option: "تحرير",
        Profile_label: "الملف الشخصي",
        asset_label: "معرف الأصل",
        job_id_label: "معرف الوظيفة",
        job_started_label: "بدأت",
        job_finished_label: "انتهى",
        elapsed_label: "منقضي",
        job_input_file_label: "ملف الإدخال",
        media_type_column: "نوع الوسائط",
        file_location_column: "موقع الملف",
        Attach_media_button_tooltip: "إرفاق الوسائط",
        Attach_media_button_text: "إرفاق الوسائط",
        Select_media_collection_header: "حدد الوسائط",
        Assets_label_ott_collection: "الأصول",
        Select_assets_collection_header: "حدد الأصول",
        some_bookings_are_already_Scheduled_Could_not_transfer_error_message: "تم جدولة بعض الحجوزات بالفعل، ولا يمكن نقلها",
        jobs_title: "الوظائف",
        Total_assets_label: "إجمالي الأصول",
        makegoodspot_sub_menu: "اصنع مكانًا جيدًا",
        makegoodspot_title: "اصنع مكانًا جيدًا",
        makegoodspottransfer_dialog_header: "إجراء نقل فوري جيد",
        Select_item_date_between_from_and_to_error_message: "يجب أن يقع تاريخ النقل المحدد بين فترة الحملة من وإلى التاريخ",
        Please_transfer_error_date_greater_than_bookingdate_message: "يُرجى تحديد تاريخ نقل أكبر من تاريخ الحجز الحالي!",
        last_jobs_label: "أحدث الوظائف",
        valid_date_range_copy_to_planning_error_message: "نسخة غير صالحة إلى النطاق الزمني",
        valid_date_range_copy_from_planning_error_message: "نسخة غير صالحة من النطاق الزمني",
        date_range_between_seven_day_copy_from_planning_error_message: "يجب أن يكون نطاق النسخ من التاريخ خلال 31 يومًا",
        date_range_between_seven_day_copy_to_planning_error_message: "يجب أن يكون نطاق النسخ إلى التاريخ خلال 31 يومًا",
        height_label: "الارتفاع",
        create_ott_asset_label: "إنشاء أصل أوت",
        media_label: "الوسائط",
        Please_select_type_error_message: "الرجاء تحديد النوع",
        create_schedule_constraints_editpage_header: "إنشاء قيود الجدول الزمني",
        schedul_constraints_error_message: "قيود الجدول الزمني",
        constraints_lable: "القيود",
        fill_under_run_button_tooltip: "ملء الجدول بناءً على الاختلافات والتنسيق الافتراضي",
        Resetautofill_button_tooltip: "إعادة تعيين التعبئة التلقائية",
        Please_select_amount_error_message: "يرجى تحديد المبلغ",
        Please_enter_sort_index_error_message: "الرجاء إدخال فهرس الفرز",
        Please_enter_trial_price_error_message: "الرجاء إدخال سعر النسخة التجريبية",
        Please_enter_trial_days_error_message: "الرجاء إدخال أيام النسخة التجريبية",
        Please_select_reminder_error_message: "الرجاء تحديد التذكير",
        Please_enter_days_before_error_message: "الرجاء إدخال الأيام السابقة",
        Enable_reminder_label: "تمكين التذكير",
        Coupon_page_breadcrumb: "القسيمة",
        Discount_type_label: "نوع الخصم",
        Discount_value_label: "قيمة الخصم",
        create_coupon_dialog_header: "إنشاء قسيمة",
        Please_select_discount_type_error_message: "يرجى تحديد نوع الخصم",
        percentage_can_not_be_greater_than_error_message: "لا يمكن أن تكون النسبة المئوية أكبر من 100",
        Enable_fixed_trial_label: "تمكين الإصدار التجريبي الثابت",
        Limited_period_label: "فترة محدودة",
        valid_from_label: "صالح من",
        valid_to_label: "صالح لـ",
        Please_select_valid_from_date_error_message: "الرجاء تحديد صالح من",
        Please_select_valid_to_date_error_message: "الرجاء تحديد صالح لـ",
        Discount_should_be_greater_then_zero_error_message: "يجب أن يكون الخصم أكبر من الصفر",
        Please_select_valid_date_error_message: "الرجاء تحديد تاريخ صالح",
        Payment_plan_label: "خطة الدفع",
        Coupon_label: "القسيمة",
        add_coupon_tooltip: "أضف قسيمة",
        Select_coupon_collection: "اختر قسيمة",
        code_column: "الرمز",
        Discount_type_column: "نوع الخصم",
        Discount_value_column: "قيمة الخصم",
        Audit_log_menu: "سجل التدقيق",
        Audit_log_breadcrumb: "سجل التدقيق",
        gene_sub_menu_: "النوع",
        media_category_sub_menu: "فئة الوسائط",
        gene_page_breadcrumb: "النوع",
        media_category_page_breadcrumb: "فئة الوسائط",
        Module_label: "الوحدة النمطية",
        Event_label: "حدث",
        Please_select_event_error_message: "الرجاء تحديد الحدث",
        download_button_tooltip: "تنزيل",
        date_time_label: "التاريخ والوقت",
        Confirm_password_label: "تأكيد كلمة المرور",
        password_do_not_match_error_message: "كلمة المرور غير متطابقة",
        Please_enter_confirm_password_users_error_message: "الرجاء إدخال تأكيد كلمة المرور",
        atleast_attach_atleast_one_platform_error_message: "يرجى تحديد منصة واحدة على الأقل",
        upload_file_button_tooltip: "تحميل ملف",
        role_tab_label: "الدور",
        add_channel_button_text: "إضافة قناة",
        Select_channel_collection_header: "اختر قناة",
        Please_add_atleast_one_channel_users_error_message: "يرجى إضافة قناة واحدة على الأقل",
        Please_select_order_date_error_message: "الرجاء تحديد تاريخ الطلب",
        Please_select_period_from_date_error_message: "الرجاء تحديد الفترة من",
        Please_select_period_to_date_error_message: "يرجى تحديد الفترة إلى",
        Please_select_deal_type_error_message: "يرجى تحديد نوع الصفقة",
        Please_select_location_error_message: "الرجاء تحديد الموقع",
        Please_select_product_error_message: "الرجاء تحديد المنتج",
        ott_segment_sub_menu: "مقطع",
        Payment_plan_page_breadcrumb: "خطة الدفع",
        ott_segment_page_breadcrumb: "مقطع",
        create_segment_dialog_header: "إنشاء مقطع",
        section_label: "مقطع",
        Please_select_segment_error_message: "الرجاء تحديد المقطع",
        monetization_dashboard: "تحقيق الدخل",
        section_by_subscribe_label: "التقسيم حسب المشترك",
        section_by_product_label: "التقسيم حسب المنتج",
        Products_column: "المنتجات",
        Total_coupon_column: "إجمالي القسيمة",
        Total_subscriber_column: "إجمالي المشتركين",
        Coupon_name_column: "اسم القسيمة",
        pgrating_sub_menu: "تقييم ص",
        pgrating_page_breadcrumb: "تقييم ص",
        open_in_a_new_tab_label: "فتح في علامة تبويب جديدة",
        column_preference_label: "تفضيلات العمود",
        parent_label: "الوالد",
        overrun_underrun_label: "التجاوز والتشغيل الناقص",
        Copy_count_label: "عدد النسخ",
        Selected_header_label: "الرأس المحدد",
        Selected_count_label: "العدد المحدد",
        Platform_column: "النظام الأساسي",
        Please_enter_old_password_users_error_message: "الرجاء إدخال كلمة المرور القديمة",
        old_password_does_not_match_error_message: "كلمة المرور القديمة غير متطابقة",
        Please_enter_new_password_error_message: "الرجاء إدخال كلمة المرور الجديدة",
        Confirm_password_do_not_match_error_message: "تأكيد عدم تطابق كلمة المرور",
        old_password_label: "كلمة المرور القديمة",
        new_password_label: "كلمة المرور الجديدة",
        account_label: "الحساب",
        Change_password_label: "تغيير كلمة المرور",
        log_out_label: "تسجيل الخروج",
        media_by_category_menu: "الوسائط حسب الفئة",
        movie_label: "فيلم",
        season_label: "الموسم",
        view_details_label: "عرض التفاصيل",
        Executive_label: "تنفيذي",
        subscriber_label: "مشترك",
        Confirm_logout_label: "تأكيد تسجيل الخروج",
        are_you_sure_you_want_to_generate_Payment: "هل أنت متأكد من رغبتك في إنشاء الدفعة؟",
        Yes_label: "نعم",
        no_label: "لا",
        Confirm_delete_label: "تأكيد الحذف",
        are_you_sure_you_want_to_delete: "هل أنت متأكد من رغبتك في الحذف؟",
        scheduling_label: "الجدولة",
        Planning_label: "التخطيط",
        options_label: "الخيارات",
        un_archive_label: "إلغاء الأرشفة",
        create_from_label: "إنشاء من",
        Category_label: "الفئة",
        Select_category_label: "اختر فئة",
        Grid_view_label: "عرض الشبكة",
        Tile_view_label: "عرض البلاط",
        linear_label: "خطي",
        Non_linear_label: "غير خطي",
        Audit_log_label: "سجل التدقيق",
        enter_date_and_time_column: "تاريخ الإدخال والوقت",
        Event_column: "الحدث",
        user_column: "المستخدم",
        Close_button_tooltip: "إغلاق",
        Apply_recursive_button_text_planning: "تطبيق متكرر",
        History_button_text_planning: "التاريخ",
        open_schedule_button_text_planning: "فتح الجدول الزمني",
        Insert_program_group_label_planning: "إدراج مجموعة البرامج",
        Export_planner_button_text: "مخطط التصدير",
        export_epg_button_text: "تصدير دليل البرامج الإلكتروني",
        Planning_loaded_label: "تم تحميل التخطيط",
        Planning_loading_error_label: "خطأ في تحميل التخطيط",
        error_fetching_planning_data_error_message: "حدث خطأ أثناء جلب بيانات التخطيط",
        Planning_loading_label: "تحميل التخطيط",
        Success_created_group_label: "تم إنشاء المجموعة بنجاح!",
        Pasted_label: "تم اللصق",
        items_label: "العناصر",
        last_updated_from_label_msg: "آخر تحديث منذ",
        cannot_delete_segment_label_msg: "لا يمكن حذف المقطع",
        Can_delete_header_label_msg: "لا يمكن حذف الرأس، استخدم حذف الرأس عند النقر بزر الماوس الأيمن على الرأس",
        Select_item_to_error_message: "حدد عنصرًا لـ",
        Can_cut_footer_msg_scheduling: "لا يمكن قص التذييل.",
        Can_delete_multiple_footer_msg_scheduling: "لا يمكن حذف تذييلات متعددة.",
        Can_delete_multiple_footer_please_select_one_footer_at_a_time_msg_scheduling: "لا يمكن حذف تذييل متعدد، يرجى تحديد تذييل واحد في كل مرة.",
        no_item_selected_to_copy_msg_scheduling: "لم يتم تحديد أي عنصر للنسخ",
        cannot_copy_segment_msg_scheduling: "لا يمكن نسخ - شريحة",
        cannot_copy_break_msg_scheduling: "لا يمكن النسخ - فاصل",
        cannot_copy_header_msg_scheduling: "لا يمكن نسخ - الرأس",
        deleting_footer_msg_scheduling: "حذف التذييل",
        footer_deleted_msg_scheduling: " تم حذف التذييل",
        no_footer_to_deleted_error_message: "لا يوجد تذييل لحذفه",
        all_footer_deleted_error_message: "تم حذف كافة التذييلات",
        there_are_some_at_server_side_please_contact_admin: "يوجد بعضها على جانب الخادم، يرجى الاتصال بالمسؤول",
        Loading_schedule_please_wait_msg_scheduling: "جاري تحميل الجدول، الرجاء الانتظار...",
        Loading_schedule_Completed_msg_scheduling: "اكتمل جدول التحميل!!",
        Please_selct_one_item_msg_scheduling: "يرجى تحديد عنصر واحد",
        no_media_selected_msg_scheduling: "لم يتم تحديد الوسائط",
        deleted_Secondary_events_msg_scheduling: "الأحداث الثانوية المحذوفة",
        all_Secondary_events_deleted_successously_msg_scheduling: "تم حذف كافة الأحداث الثانوية بنجاح!!",
        style_sheet_applied_successously_msg_scheduling: "تم تطبيق ورقة الأنماط بنجاح!!",
        Secondary_event_updated_msg_scheduling: "تم تحديث الحدث الثانوي",
        no_Secondary_events_error_message: "لا توجد أحداث ثانوية",
        Select_target_item_from_schedule_error_message: "حدد العنصر المستهدف من الجدول الزمني",
        first_cut_or_copy_item_error_message: "أول قطع أو نسخ العنصر.",
        Please_select_Item_to_paste_error_message: "الرجاء تحديد العنصر المراد لصقه.",
        Please_select_one_Item_where_need_to_paste_error_message: "يرجى تحديد عنصر واحد، حيث يلزم لصقه.",
        delete_msg: "حذف",
        Cut_msg: "حذف",
        cannot_segment_please_unselect_segment_error_message: "لا يمكن حذف المقطع، يرجى إلغاء تحديد المقطع",
        Cant_delete_header_please_unselect_header_error_message: "لا يمكن حذف الرأس، يرجى إلغاء تحديد الرأس أو استخدام خيار حذف الرأس بزر الماوس الأيمن.",
        Confirmation_label: "تأكيد",
        are_you_sure_you_want_to_delete_footer_label: "هل أنت متأكد من رغبتك في حذف التذييل؟",
        Are_you_sure_you_want_to_items_label_confirm_alert: "هل أنت متأكد من رغبتك في ذلك",
        cannot_select_footer_error_message: "لا يمكن تحديد التذييل.",
        cannot_multi_select_items_from_different_headers_error_message: "لا يمكن تحديد عناصر متعددة من رؤوس مختلفة.",
        Please_select_first_error_message: "يرجى التحديد أولاً.",
        cannot_select_items_from_different_headers_error_message: "لا يمكن تحديد عناصر من رؤوس مختلفة.",
        Please_choose_right_media_categor_error_message: "الرجاء اختيار فئة الوسائط الصحيحة",
        Prototype_drop_not_allowed_for_headers_error_message: "إسقاط النموذج الأولي غير مسموح به للرؤوس",
        Break_type_item_is_not_allowed_error_message: "عنصر نوع الفصل غير مسموح به.",
        Can_move_segment_to_different_program_schedule_error_message: "لا يمكن نقل المقطع إلى جدول برنامج مختلف",
        Prototype_drop_not_allowed_for_headers_and_footers_error_message: "غير مسموح بإسقاط النموذج الأولي للرؤوس والتذييلات",
        Please_select_header_firsts_error_message: "الرجاء تحديد الرأس أولاً",
        Can_delete_selected_header_contains_booked_commercials_error_message: "لا يمكن الحذف !! يحتوي الرأس المحدد على إعلانات تجارية محجوزة",
        cannot_delete_selected_header_contains_reconciled_items_error_message: "لا يمكن الحذف!! يحتوي الرأس المحدد على العناصر التي تمت تسويتها",
        Confirm_delete_header_confirm_alert_msg: "تأكيد حذف الرأس",
        are_you_sure_you_want_to_delete_confirm_alert_msg: "هل أنت متأكد من رغبتك في الحذف",
        Select_one_program_to_replace_with_error_message: "اختر برنامجًا واحدًا للاستبدال به",
        header_from_confirm_alert_msg: "الرأس من",
        Please_select_schedule_item_error_message: "الرجاء تحديد عنصر الجدول الزمني",
        not_allowed_on_this_postion_error_message: "غير مسموح به في هذا المنشور",
        Please_select_one_item_error_message: "يرجى تحديد عنصر واحد",
        no_Secondary_events_attached_to_delete_error_message: "لا توجد أحداث ثانوية مرفقة للحذف",
        Prototype_drop_not_allowed_for_break_error_message: "إسقاط النموذج الأولي غير مسموح به للاستراحة",
        add_Secondary_events_success_message: "تمت إضافة أحداث ثانوية",
        Please_load_schedule_first_error_message: "يُرجى تحميل الجدول أولاً.",
        varis_are_not_available_info_message: "الاختلافات غير متاحة",
        process_Completed_success_message: "اكتملت العملية",
        Select_atleast_one_header_error_message: "حدد رأسًا واحدًا على الأقل",
        user_favourite_page_breadcrumb: "المفضلة",
        Please_enter_template_name_to_save_template_error_message: "الرجاء إدخال اسم القالب لحفظ القالب",
        rmn_label: "رمن",
        Please_enter_rmn_error_message: "الرجاء إدخال رقم رمن",
        expand_collapse_headers_label: "توسيع/طي الرؤوس",
        pages_label: "الصفحات",
        Total_product_column: "إجمالي المنتج",
        update_synopsis: "ملخص التحديث",
        valid_time_range: "نطاق زمني غير صالح",
        table_automatic_break_tooltip: "إنشاء فواصل تلقائية",
        Select_icon_url_collection_header: "اختر أيقونة",
        Planningdistributionformat_sub_menu: "تنسيق توزيع التخطيط",
        Planningdistributionformat_page_breadcrumb: "تنسيق توزيع التخطيط",
        edit_planningdistributionformat_editpage_header: "تحرير تنسيق توزيع التخطيط",
        create_planningdistributionformat_editpage_header: "إنشاء تنسيق توزيع التخطيط",
        subtitle_label: "العنوان الفرعي",
        subtitle_type_label: "نوع الترجمة",
        Please_select_segment_type_error_message: "الرجاء تحديد نوع المقطع",
        audio_track_label: "مسار صوتي",
        Track_number_label: "رقم المسار",
        add_language_group_prototype_button_tooltip: "إضافة مجموعة لغات",
        add_language_group_prototype_button_text: "إضافة مجموعة لغات",
        Please_enter_track_number_error_message: "الرجاء إدخال رقم المسار",
        Please_select_atleast_one_language_error_message: "يرجى تحديد لغة واحدة على الأقل",
        language_already_added_error_message: "تمت إضافة اللغة بالفعل",
        Track_number_already_added_error_message: "تمت إضافة رقم المسار بالفعل",
        Please_select_atleast_one_rule_error_message: "يرجى تحديد قاعدة واحدة على الأقل",
        update_template_label: "تحديث القالب",
        media_category_type_sub_menu: "نوع فئة الوسائط",
        Work_order_dashboard: "أمر العمل",
        todo_tile_label: "المهام الواجبة",
        in_progress_tile_label: "قيد التقدم",
        Done_tile_label: "تم",
        Workflow_label: "سير العمل",
        Notes_label: "ملاحظات",
        Please_select_atleast_one_role_error_message: "يرجى تحديد دور واحد على الأقل",
        Workflow_dialog_header: "إنشاء سير عمل",
        Workorder_dialog_header: "إنشاء أمر عمل",
        role_label: "الأدوار",
        Workflow_page_breadcrumb: "سير العمل",
        Workflow_menu: "سير العمل",
        current_status_column: "الحالة الحالية",
        create_date_column: "تاريخ الإنشاء",
        Please_select_workflow_error_message: "الرجاء تحديد سير العمل",
        media_column: "الوسائط",
        Transmission_label: "إرسال",
        transmission_column: "الإرسال",
        mamID_label: "معرف مام",
        Apply_distribution_button_text_planning: "تخطيط التوزيع",
        min_gap_label: "الفارق الخاص بي",
        Apply_fix_gap_label: "تطبيق إصلاح الفجوة",
        Plan_till_label: "التخطيط لـ",
        max_placement_label: "الحد الأقصى للموضع",
        valid_days_label: "الأيام الصالحة",
        retry_gap_label: "إعادة محاولة الفجوة",
        Planning_distribution_label: "تخطيط التوزيع",
        Please_enter_minimum_gap_error_message: "الرجاء إدخال الحد الأدنى للفجوة",
        Please_select_plan_till_date_error_message: "يرجى تحديد الخطة حتى الآن",
        Please_enter_max_placement_error_message: "الرجاء إدخال الحد الأقصى للموضع",
        Please_select_days_error_message: "الرجاء تحديد الأيام",
        Please_enter_retry_gap_error_message: "الرجاء إدخال فجوة إعادة المحاولة",
        Please_select_starting_role_error_message: "يرجى تحديد دور البداية",
        start_role_label: "دور البداية",
        Plan_till_date_cannot_be_less_than_original_planned_item_error_message: "لا يمكن أن تكون الخطة حتى التاريخ أقل من العنصر المخطط الأصلي",
        Apply_planning_distribution_template_please_wait_planner_status_message: "تطبيق قالب توزيع التخطيط، الرجاء الانتظار...",
        Planning_distribution_template_applied_success_planner_status_message: "تم تطبيق قالب تخطيط التوزيع بنجاح",
        note_for_parent_select_null_label: "ملاحظة: بالنسبة للوالد حدد null",
        Payments_label: "المدفوعات",
        table_autofill_button_tooltip: "التعبئة التلقائية للإعلانات التجارية المحجوزة",
        schedul_reset_all_header_to_nominal_start_time_button_tooltip: "إعادة تعيين كل وقت بدء الرأس إلى الوقت الاسمي المخطط",
        Work_orders_label: "أوامر العمل",
        role_wise_work_orders_label: "دور أوامر العمل الحكيمة",
        user_wise_work_orders_label: "أوامر العمل الحكيمة للمستخدم",
        Select_media_info_message: "حدد الوسائط",
        History_label: "التاريخ",
        booking_details_label: "تفاصيل الحجز",
        show_jobs_button_text: "إظهار الوظائف",
        Please_check_label: "يرجى التحقق",
        Categories_label: "الفئات",
        job_status_label: "الحالة الوظيفية",
        valid_start_date: "تاريخ البدء غير صالح",
        valid_end_date: "تاريخ انتهاء غير صالح",
        target_budget_should_be_greater_then_zero: "يجب أن تكون الميزانية المستهدفة أكبر من الصفر",
        target_spots_should_be_greater_then_zero: "يجب أن تكون المواقع المستهدفة أكبر من الصفر",
        target_thans_should_be_greater_then_zero: "يجب أن تكون الثواني المستهدفة أكبر من القيمة السالبة",
        Please_select_date_format_error_message: "الرجاء تحديد تنسيق التاريخ",
        no_data_schedule_to_save_scheduling_reconciliation_error_message: "لم يتم العثور على جدول زمني",
        no_data_asrun_to_save_scheduling_reconciliation_error_message: "لم يتم العثور على بيانات كما تشغيل",
        reset_password_label: "إعادة تعيين كلمة المرور",
        date_column_is_not_present_in_this_csv_file_label: "عمود التاريخ غير موجود في ملف سي إس في هذا",
        time_column_is_not_present_in_this_csv_file_label: "عمود الوقت غير موجود في ملف سي إس في هذا",
        house_number_column_is_not_present_in_this_csv_file_label: "عمود رقم المنزل غير موجود في ملف سي إس في هذا",
        user_favourite_add_button_title: "إضافة المفضلة",
        user_favourite_menu: "المفضلة",
        user_favorite_menu_dropdown_label: "القائمة",
        user_favorite_menu_text_label: "الاسم",
        Please_select_user_favourite_menu_error_message: "الرجاء تحديد القائمة",
        Please_select_user_favourite_name_error_message: "الرجاء إدخال الاسم",
        vodtype_label: "أنواع الخامس التطوير التنظيمي",
        replace_existing_planning_label: "استبدال التخطيط الموجود",
        region_column: "المنطقة",
        Live_events_menu: "الأحداث المباشرة",
        vodtype: "نوع الخامس التطوير التنظيمي",
        version_sub_menu: "الإصدار",
        version_page_breadcrumb: "الإصدار",
        Spot_can_not_be_negative_error_message: "لا يمكن أن تكون النقطة سالبة",
        Rate_can_not_be_negative_error_message: "لا يمكن أن يكون المعدل سالبًا",
        Please_add_booking_first_booking_error_message: "يُرجى إضافة الحجز أولاً",
        Transfer_from_and_transfer_to_are_same_date_error_message: "لا يمكن النقل في نفس التاريخ",
        Tournament_dialog_header: "إنشاء بطولة",
        Live_match_dialog_header: "إنشاء مطابقة",
        no_booking_data_error_message: "لم يتم العثور على بيانات الحجز!",
        ott_assets_video: "فيديو",
        ott_assets_poster: "ملصق",
        update_successously_booking_success_toast_message: "تم تحديث الحجز بنجاح",
        Please_select_a_value_to_delete_booking_error_message: "يرجى تحديد قيمة لحذفها",
        ott_assets_video_url_error_message: "الرجاء إدخال عنوان يو آر إل",
        LiveEventRound_sub_menu: "جولة الحدث المباشر",
        LiveEventType_sub_menu: "نوع الحدث المباشر",
        TournamentType_sub_menu: "نوع البطولة",
        Commission_negative_value_campaign_error_message: "لا يمكن أن تكون العمولة سالبة",
        Discount_negative_value_campaign_error_message: "لا يمكن أن يكون الخصم سلبيًا",
        valid_spots_value_line_no_booking_error_message: "قيمة النقاط السلبية في السطر رقم",
        Channels_not_updated_in_booking_error_message: "لم يتم تحديث القناة في السطر رقم",
        Attach_media_label: "إرفاق الوسائط",
        media_episode_localization: "التعريب",
        media_episode_id_column: "معرف حلقة الوسائط",
        Manage_content_template_sub_menu: "إدارة قالب المحتوى",
        fct_can_not_be_negative_error_message: "واو سي تي لا يمكن أن يكون سلبيًا",
        Rate_10_sec_can_not_be_negative_error_message: "معدل 10 ثانية لا يمكن أن يكون سالبًا",
        amount_can_not_be_negative_error_message: "لا يمكن أن يكون المبلغ سالبًا",
        book_spots_scheduled_error_message: "بعض الحجوزات المحددة مستخدمة بالفعل في الجدول الزمني.",
        booking_line_no: "رقم السطر",
        Please_select_import_type_error_message: "يرجى تحديد نوع الاستيراد",
        optimisation_sun_menu: "التحسين",
        optimisation_page_breadcrumb: "التحسين",
        booking_date_label: "تاريخ الحجز",
        Agency_name_column: "اسم الوكالة",
        Insurance_type_column: "نوع الضمان",
        sursured_value_column: "القيمة المؤكدة",
        Please_select_booking_date_error_message: "يرجى تحديد تاريخ الحجز",
        optimisation_label: "التحسين",
        Please_show_atleast_one_item_error_message: "يرجى إظهار عنصر واحد على الأقل!",
        Please_enter_valid_percentage_error_message: "الرجاء إدخال نسبة مئوية صحيحة",
        Campaign_target_thans_actual_thans_booking_error: "لا يمكن أن تكون الثواني المستهدفة أقل من إجمالي الثواني المحجوزة",
        Campaign_target_budget_actual_budget_booking_error: "لا يمكن أن تكون الميزانية المستهدفة أقل من إجمالي الميزانية المحجوزة",
        Campaign_target_spots_actual_spots_booking_error: "لا يمكن أن تكون النقاط المستهدفة أقل من إجمالي النقاط المحجوزة",
        sursured_value_is_greater_than_total_fct_error_message: "القيمة المؤكدة أكبر من إجمالي fct",
        sursured_value_is_less_than_zero_error_message: "القيمة المؤكدة أقل من الصفر",
        booking_schedule_status: "حالة جدول الحجز",
        makegood_column: "افعل الخير",
        book_spots_unique_line_no_selection_error_message: "يُرجى تحديد المواقع التي لها نفس السطر لا للتحديث",
        booking_file_import_error_message: "غير قادر على قراءة البيانات من الملف. خطأ - ",
        Spot_status_column: "الحالة",
        booking_transfer_from_date_greater_than_transfer_to_date_error_message: "لا يمكن أن يكون النقل من التاريخ أكبر من النقل إلى التاريخ",
        Spot_time_from_time_to_error_message: "من وقت يجب أن يكون أقل من وقت",
        Material_type_label: "نوع المادة",
        cancreatedeal_label: "يمكن إنشاء صفقة",
        Please_enter_material_type_error_message: "الرجاء إدخال نوع المادة",
        Please_select_media_category_error_message: "الرجاء تحديد فئة الوسائط",
        Automation_type_label: "نوع الأتمتة",
        download_button_text: "تنزيل",
        edit_black_out_date_button_tooltip: "تحرير تاريخ انقطاع التيار الكهربائي",
        add_black_out_date_button_tooltip: "إضافة تاريخ انقطاع التيار الكهربائي",
        edit_black_out_date_dialog_header: "تحرير التعتيم",
        add_black_out_date_dialog_header: "إضافة التعتيم",
        black_out_date_dialog_header: "تاريخ انقطاع التيار الكهربائي",
        Please_add_atleast_one_black_out_date_error_message: "يُرجى إضافة تاريخ حظر واحد على الأقل",
        update_successously_grid_data_success_toast_message: "تم التحديث بنجاح",
        black_out_channel_column: "قناة بلاك اوت",
        black_out_start_date_column: "تاريخ بدء الحجب",
        black_out_end_date_column: "تاريخ انتهاء الحظر",
        black_out_date_should_be_within_publishing_dates_range_error_message: "يجب أن تكون تواريخ الحظر ضمن نطاق تواريخ النشر",
        some_bookings_are_out_of_campaign_date_range_could_not_transfer_error_message: "بعض الحجوزات خارج النطاق الزمني للحملة، لا يمكن النقل",
        report_menu: "تقرير",
        interstitial_history_sub_menu: "السجل الخلالي",
        interstitial_history_report_dialog_header: "تقرير السجل الخلالي",
        client_agency_booking_report_sub_menu: "تقرير حجز وكالة العميل",
        Primary_channel_column: "القناة الأساسية",
        order_date_error_message: "يجب أن يكون تاريخ الطلب أقل من الفترة من",
        Please_select_tournament_type: "يرجى تحديد نوع البطولة",
        Please_enter_tournament_ID: "الرجاء إدخال معرف البطولة",
        Tournament_type_label: "نوع البطولة",
        Tournament_ID_label: "معرف البطولة",
        as_run_label: "كما تشغيل",
        table_label: "الجدول الزمني",
        update_booking_multiple_dialog_header: "تحديث الحجز",
        Commercial_duration_lable: "المدة",
        no_as_run_found_error_message: "لم يتم العثور على كما تشغيل",
        Copy_from_and_copy_to_date_range_should_be_same: "يجب أن تكون الأيام (النسخ من) المحددة مساوية للأيام المحددة (النسخ إلى).",
        Exclusive_label: "حصريًا",
        Exclusive_start_date_column: "تاريخ البدء الحصري",
        Exclusive_end_date_column: "تاريخ الانتهاء الحصري",
        Technical_details_prototype_sub_menu: "التفاصيل الفنية للنماذج الأولية",
        Technical_details_prototype_page_breadcrumb: "النماذج الأولية للتفاصيل الفنية",
        audio_codec_page_breadcrumb: "برنامج ترميز الصوت",
        video_codec_page_breadcrumb: "برنامج ترميز الفيديو",
        Delivery_method_page_breadcrumb: "طريقة التسليم",
        video_aspect_ratio_page_breadcrumb: "نسبة العرض إلى الارتفاع للفيديو",
        video_type_page_breadcrumb: "نوع الفيديو",
        audio_codec_sub_menu: "برنامج ترميز الصوت",
        video_codec_sub_menu: "برنامج ترميز الفيديو",
        Delivery_method_sub_menu: "طريقة التسليم",
        video_aspect_ratio_sub_menu: "نسبة العرض إلى الارتفاع للفيديو",
        video_type_sub_menu: "نوع الفيديو",
        is_exclusive_column: "حصري",
        ref_off_setting_label: "إعداد الإزاحة",
        Offset_time_minus_label: "وقت الإزاحة ناقص",
        Offset_time_plus_label: "وقت الإزاحة الزائد",
        ignore_duration_lable: "مدة يتجاهل",
        reference_no_label: "رقم المرجع",
        Please_enter_reference_no_error_message: "الرجاء إدخال الرقم المرجعي",
        create_technical_details_prototype_header_dialog: "إنشاء نموذج أولي للتفاصيل الفنية",
        audio_codec_label: "برنامج ترميز الصوت",
        video_codec_label: "برنامج ترميز الفيديو",
        video_aspect_ratio_label: "نسبة العرض إلى الارتفاع للفيديو",
        Delivery_method_label: "طريقة التسليم",
        is_quality_checked_label: "تم فحص الجودة",
        Enable_caption_label: "تمكين التسمية التوضيحية",
        Distributer_label: "الموزع",
        Please_select_audio_codec_error_message: "الرجاء تحديد برنامج ترميز الصوت",
        Please_select_video_codec_error_message: "الرجاء تحديد برنامج ترميز الفيديو",
        Please_select_delivery_method_error_message: "الرجاء تحديد طريقة التسليم",
        Please_select_video_aspect_ratio_error_message: "الرجاء تحديد نسبة العرض إلى الارتفاع للفيديو",
        Please_select_video_type_error_message: "الرجاء تحديد نوع الفيديو",
        Offsetting_dialog_header: "إعدادات إيقاف التشغيل",
        Please_enter_OffSet_Time_Minus_error_message: "الرجاء إدخال وقت الإزاحة ناقص",
        Please_enter_offSet_time_plus_error_message: "الرجاء إدخال وقت الإزاحة الزائد",
        booking_schedule_status_sub_menu: "حالة جدول الحجز",
        edit_multiple_tooltip: "تحرير المتعدد",
        Select_commercial_error_message: "يرجى تحديد تجاري",
        valid_spotRate_error_message: "يُرجى إدخال سعر فوري صالح",
        valid_rate10Sec_error_message: "الرجاء إدخال معدل صالح لمدة 10 ثوانٍ",
        Please_select_atleast_one_value_to_update_error_message: "يرجى تحديد قيمة واحدة على الأقل للتحديث",
        Rate_10_sec_column: "معدل 10 ثانية",
        Missing_media_report_dialog_header: "تقرير الوسائط المفقود",
        Missing_media_report_sub_menu: "تقرير الوسائط المفقود",
        table_date_label: "تاريخ الجدولة",
        Please_select_schedule_date_error_message: "يرجى تحديد تاريخ الجدول الزمني",
        mam_assets_sub_menu: "ماماسيت",
        mamassets_page_breadcrumb: "ام الأصول",
        create_mamasset_dialog_header: "إنشاء ماماسيت",
        Please_enter_programeditstatus_error_message: "الرجاء إدخال حالة تحرير البرنامج",
        end_time_label: "وقت الانتهاء",
        Program_edit_status_label: "حالة تحرير البرنامج",
        tx_ready_label: "تكساس جاهز",
        subtitle_availble_label: "الترجمة متوفرة",
        censership_report_available_label: "تقرير الرقابة متاح",
        qcpass_label: "ممر مراقبة الجودة",
        Please_enter_valid_end_time_message: "الرجاء إدخال وقت انتهاء صالح",
        Please_enter_valid_actual_duration_message: "الرجاء إدخال مدة فعلية صالحة",
        time_in_label: "الوقت الوارد",
        time_out_label: "المهلة",
        Commercial_limit_label: "الحدود التجارية",
        Please_enter_valid_commercial_limit_error_message: "الرجاء إدخال حد تجاري صالح",
        Contract_number_column: "رقم العقد",
        Duration_should_be_greater_than_zero_error_message: "يجب أن تكون المدة أكبر من الصفر",
        number_of_episode_can_be_greater_than_zero_error_message: `يجب أن يكون عدد الحلقات أكبر من الصفر`,
        staring_episode_can_be_greater_than_zero_error_message: `يجب أن يكون بدء الحلقة أكبر من الصفر`,
        section_qc_page_header: "مراقبة الجودة للقطاع",
        section_qc_button_tooltip: "مراقبة الجودة للقطاع",
        media_title_label: "عنوان الوسائط",
        qc_status_label: "حالة مراقبة الجودة",
        frame_rate_label: "معدل الإطارات",
        note_label: "ملاحظة",
        Please_select_qc_status_error_message: "يرجى تحديد حالة مراقبة الجودة",
        Please_enter_note_error_message: "الرجاء إدخال ملاحظة",
        Please_select_frame_rate_error_message: "الرجاء تحديد معدل الإطارات",
        Please_enter_positive_value_in_pin_code_error_message: "الرجاء إدخال قيمة موجبة في الرمز السري",
        Please_enter_commission_error_message: "الرجاء إدخال العمولة",
        Please_enter_discount_error_message: "الرجاء إدخال الخصم",
        Please_configure_checklist_preference_error_message: "الرجاء تكوين تفضيلات قائمة التحقق !!",
        Preference_saved_successously: "تم حفظ التفضيل بنجاح!!",
        Please_select_csv_file_error_message: "الرجاء تحديد ملف سي إس في!",
        cannot_delete_channel_campaign_already_has_booking_error_message: " لا يمكن حذف حملة القناة التي تم حجزها بالفعل",
        cannot_delete_commercial_campaign_already_has_booking_error_message: " لا يمكن حذف الحملة التجارية التي تم حجزها بالفعل",
        ref_change_rate10sec_label: "معدل التغيير 10 ثوانٍ",
        Change_rate10sec_dialog_header: "تغيير المعدل 10 ثوانٍ",
        Change_rate10sec_label: "تغيير المعدل 10 ثوانٍ",
        import_pdf_file: "استيراد ملف قوات الدفاع الشعبي",
        Please_select_atleast_one_media_category_type_error_message: "يرجى تحديد نوع واحد على الأقل من فئة الوسائط",
        Please_select_episode_content_error_message: "الرجاء تحديد محتوى الحلقة",
        iso_code_label: "رمز ايزو",
        google_api_code_label: "رمز جوجل واجهة برمجة التطبيقات",
        create_language_dialog_header: "إنشاء لغة",
        Please_enter_iso_code_error_message: "الرجاء إدخال رمز ايزو",
        Please_enter_google_api_code_error_message: "الرجاء إدخال رمز جوجل واجهة برمجة التطبيقات",
        click_here_to_check_ISO_code_error_message: "انقر هنا للتحقق من رمز ايزو",
        booking_update_successously: "تم تحديث الحجز بنجاح",
        cast_Type_page_breadcrumb: "نوع الإرسال",
        cast_Type_sub_menu: "نوع الإرسال",
        Spots_out_of_campaign_date_range_error_message: "توجد بعض المواقع خارج النطاق الزمني للحملة. يرجى المراجعة",
        import_pdf_booking_file: "استيراد حجز قوات الدفاع الشعبي",
        import_booking_label: "استيراد الحجز",
        download_template_label: "تنزيل القالب",
        Export_saved_booking_label: "تصدير الحجز المحفوظ",
        Export_current_booking_label: "تصدير الحجز الحالي",
        Planning_is_locked_on_some_days_in_this_date_range: "التخطيط مقفل في بعض الأيام في هذا النطاق الزمني",
        Payment_schedule_label: "جدول الدفع",
        Promotional_excerpts_label: "مقتطفات ترويجية",
        Governor_laws_label: "القوانين الحاكمة",
        add_linear_page_header: "إضافة خطي",
        add_linear_button_tooltip: "إضافة خطي",
        amount_should_be_negative_error_message: "لا يمكن أن يكون المبلغ سالبًا",
        currency_column: "العملة",
        Total_booked_spots_label: "الأماكن المحجوزة",
        Total_booked_thans_label: "الثواني المحجوزة",
        Total_booked_amount_label: "المبلغ المحجوز",
        booking_exceeded_target_budget: "تجاوز الميزانية المستهدفة، يرجى التحديث والمحاولة مرة أخرى",
        booking_exceeded_target_thans: "تجاوز الميزانية المستهدفة، يرجى التحديث والمحاولة مرة أخرى",
        booking_exceeded_target_amount: "تجاوز الميزانية المستهدفة، يرجى التحديث والمحاولة مرة أخرى",
        Broadcaster_id_label: "معرف المذيع",
        Restriction_label: "تقييد",
        create_restriction_dialog_header: "إنشاء تقييد",
        dynamic_rules_label: "القواعد الديناميكية",
        censership_details_label: "تفاصيل الرقابة",
        term_label: "الشروط",
        Reason_label: "السبب",
        Hold_all_Payment_label: "تعليق جميع الدفعات",
        generator_Payment_button_text: "إنشاء الدفع",
        Contract_Payment_schedule_dialog_header: "جدول دفع العقد",
        generator_Payment_schedule_dialog_header: "إنشاء جدول الدفع",
        Due_date_label: "تاريخ الاستحقاق",
        Interest_rate_label: "سعر الفائدة",
        no_of_installment_label: "لا. بالتقسيط",
        recurring_label: "متكرر",
        Due_date_column: "تاريخ الاستحقاق",
        Due_amount_column: "المبلغ المستحق",
        Accept_status_column: "الموافقة على الحالة",
        amount_paid_column: "المبلغ المدفوع",
        Balance_amount_column: "مبلغ الرصيد",
        Please_select_recurring_error_message: "الرجاء تحديد متكرر",
        Interest_rate_should_be_negative_error_message: "يجب أن يكون سعر الفائدة سالبًا",
        no_of_installment_should_be_greater_than_zero_error_message: "يجب أن يكون عدد القسط أكبر من الصفر",
        generator_pay_label: "إنشاء الدفع",
        are_you_sure_you_want_to_generate_Payment_schedule: "هل أنت متأكد من رغبتك في إعادة إنشاء جدول الدفع",
        amount_paid_label: "المبلغ المدفوع",
        Approval_status_label: "حالة الموافقة",
        mark_column: "ملاحظة",
        edit_contract_title_button_text: "تحرير عنوان العقد",
        edit_black_out_date_button_text: "تحرير تاريخ الحجب",
        delete_contract_title_button_text: "حذف عنوان العقد",
        classification_label: "التصنيف",
        Cut_tc_in_label: "قص ح في (س:د:ثث:فف)",
        Cut_tc_out_label: "قص Tc (س:د:ثث:فف)",
        Done_date_label: "تاريخ الانتهاء",
        result_label: "النتيجة",
        officer_label: "ضابط",
        Cut_label: "قص",
        classification_column: "التصنيف",
        Cut_tc_in_column: "قص ح في",
        Cut_tc_out_column: "قص ح خارج",
        Done_date_column: "تاريخ الانتهاء",
        reference_no_column: "رقم المرجع",
        result_column: "النتيجة",
        officer_column: "ضابط",
        cut_column: "قص",
        create_censorship_details_dialog_header: "إنشاء تفاصيل الرقابة",
        Please_enter_valid_value_cut_tcin_error_message: "الرجاء إدخال قطع تي ج في صالح",
        can_not_delete_error_message: "لا يمكن حذف لوحة المعلومات بشكل صحيح",
        add_brand_button_tooltip: "إضافة علامة تجارية",
        add_product_button_tooltip: "إضافة منتج",
        Ratecard_page_breadcrumb: "بطاقة السعر",
        Ratecard_sun_menu: "بطاقة السعر",
        create_ratecard_dialog_header: "إنشاء بطاقة أسعار",
        Rate_10sec_label: "معدل 10 ثواني",
        Please_enter_time_in_error_message: "الرجاء إدخال الوقت",
        Please_enter_time_out_error_message: "الرجاء إدخال المهلة",
        view_label: "عرض",
        other_option_label: "خيار آخر",
        prime_time_label: "وقت الذروة",
        no_rights_scheduling_error_message: "لا توجد حقوق جدولة",
        used_to_configure_prefix_suffix_and_incremental_next_number_for_assetid_tooltip: "يتم استخدام هذا لتكوين لاحقة البادئة والرقم التالي المتزايد لمعرف الأصل",
        sales_executive_label: "مدير مبيعات",
        Please_select_sales_executive_error_message: "يرجى تحديد مدير المبيعات",
        Material_content_page_breadcrumb: "محتوى المادة",
        Material_content_sub_menu: "محتوى المادة",
        add_by_column: "تمت الإضافة بواسطة",
        modified_by_column: "تم التعديل بواسطة",
        show_history_button_text: "إظهار السجل",
        Success_download_success_message: "تم التنزيل بنجاح",
        top_5_sales_executive_label: "أفضل 5 مديري مبيعات",
        add_job_url_button_tooltip: "أضف عنوان يو آر إل للوظيفة",
        checklist_preference_label: "تفضيلات قائمة التحقق",
        Select_playback_url_header: "حدد عنوان يو آر إل للتشغيل",
        Duration_mismatch_error_message: "المدة غير متطابقة",
        no_invoice_details_are_available_to_preview_bill_error_message: "لا توجد تفاصيل فاتورة متاحة للمعاينة!",
        Selected_commercial_label: "الإعلان التجاري المحدد",
        no_data_schedule_to_download_error_message: "لا يوجد جدول زمني لتنزيل البيانات",
        from_date_can_not_be_less_than_campaign_start_date_error_message: "من تاريخ لا يمكن أن يكون أقل من تاريخ بدء الحملة",
        to_date_can_not_be_greater_than_campaign_end_date_error_message: "حتى الآن لا يمكن أن يكون أكبر من تاريخ انتهاء الحملة",
        Cancel_invoice_waiting_message: "جارٍ إلغاء الفاتورة، برجاء الانتظار...",
        series_dialog_header: "السلسلة",
        Manage_content_template_breadcrumb: "إدارة قالب المحتوى",
        ottmenu_sub_menu: "القائمة",
        ottmenu_page_breadcrumb: "القائمة",
        Cardlist_pages_menu_title: "الصفحات",
        Select_pages_header_collection: "الصفحات",
        ottmenu_title_editpageheader: "القائمة",
        Sidefixmenu_rails_pages_tooltip: "الصفحات",
        atleast_attach_one_ott_pages_rails_error_message: "إرفاق صفحة واحدة على الأقل",
        Menu_type_label: "نوع القائمة",
        team_a_label: "الفريق أ",
        team_b_label: "الفريق ب",
        round_label: "جولة",
        Bottom_menu_sub_menu: "القائمة السفلية",
        Bottom_menu_page_breadcrumb: "القائمة السفلية",
        top_menu_sub_menu: "القائمة العلوية",
        top_menu_page_breadcrumb: "القائمة العلوية",
        Please_select_asset_type_to_media_asset_error_message: "يُرجى تحديد نوع الأصل لأصول الوسائط",
        multi_versioning_tooltip_button: "الإصدارات المتعددة",
        title_view_tooltip_button: "عرض العنوان",
        Close_title_view_tooltip_button: "إغلاق عرض العنوان",
        Sidefix_episode_tooltip: "الحلقة",
        Please_select_valid_start_date_error_message: "الرجاء تحديد تاريخ بدء صالح",
        Please_select_valid_end_date_error_message: "الرجاء تحديد تاريخ انتهاء صالح",
        Please_select_exclusive_start_date_error_message: "يُرجى تحديد تاريخ البدء الحصري",
        Please_select_exclusive_end_date_error_message: "يُرجى تحديد تاريخ انتهاء حصري",
        Please_select_start_date_smaller_than_end_date_media_episode_publishing_error_message: "يجب أن يكون تاريخ البدء أقل من تاريخ الانتهاء",
        amount_paid_can_not_be_negative_error_message: "لا يمكن أن يكون المبلغ المدفوع سالبًا",
        print_button_tooltip: "طباعة",
        print_telecast_certificate_in_pdf_button_tooltip: "طباعة شهادة البث التلفزيوني بصيغة قوات الدفاع الشعبي",
        print_telecast_certificate_in_excel_button_tooltip: "طباعة شهادة البث التلفزيوني في اكسل",
        Cancel_invoice_button_tooltip: "إلغاء الفاتورة",
        Campagn_type_page_breadcrumb: "نوع الحملة",
        Deal_type_page_breadcrumb: "نوع الصفقة",
        location_page_breadcrumb: "الموقع",
        Campaigntype_sub_menu: "نوع الحملة",
        Dealtype_sub_menu: "نوع الصفقة",
        location_sub_menu: "الموقع",
        ott_setting_sub_menu: "الإعدادات",
        ott_setting_page_breadcrumb: "الإعدادات",
        application_name_label: "اسم التطبيق",
        logo_label: "الشعار",
        logo_position_label: "موضع الشعار",
        pi_page_template_label: "قالب صفحة باي",
        show_bottom_menu_label: "إظهار القائمة السفلية",
        home_page_label: "الصفحة الرئيسية",
        show_hamburger_menu_label: "عرض قائمة الهامبرغر",
        image_cdn_base_url_label: "عنوان يو آر إل الأساسي لصورة ج د ن",
        video_cdn_base_url_label: "عنوان يو آر إل الأساسي لشبكة ج د ن للفيديو",
        image_cdn_credentials_label: "صورة ج د ن كريد",
        video_cdn_credentials_label: "فيديو ج د ن كريد",
        key_name_label: "اسم المفتاح",
        key_value_label: "قيمة المفتاح",
        add_image_cdn_credentials_dialog_header: "إضافة صورة ج د ن كريد",
        add_video_cdn_credentials_dialog_header: "إضافة فيديو ج د ن كريد",
        Please_enter_key_name_error_messgae: "الرجاء إدخال اسم المفتاح",
        Please_enter_key_value_error_message: "الرجاء إدخال قيمة المفتاح",
        settings_label: "الإعدادات",
        Please_enter_application_name_error_message: "الرجاء إدخال اسم التطبيق",
        Please_select_logo_error_message: "الرجاء تحديد الشعار",
        Please_select_logo_position_error_message: "الرجاء تحديد موضع الشعار",
        Please_select_pi_page_template_error_message: "الرجاء تحديد قالب صفحة باي",
        Please_select_home_page_error_message: "الرجاء تحديد الصفحة الرئيسية",
        Please_select_theme_error_message: "الرجاء تحديد الموضوع",
        Please_enter_image_cdn_base_url_error_message: "الرجاء إدخال عنوان يو آر إل الأساسي لصورة ج د ن",
        Please_enter_video_cdn_base_url_error_message: "الرجاء إدخال عنوان يو آر إل الأساسي لشبكة ج د ن للفيديو",
        icon_label: "أيقونة",
        Please_select_icon_error_message: "الرجاء تحديد الرمز",
        Please_select_hamburger_menu_error_message: `يرجى تحديد قائمة الهامبرغر`,
        hamburger_menu_label: "قائمة الهامبرغر",
        Select_package_header: "حدد الحزمة",
        Please_select_package_error_message: "الرجاء تحديد الحزمة",
        vod_type_validation_error_message: `يمكن تطبيق نوع الخامس التطوير التنظيمي المجاني مع أ ف أو د فقط`,
        server_health_sub_menu: "صحة الخادم",
        server_health_page_breadcrumb: "صحة الخادم",
        text_number_can_not_be_negative_error_message: "لا يمكن أن يكون رقم النص سالبًا",
        prelog_postlog_report_sub_menu: "تقرير سجل ما قبل/ما بعد",
        pre_log_report_title_button: "تقرير التسجيل المسبق",
        post_log_report_title_button: "تقرير سجل ما بعد",
        download_pre_log_report_tooltip_button: "تنزيل تقرير السجل المسبق",
        download_post_log_report_tooltip_button: "تنزيل تقرير سجل ما بعد",
        Credit_line_report_sub_menu: "تقرير حد الائتمان",
        download_credit_line_report_tooltip_button: "تنزيل تقرير حد الائتمان",
        Please_select_date_error_message: "الرجاء تحديد التاريخ",
        logo_size_label: "حجم الشعار",
        application_color_label: "لون التطبيق",
        purge_Spot_report_sub_menu: "تقرير تطهير البقعة",
        download_purge_Spot_report_tooltip_button: "تنزيل تقرير تطهير البقعة",
        download_client_agency_booking_report_tooltip_button: "تنزيل تقرير حجز وكالة العميل",
        download_purge_spot_report_tooltip_button: "تنزيل تقرير تطهير البقعة",
        client_agency_booking_report_header: "تقرير حجز وكالة العميل",
        pre_post_log_report_header: "تقرير سجل ما قبل/ما بعد",
        Credit_line_report_header: "تقرير حد الائتمان",
        purge_spot_report_header: "تقرير تطهير البقعة",
        interstitial_history_report_header: "تقرير السجل الخلالي",
        download_interstitial_history_report_tooltip_button: "تنزيل تقرير سجل الإعلانات الخلالية",
        telecast_certificate_details_not_found_error_message: "لم يتم العثور على تفاصيل البث",
        air_time_consumption_report_sub_menu: "تقرير استهلاك وقت الهواء",
        download_air_time_consumption_report_tooltip_button: "تنزيل تقرير استهلاك وقت الهواء",
        air_time_consumption_report_header: "تقرير استهلاك وقت الهواء",
        Prototypecontent_sub_menu: "محتوى النموذج الأولي",
        Prototypecontent_page_breadcrumb: "محتوى النموذج الأولي",
        create_prototypecontent_dialog_header: "إنشاء محتوى النموذج الأولي",
        Please_enter_max_length_error_message: "الرجاء إدخال الحد الأقصى للطول",
        manual_prototype_id_label: "المعرف اليدوي",
        Prototype_id_label: "المعرف",
        error_while_geneating_prototype_number_error_message: "حدث خطأ أثناء إنشاء رقم النموذج الأولي",
        Refresh_generated_segments_tooltip: "تحديث المقاطع التي تم إنشاؤها",
        generator_segments_selected_segmentType_mismatch_error_message: "عدد المقاطع التي تم إنشاؤها ليس نفس نوع الشريحة المحددة",
        MaterialID_mediaID_mismatch_generated_segment_error_message: "معرف المادة ليس هو نفسه معرف الوسائط في المقطع الذي تم إنشاؤه، يرجى التحديث",
        Please_select_subtitle_type_error_message: "الرجاء تحديد نوع الترجمة",
        number_of_generated_segments_is_not_same_as_selected_segment_Type_error_message: "عدد المقاطع التي تم إنشاؤها ليس نفس نوع القطعة المحددة",
        Select_material_content_first_error_message: "حدد محتوى المادة أولاً",
        section_already_exist_with_same_material_id_and_segment_type_error_message: "القسم موجود بالفعل بنفس معرف المادة ونوع المقطع",
        amazon_delivery_group_page_breadcrumb: "مجموعة توصيل أمازون",
        amazon_delivery_group_sub_menu: "مجموعة توصيل أمازون",
        amazon_delivery_group_edit_page_header: "مجموعة توصيل أمازون",
        tv_preview_label: "معاينة التلفاز",
        mobile_preview_label: "معاينة الجوال",
        ditribute_by_percentage_label: "التوزيع حسب %",
        ditribute_by_percentage_error_message: "يجب أن يكون مجموع التوزيع التجاري المحدد 100",
        Select_commercial_for_booking_error_message: "يُرجى تحديد إعلان تجاري واحد على الأقل للحجز",
        Distribute_selected_equal_lable: "توزيع المحدد بالتساوي",
        feature_label: "الميزات",
        Select_Secondary_event_error_message: "حدد حدثًا ثانويًا أولاً",
        delete_Secondary_event_tooltip: "حذف الحدث الثانوي المحدد",
        Select_campaign_header_dialog: "اختر حملة",
        Select_pages_header_dialog: "تحديد الصفحات",
        Display_name_column: "اسم العرض",
        Spot_separation_label: "فصل البقعة",
        Please_enter_valid_spot_separation_error_message: "الرجاء إدخال فصل صحيح للبقعة",
        ott_package_delivery_schedule_menu: "جدول تسليم طرود أوت",
        Service_menu: "الخدمة",
        ott_package_delivery_schedule_page_breadcrumb: "جدول تسليم طرود أوت",
        table_delivery_button_tooltip: "جدول التسليم",
        table_delivery_button_text: "جدول التسليم",
        schedul_delivered_successously_success_message: "تم تسليم الجدول بنجاح",
        table_auto_fill_interstitial_page_breadcrumb: "جدولة الملء التلقائي للإعلان البيني",
        table_auto_fill_interstitial_sub_menu: "جدولة الملء التلقائي للإعلان البيني",
        table_auto_fill_interstitial_edit_page_header: "جدولة الملء التلقائي للإعلان البيني",
        interstitial_label: "الإعلان البيني",
        filler_label: "الحشو",
        music_label: "موسيقى",
        new_subscriber_in_week_label: "المشتركون الجدد في الأسبوع",
        no_pack_users_label: "لا يوجد مستخدمون للحزم",
        users_subscription_expiring_in_current_week_label: "تنتهي صلاحية المستخدم في الأسبوع",
        user_by_plan_label: "المستخدم حسب الخطة",
        media_asset_label: "أصول الوسائط",
        vod_label: "الخامس التطوير التنظيمي",
        dummy_page_breadcrumb: "دمية",
        dummy_sub_menu: "دمية",
        ref_attach_formats_label: "تنسيق الإرفاق",
        format_attached_success_message: "تم إرفاق التنسيق بنجاح",
        ref_delete_formats_label: "حذف جميع التنسيقات",
        formats_deleted_success_message: "تم حذف جميع التنسيقات بنجاح",
        Insert_break_label: "إدراج فاصل",
        Slot_duration_label: "مدة الفتحة",
        Please_enter_slot_duration_error: "الرجاء إدخال مدة الفترة الزمنية",
        actual_duration_slot_duration_format_error_message: "لا يمكن أن تكون المدة الفعلية أكبر من مدة الفاصل الزمني",
        Total_amount_is_smaller_than_amount_profit_error_message: "إجمالي المبلغ أقل من المبلغ المدفوع",
        is_dummy_label: "دمية",
        downloading_log_report_label: "تنزيل تقرير السجل",
        bill_generate_label: "إنشاء فاتورة",
        Contract_run_report_button_tooltip: "تقرير تشغيل العقد",
        Contract_run_report_label: "تقرير تشغيل العقد",
        Total_run_column: "إجمالي التشغيل",
        Preview_button_tooltip: "معاينة",
        Preview_image_title_label: "صورة المعاينة",
        Poster_dimension_title_label: "أبعاد الملصق",
        show_poster_dimension_title_label: "إظهار أبعاد الملصقات",
        mam_asset_report_sub_menu: "تقرير أصول مام",
        mam_asset_report_page_breadcrumb: "تقرير أصول مام",
        table_duration_column: "مدة الجدول الزمني",
        mam_duration_column: "مدة Mam",
        Total_column: "الإجمالي",
        schudule_column: "الجدول الزمني",
        hanging_colun: "معلق",
        Tomorrow_pending_booking_status_label: "حالة الحجز المعلق غدًا",
        pending_approval_sun_menu: "في انتظار الموافقة",
        hanging_approval_page_breadcrumb: "في انتظار الموافقة",
        approve_button_text: "موافقة",
        Deject_button_text: "رفض",
        booking_status_updated_successously: "تم تحديث حالة الحجز بنجاح",
        Total_segment_duration_lable: "إجمالي مدة المقطع",
        Other_label: "أخرى",
        comment_label: "تعليق",
        Please_enter_comment_error_message: "الرجاء إدخال التعليق",
        unpurged_label: "غير مطهر",
        Please_add_deeplink_in_video_list_error_message: "الرجاء إضافة رابط عميق في قائمة مقاطع الفيديو",
        Please_attach_atleast_one_video_error_message: "الرجاء إرفاق فيديو واحد على الأقل",
        Please_attach_atleast_one_poster_error_message: "يرجى إرفاق ملصق واحد على الأقل",
        Deeplink_url_label: "عنوان يو آر إل للرابط العميق",
        rent_wholesale_price_label: "سعر الإيجار بالجملة",
        rent_retail_price_label: "سعر الإيجار بالتجزئة",
        actual_on_air_column: "فعلي على الهواء",
        nominal_on_air_column: "الاسمي على الهواء",
        parent_series_code_label: "رمز السلسلة الأصلية",
        series_code_label: "رمز السلسلة",
        Duration_only_label: "المدة",
        reference_code_label: "الرمز المرجعي",
        Material_type_column: "نوع المادة",
        Break_configuration_page_breadcrumb: "فاصل التكوين",
        Break_configuration_sub_menu: "فصل التكوين",
        create_break_configuration_dialog_header: "إنشاء تكوين فاصل",
        Please_select_atleast_one_allow_media_category_type_error_message: "يُرجى تحديد نوع واحد على الأقل من فئة الوسائط المسموح بها",
        Please_select_atleast_one_day_error_message: "يرجى تحديد يوم واحد على الأقل",
        Please_enter_from_time_label: "الرجاء الدخول من الوقت",
        Please_enter_to_time_label: "الرجاء إدخال الوقت",
        fct_should_be_greater_than_zero_error_message: "يجب أن يكون واو سي تي أكبر من الصفر",
        from_time_should_be_less_than_To_time_error_message: "من الوقت يجب أن يكون أقل من الوقت",
        to_date_should_be_greater_than_from_date_error_message: "يجب أن يكون تاريخ أكبر من تاريخ",
        fct_already_exists_error_message: "واو سي تي موجود بالفعل في نفس القناة/النطاق الزمني/الأيام",
        fct_should_not_be_greater_than_campaign_target_thans_error_message: "واو سي تي يجب ألا يكون أكبر من الثواني المستهدفة للحملة",
        sort_by_label: "فرز حسب",
        billing_summary_report_sub_menu: "تقرير ملخص الفواتير",
        no_scheduling_found_auto_fill_commercial_error: "لم يتم العثور على جدولة",
        no_break_item_found_auto_fill_commercial_error: "لم تتم جدولة عناصر فاصل في هذا اليوم",
        no_booked_spot_found_auto_fill_commercial_error: "الأماكن المحجوزة غير متوفرة",
        save_bill_button_text: "حفظ الفاتورة",
        save_bill_button_tooltip: "حفظ الفاتورة",
        Preview_button_text: "معاينة",
        parent_series_lable: "السلسلة الأصلية",
        ott_setting_label: "إعداد OTT",
        Bottom_menu_label: "القائمة السفلية",
        series_only_label: "السلسلة",
        add_insert_break_label: "إضافة فاصل إدراج",
        playlist_lock_status_sub_menu: "حالة قفل قائمة التشغيل",
        playlist_lock_page_breadcrumb: "حالة قفل قائمة التشغيل",
        generator_pdf_message: "يُرجى الانتظار حتى يتم إنشاء ملف قوات الدفاع الشعبي...",
        generator_pdf_successously_message: "تم إنشاء ملف قوات الدفاع الشعبي بنجاح",
        Payment_received_label: "تم استلام الدفعة",
        Payment_received_button_tooltip: "تم استلام الدفعة",
        Payment_received_button_text: "تم استلام الدفعة",
        print_button_text: "طباعة",
        to_txt_button_toolip: "إلى رسالة قصيرة",
        to_txt_button_text: "إلى رسالة قصيرة",
        pdf_button_text: "قوات الدفاع الشعبي",
        excel_button_text: "إكسل",
        Received_date_label: "تاريخ الاستلام",
        Payment_mode_label: "وضع الدفع",
        check_no_label: "التحقق من الرقم",
        Payment_received_successously: "تم استلام الدفعة بنجاح",
        is_paymnet_received_column: "هل تم استلام الدفعة",
        Payment_received_date_column: "تاريخ استلام الدفعة",
        Payment_mode_column: "وضع الدفع",
        cheque_no_column: "رقم الشيك",
        Payment_already_received_error_message: "تم استلام الدفعة بالفعل",
        Please_select_received_date_error_message: "الرجاء تحديد تاريخ الاستلام",
        Please_select_Payment_mode_error_message: "يرجى تحديد وضع الدفع",
        Please_enter_cheque_no_error_message: "الرجاء إدخال رقم التحقق",
        booking_commercial_label: "حجز تجاري",
        booking_announcement_label: "إعلان محجوز",
        announcement_label: "الإعلانات",
        Export_commercial_break_playlist_button_tooltip: "تصدير قائمة تشغيل الفواصل التجارية",
        Credit_line_report_page_breadcrumb: "تقرير حد الائتمان",
        Brand_column: "العلامة التجارية",
        time_range_column: "النطاق الزمني",
        schedul_spot_column: "جدول زمني",
        Total_duration_column: "المدة الإجمالية",
        booking_schedule_status_header: "حالة جدول الحجز",
        no_data_found_for_selected_filter_error_message: "لم يتم العثور على بيانات للمرشحات المحددة!",
        Artist_label: "فنان",
        Please_enter_artist_error_message: "الرجاء إدخال الفنان",
        announcement_reconcile_sun_menu: "تسوية الإعلان",
        announcement_reconcile_page_breadcrumb: "تسوية الإعلان",
        Edit_header_dialog: "تحرير",
        actual_on_air_label: "الفعلية على الهواء",
        reconciled_successously_message: "تمت التسوية بنجاح",
        reconcile_label: "التسوية",
        Please_enter_actualonair_error_message: "الرجاء إدخال الفعلية على الهواء",
        Please_select_atleast_one_saleteam_error_message: "يرجى تحديد فريق مبيعات واحد على الأقل",
        Export_announcement_tooltip: "إعلان التصدير",
        export_jazzler_automation_playlist: "تصدير فاصل تجاري لجازلر",
        point_of_contact_label: "نقطة الاتصال",
        Please_enter_point_of_contact_error_message: "الرجاء إدخال نقطة الاتصال",
        Please_enter_pin_code_error_message: "الرجاء إدخال الرمز السري",
        epg_menu: "دليل البرامج الإلكتروني",
        epg_channel_sub_menu: "القنوات",
        epg_channel_page_breadcrumb: "القنوات",
        create_channel_dialog_header: "إنشاء قناة",
        Please_enter_image_url_error_message: "الرجاء إدخال عنوان يو آر إل للصورة",
        faq_category_page_breadcrumb: "فئة الأسئلة الشائعة",
        faq_category_sub_menu: "فئة الأسئلة الشائعة",
        faq_page_breadcrumb: "الأسئلة الشائعة",
        faq_sub_menu: "الأسئلة الشائعة",
        Please_select_faq_Category_error_message: "يرجى تحديد الفئة",
        faq_category_label: "فئة الأسئلة الشائعة",
        question_label: "سؤال",
        Answer_label: "الإجابة",
        Please_enter_question_error_message: "الرجاء إدخال السؤال",
        Please_enter_answer_error_message: "الرجاء إدخال الإجابة",
        Select_a_category_column: "حدد فئة",
        faqs_column: "الأسئلة الشائعة",
        faqs_dailog_header: "الأسئلة الشائعة",
        faqs_page_breadcrumb: "الأسئلة الشائعة",
        top_news_menu: "أهم الأخبار",
        top_news_page_breadcrumb: "أهم الأخبار",
        Favorite_channel_sub_menu: "القناة المفضلة",
        Favorite_channel_page_breadcrumb: "القناة المفضلة",
        create_favorite_channel_dialog_header: "إنشاء قناة مفضلة",
        logo_column: "الشعار",
        Please_select_atleast_one_channel_error_message: "يرجى تحديد قناة واحدة على الأقل",
        Tutorial_videos_page_breadcrumb: "مقاطع فيديو تعليمية",
        Tutorial_videos_sub_menu: "مقاطع فيديو تعليمية",
        Summary_label: "ملخص",
        playback_url_label: "عنوان يو آر إل للتشغيل",
        create_tutorial_videos_dialog_header: "إنشاء مقاطع فيديو تعليمية",
        Please_enter_summary_error_message: "الرجاء إدخال الملخص",
        Please_enter_playback_url_error_message: "الرجاء إدخال عنوان يو آر إل للتشغيل",
        create_top_news_dialog_header: "إنشاء أهم الأخبار",
        source_id_label: "معرف المصدر",
        feature_image_url_label: "عنوان يو آر إل للصورة المميزة",
        image_caption_label: "تعليق الصورة",
        time_stamp_label: "الطابع الزمني",
        pull_latest_top_news_button_tooltip: "اطلع على آخر الأخبار المهمة",
        thumbnail_url_label: "عنوان يو آر إل المصغر",
        Please_enter_thumbnail_url_error_message: "الرجاء إدخال عنوان يو آر إل للصورة المصغرة",
        Please_enter_source_id_error_message: "الرجاء إدخال معرف المصدر",
        Please_enter_image_caption_error_message: "الرجاء إدخال تسمية توضيحية للصورة",
        header_address_label: "عنوان الرأس",
        footer_address_label: "عنوان التذييل",
        ok_label: "موافق",
        session_expired_please_login_again_label: "انتهت الجلسة. الرجاء تسجيل الدخول مرة أخرى",
        Please_select_episodes_first: `يرجى تحديد الحلقات أولاً`,
        Success_saved_updated_message: "تم الحفظ/التحديث بنجاح !!!",
        Please_select_all_platforms_message: "يُرجى تحديد كافة المنصات لتغيير الموضع",
        Please_book_spots_within_campaign_date_message: "يُرجى حجز الأماكن ضمن النطاق الزمني للحملة: ",
        invalid_file_format: `تنسيق ملف غير صالح`,
        import_already_in_progress: "الاستيراد قيد التقدم بالفعل. تم إحباط العملية",
        valid_template_file: "ملف القالب غير صالح!!",
        date_time_houseNumber_column_is_mandatory: "عمود التاريخ والوقت ورقم المنزل إلزامي في ملف الاستيراد",
        Commercial_used_in_booking_cannot_change_duration_message: "لا يمكن تغيير المدة التجارية المستخدمة في الحجز !!",
        Please_enter_team: `الرجاء إدخال الفريق`,
        Please_select_round_error: "يرجى تحديد الجولة",
        Please_select_start_date_between_tournament_date_range_error: `يرجى تحديد تاريخ البدء بين نطاق تاريخ البطولة`,
        match_scheduled_successful_message: "تم جدولة المباراة بنجاح !!",
        some_spots_are_reconciled_bill_generated_selected_spots: `تمت تسوية بعض النقاط أو إنشاء فاتورة في المواقع المحددة`,
        media_master_report_sub_menu: "تقرير الوسائط الرئيسية",
        media_master_report_page_breadcrumb: "تقرير الوسائط الرئيسية",
        video_column: "فيديو",
        product_column: "المنتج",
        data_load_successful_message: "تم تحميل البيانات بنجاح",
        Please_enter_address_error_message: "الرجاء إدخال العنوان",
        target_thans_should_be_greater_then_zero_error_message: "ثواني الهدف يجب أن تكون أكبر من الصفر",
        Missing_seasone_detail_form_error_message: "تفاصيل الموسم مفقودة",
        ott_menu: "OTT",
        Manage_content_menu: "إدارة المحتوى",
        to_do_column: "المهام الواجبة",
        in_progress_column: "قيد التقدم",
        Done_column: "تم",
        Work_order_button_tooltip: "أمر العمل",
        show_spots_button_tooltip: "إظهار النقاط",
        show_spots_button_text: "إظهار المواقع",
        save_and_create_work_order_button_tooltip: "حفظ وإنشاء أوامر العمل",
        save_and_create_work_order_button_text: "حفظ أمر العمل",
        Planning_prime_time_sub_menu: "التخطيط لوقت الذروة",
        Breaks_label: "فترات الاستراحة",
        add_line_button_tooltip: "إضافة سطر",
        add_line_button_text: "إضافة سطر",
        perday_label: "لكل يوم",
        perweek_label: "لكل أسبوع",
        trp_label: "الحزب الراديكالي الراديكالي",
        booking_yearly_sub_menu: "الحجز السنوي",
        booking_yearly_page_breadcrumb: "الحجز السنوي",
        days_of_week_column: "أيام الأسبوع",
        edit_multiple_button_text: "تحرير المتعدد",
        delete_multiple_button_tooltip: "حذف متعدد",
        delete_multiple_button_text: "حذف عدة",
        notifications_label: "الإعلانات",
        Record_commercial_label: "إعلان تجاري مسجل",
        read_outs_column: "القراءات",
        scripts_column: "البرامج النصية",
        booking_status_column: "حالة الحجز",
        asset_id_column: "معرف الأصل",
        delete_strand_label: "حذف ستراند",
        delete_strand_items_confirm_message: "حذف عناصر السلسلة",
        press_yes_to_delete_all_the_strand_from_the_selected_slot_onwards_confirm_message: "اضغط على YES لحذف كل الخصلات من الفتحة المحددة فصاعدًا",
        show_media_label: "إظهار الوسائط",
        lock_unlock_label: "القفل/فتح القفل",
        show_exhibitions_label: "إظهار المعارض",
        expand_all_breaks_label: "توسيع كافة الفواصل",
        mnimize_all_breaks_label: "تصغير كافة فترات الراحة",
        Please_select_atleast_one_days_error_message: "يرجى تحديد يوم واحد على الأقل",
        session_time_out_label: "انتهت مهلة الجلسة",
        Please_enter_session_time_out_error_message: "الرجاء إدخال مهلة الجلسة",
        session_time_out_should_be_greater_than_one_hour_error_message: "يجب أن تكون مهلة الجلسة أكبر من ساعة واحدة",
        Non_reconciled_spot_column: "المواقع غير التوفيقية",
        time_in_should_be_less_than_time_out_error_message: "يجب أن يكون وقت الدخول أقل من المهلة",
        Promotional_screens_sub_menu: "الشاشات الترويجية",
        Promotional_screens_page_breadcrumb: "الشاشات الترويجية",
        Marketing_screens_sub_menu: "شاشات التسويق",
        Marketing_screens_page_breadcrumb: "شاشات التسويق",
        Frequency_type_label: "نوع التردد",
        Frequency_label: "التردد",
        Enable_label: "تمكين",
        Marketing_screens_editpageheader: "شاشات التسويق",
        Promotional_screens_editpageheader: "الشاشات الترويجية",
        Frequency_should_be_greater_than_zero_error_message: "يجب أن يكون التردد أكبر من الصفر",
        Verbiage_key_label: "إسهاب",
        access_level_label: "مستوى الوصول",
        ottcampaign_label: "حملة أوت",
        ott_campaign_dialog_header: "الحملة",
        successfully_add_campaign_message: "تم إضافة الحملة بنجاح",
        Rail_is_already_attach_in_selected_campaign_info_message: "تم إرفاق السكك الحديدية بالفعل في الحملة المحددة",
        deattach_ott_campaign_dialog_header: "حملة إلغاء المرفقات",
        deattach_successously_message: "تم الفصل بنجاح",
        Confirm_deattach_label: "تأكيد الانفصال",
        are_you_sure_do_you_want_to_deattach_campaign_label: "هل أنت متأكد من رغبتك في فصل الحملة",
        ott_camapign_status_label: "حالة الحملة",
        Exploit_label: "انتهت الصلاحية",
        Rails_dialog_header: "القضبان",
        Please_select_provider_error_message: "الرجاء تحديد الموفر",
        are_you_sure_do_you_want_to_deattach_rail_label: "هل أنت متأكد أنك تريد فصل السكك الحديدية",
        Rail_is_already_attach_in_selected_page_info_message: "تم إرفاق السكك الحديدية بالفعل في الصفحة المحددة",
        successfully_add_rails_message: "تم إضافة القضبان بنجاح",
        Provider_sub_menu: "المزود",
        Provider_page_breadcrumb: "الموفر",
        logourl_label: "عنوان يو آر إل للشعار",
        Please_enter_logourl_error_message: "الرجاء إدخال عنوان يو آر إل للشعار",
        Please_select_at_least_one_product_error_message: "يرجى تحديد منتج واحد على الأقل",
        Products_label: "المنتجات",
        active_ottcampaign_label: "حملة نشطة",
        Total_active_subscriber_label: "إجمالي المشتركين النشطين",
        Preview_menu: "معاينة",
        Module_sub_menu: "الوحدة النمطية",
        Module_page_breadcrumb: "الوحدة النمطية",
        path_label: "المسار",
        create_module_header_dialog: "إنشاء وحدة",
        Select_product_header_dialog: "اختر المنتج",
        Success_add_product_succes_message: "تم إضافة المنتج بنجاح",
        Campaign_prefix_label: "بادئة الحملة",
        Please_enter_campaign_prefix_error_message: "الرجاء إدخال بادئة الحملة",
        Please_enter_valid_release_year_error_message: "الرجاء إدخال سنة إصدار صالحة!",
        Traffic_sub_menu: "حركة المرور",
        adSales_sub_menu: "مبيعات الإعلانات",
        curate_sub_menu: "تنظيم",
        monetize_sub_menu: "تحقيق الدخل",
        sms_sub_menu: "الرسائل القصيرة",
        Couponing_sub_menu: "القسيمة",
        print_pdf_button_tooltip: "طباعة ملف قوات الدفاع الشعبي",
        Please_enter_code: "الرجاء إدخال الرمز",
        External_description_label: "الوصف الخارجي",
        Alternative_description_label: "الوصف البديل",
        Please_select_access_level_error_message: "الرجاء تحديد مستوى الوصول",
        Company_setting_label: "إعدادات الشركة",
        bill_label: "فاتورة",
        Success_saved_message: "تم الحفظ بنجاح",
        export_edi_format_label: "تنسيق EDI للتصدير",
        do_you_want_print_campaign_billing_lines_label: "هل تريد طباعة خطوط فواتير الحملة؟",
        Cancel_invoice_label: "إلغاء الفاتورة",
        do_you_want_cancel_this_invoice_label: "هل تريد إلغاء هذه الفاتورة؟",
        Please_wait_cancel_invoice_message: "يرجى الانتظار لإلغاء الفاتورة...",
        Please_select_menu_type_error_message: "الرجاء تحديد نوع القائمة",
        is_parent_menu_label: "عنصر القائمة الرئيسية",
        submenu_label: "القائمة الفرعية",
        Please_select_sub_menu_error_message: "الرجاء تحديد القائمة الفرعية",
        warning_label: "تحذير",
        user_channel_warning_message: "لا توجد حقوق قناة مرتبطة بهذا المستخدم. هل تريد المتابعة؟",
        Financial_year_page_breadcrumb: "السنة المالية",
        sales_target_page_breadcrumb: "هدف المبيعات",
        Financial_year_dialog_header: "إنشاء سنة مالية",
        sales_target_dialog_header: "إنشاء هدف المبيعات",
        Financial_year_sub_menu: "السنة المالية",
        sales_target_sub_menu: "هدف المبيعات",
        Financial_year_label: "السنة المالية",
        Quarter_label: "ربع",
        Please_select_financial_year_error_message: "يرجى تحديد السنة المالية",
        Please_enter_target_error_message: "الرجاء إدخال الهدف",
        please_select_quarter_error_message: "يرجى تحديد ربع السنة",
        Please_update_target_details_error_message: "يرجى تحديث تفاصيل الهدف",
        Please_update_target_wrong_distribution_error_message: "يجب أن يكون الهدف مساويًا للأهداف الموزعة",
        target_details_label: "تفاصيل الهدف",
        sales_target_achived_label: "هدف مديري المبيعات / تم تحقيق الهدف",
        Total_target_label: "إجمالي الهدف:",
        Distributed_target_label: "الهدف الموزع:",
        Please_enter_assetid_error_message: "الرجاء إدخال معرف الأصل",
        end_time_should_be_greater_than_start_time_error_message: "يجب أن يكون وقت الانتهاء أكبر من وقت البدء",
        Please_select_vod_type_validation_error_message: "الرجاء تحديد نوع الخامس التطوير التنظيمي",
        sum_of_percentages_should_be_100_error_message: "يجب أن يكون مجموع النسب المئوية 100",
        Campaign_actionbutton_option: "الحملات",
        coming_label: "قادم",
        Select_ott_assets_header_dialog: "حدد أصول OTT",
        ott_assets_label: "أصول أوت",
        fast_segmentation_actionbutton_menutext: "التقسيم السريع",
        is_negative_asrun_diff_label: "فرق أسرون السلبي",
        ott_enabled_label: "تم تمكين أوت",
        create_provider_dialog_header: "إنشاء موفر",
        Insert_dummy_label_planning: "إدراج دمية",
        Please_enter_duration: "الرجاء إدخال المدد",
        sum_of_entered_duration_should_be_less_then_or_equal_to_media_duration: "يجب أن يكون مجموع المدد المدخلة أقل من مدة الوسائط أو يساويها",
        Please_select_area_on_planner_to_insert_dummy_planning_performance_error_message: "يرجى تحديد منطقة في المخطط لإدخال دمية",
        Insert_dummy_dialog_title: "إدراج دمية",
        edit_dummy_actionbutton_menutext: "تحرير الدمية",
        upload_fail_error_message: "فشل التحميل",
        replace_actionbutton_menutext: "استبدال",
        media_not_valid_for_selected_channel_error_message: "الوسائط غير صالحة للقناة المحددة",
        replacement_media_lost_error_message: "فقدت الوسائط البديلة",
        are_you_sure_you_want_to_logout: "هل أنت متأكد من أنك تريد تسجيل الخروج؟",
        translate_dialog_header: "ترجمة",
        text_area_label: "منطقة النص",
        translate_button_name: "ترجمة",
        Missing_google_api_code_error_message: "رمز جوجل واجهة برمجة التطبيقات مفقود",
        Please_enter_text_area_first_error_message: "الرجاء إدخال منطقة النص أولاً",
        Please_translate_first_error_message: "الرجاء الترجمة أولاً",
        Confirm_saved_label: "تأكيد الحفظ",
        changes_you_made_may_not_be_saved_label: "قد لا يتم حفظ التغييرات التي أجريتها.",
        Sign_in_label: "تسجيل الدخول",
        username_login_label: "اسم المستخدم",
        password_login_label: "كلمة المرور",
        Please_enter_user_name_login_label: "الرجاء إدخال اسم المستخدم",
        enter_your_password_login_label: "أدخل كلمة المرور الخاصة بك",
        login_lable: "تسجيل الدخول",
        Material_id_and_media_id_mismatch_please_re_generate_segments_first_error_message: "معرف المادة ومعرف الوسائط غير متطابقين، يرجى إعادة إنشاء المقاطع أولاً!",
        Please_enter_material_id_error_message: "الرجاء إدخال معرف المادة",
        Poster_note_image_size_label: "ملاحظة: حجم الصورة أقل من 1 ميجا بايت",
        Entry_already_exists_in_system_for_same_prefix_and_suffix_error_message: "الإدخال موجود بالفعل في النظام لنفس البادئة.",
        Loop_till_selected_end_date: "ملاحظة: تحقق من التكرار حتى تاريخ الانتهاء المحدد",
        Please_select_material_content_error_message: "الرجاء تحديد محتوى المادة",
        document_page_breadcrumb: "مستند",
        document_sub_menu: "المستند",
        document_type_label: "نوع المستند",
        Please_select_document_type_error_message: "الرجاء تحديد نوع المستند",
        Please_enter_doc_error_message: "الرجاء إدخال المستند",
        create_Document_dialog_header: "إنشاء مستند",
        upload_documents_label: "تحميل مستند",
        doc_label: "وثيقة",
        Please_upload_documents_error_message: "الرجاء تحميل المستندات",
        delete_selected_label: "حذف المحدد",
        delete_slot_and_push_forward_in_the_strand_label: "حذف الفتحة والدفع للأمام في الشريط",
        delete_slot_and_pull_backward_in_the_strand_label: "احذف الحلقة واسحب للخلف في الشريط",
        delete_all_the_events_forward_in_the_strand_label: "احذف جميع الأحداث التي تم تقديمها في السلسلة",
        delete_episode_in_future_from_selected_slot_forward_label: "احذف الحلقة في المستقبل من الفتحة المحددة للأمام",
        to_enable_other_options_select_only_one_item_label: "لتمكين الخيارات الأخرى، حدد عنصرًا واحدًا فقط.",
        Selected_item_should_be_episode_planning_item_error_message: "التكرار مخصص لفئة وسائط الحلقة فقط.",
        Selected_item_already_part_of_another_strand_error_message: "العنصر المحدد جزء من خيط آخر",
        Select_documents_header_dialog: "تحديد المستندات",
        Revenue_share_label: "حصة الإيرادات",
        Revenue_share_should_be_negative_error_message: "حصة الإيرادات يجب أن تكون سلبية",
        Revenue_share_column: "حصة الإيرادات",
        screen_saver_page_breadcrumb: "شاشة التوقف",
        screen_saver_sub_menu: "شاشة التوقف",
        screen_saver_editpageheader: "شاشة التوقف",
        old_value_label: "القيمة القديمة",
        new_value_label: "قيمة جديدة",
        show_changes_label: "إظهار التغييرات",
        Planning_slot_sub_menu: "فتحة التخطيط",
        Planning_slot_page_breadcrumb: "فتحة التخطيط",
        timerangefrom_should_be_greater_then_zero: "النطاق الزمنيمن يجب أن يكون أكبر من الصفر",
        timerangefrom_should_be_less_then_timerangeto: "النطاق الزمنيمن يجب أن يكون أقل من النطاق الزمني",
        timerangeTo_should_be_greater_then_zero: "يجب أن يكون النطاق الزمنيأكبر من الصفر",
        show_details_column: "إظهار التفاصيل",
        show_all_label: "إظهار الكل",
        isImportable_label: "قابل للاستيراد",
        valid_file_error_message: "الملف المحدد غير صالح",
        Enable_filter_label: "تمكين عامل التصفية",
        Rails_label: "القضبان",
        Promotional_page_page_breadcrumb: "الصفحة الترويجية",
        Promotional_page_sub_menu: "الصفحة الترويجية",
        slug_label: "سبيكة",
        Thumb_img_label: "صورة مصغرة",
        ban_img_label: "صورة البانر",
        app_img_label: "صورة التطبيق",
        tag_label: "العلامات",
        show_buy_button_label: "إظهار زر الشراء",
        show_in_app_label: "إظهار داخل التطبيق",
        Please_enter_slug_error_message: "الرجاء إدخال سبيكة ثابتة",
        Promotional_page_editpageheader: "الصفحة الترويجية",
        comma_seprated_value_should_be_enter_label: "يجب إدخال القيمة المفصولة بفواصل",
        Please_enter_next_number_error_message: "يجب أن يكون الرقم التالي أكبر من 0",
        Please_enter_number_length_error_message: "يجب أن يكون طول الرقم أكبر من 0",
        generator_button_tooltip: "تنزيل TC في اكسل",
        generator_xml_message: "الرجاء انتظار إنشاء ملف اكسل...",
        create_new_button_label: "إنشاء جديد",
        rating_label: "التقييم",
        Please_enter_rated_error_message: "الرجاء إدخال التقييم بين 1 - 10",
        Sponsor_type_page_breadcrumb: "نوع الراعي",
        ponder_type_sub_menu: "نوع الراعي",
        note_for_sponsor_type_select_null_label: "ملاحظة: يجب أن يكون التقييم بين 1-10",
        Please_enter_sponsor_type_error_message: "الرجاء إدخال نوع الراعي",
        Sponsor_type_label: "نوع الراعي",
        Please_enter_currency_error_message: "يرجى تحديد العملة",
        default_currency_label: "العملة الافتراضية",
        web_assets_sub_menu: "أصول الويب",
        web_assets_page_breadcrumb: "أصول الويب",
        web_assets_page_editpageheader: "أصول الويب",
        web_assets_label: "أصول الويب",
        logs_label: "السجلات",
        Enable_audit_log_label: "تمكين سجل التدقيق",
        Please_select_web_assets_error_message: "الرجاء تحديد أصول الويب",
        Select_web_assets_dialog_header: "حدد أصول الويب",
        Select_media_dialog_header: "حدد الوسائط",
        create_new_button_tooltip: "إنشاء جديد",
        create_new_button_text: "إنشاء جديد",
        Select_rule_label: "حدد عامل التصفية",
        from_date_should_be_less_then_to_date_error_message: "من التاريخ يجب أن يكون أقل من حتى الآن",
        show_repeat_pattern_detail_tooltip: "إظهار تفاصيل نمط التكرار",
        Please_select_repeat_pattern_error_message: "الرجاء تحديد تكرار النمط أولاً",
        account_name_label: "اسم الحساب",
        Bank_name_label: "اسم البنك",
        account_number_label: "رقم الحساب",
        Swift_code_label: "الرمز السريع",
        iban_number_label: "رقم إيبان",
        Branch_label: "فرع",
        Bank_details_label: "تفاصيل البنك",
        Hero_banner_mobile_label: "راية البطل متحرك",
        Hero_banner_tv_label: "تلفزيون راية البطل",
        Square_label: "مربع",
        Circle_label: "دائرة",
        Landscape_label: "منظر طبيعي",
        Partner_ingestion_media_deal_right_confirmation_message: "هل أنت متأكد من أنك تريد استيراد الوسائط دون حقوق الصفقة؟؟",
        no_internet_connection_please_check_your_connection_and_try_again_label: "لا يوجد اتصال بالإنترنت. يرجى التحقق من الاتصال والمحاولة مرة أخرى.",
        There_is_no_product_signed_to_your_company_kindly_contact_team_BMS_label: "لا يوجد منتج مخصص لشركتك، يرجى الاتصال بفريق نظام إدارة المباني",
        you_dont_have_any_module_access_please_contact_your_admin_label: `ليس لديك أي وصول إلى الوحدة، يرجى الاتصال بالمسؤول لديك`,
        show_break_only_label: "إظهار الفاصل فقط",
        lock_by_label: "مقفل بواسطة",
        auto_plot_interstitial_label: "الرسم البيني التلقائي",
        show_logs_label: "إظهار السجلات",
        default_label: "افتراضي",
        from_default_label: "من الافتراضي",
        update_successful_label: "تم التحديث بنجاح",
        show_provider_label: "إظهار الموفر",
        show_censer_ating_label: "عرض تقييم الرقيب",
        show_episode_no_label: "عرض رقم الحلقة",
        pi_page_setting_sub_menu: "إعداد صفحة Pi",
        pi_page_setting_page_breadcrumb: "إعداد صفحة Pi",
        pi_label: "إعداد PI",
        seo_label: "إعدادات تحسين محركات البحث",
        meta_tag_label: "علامة التعريف",
        meta_robot_label: "ميتا روبوت",
        meta_googlebot_label: "ميتا جوجل بوت",
        pi_page_setting_page_editpageheader: "إعداد صفحة Pi",
        show_description_label: "إظهار الوصف",
        show_synopsis_label: "إظهار تسمية الملخص",
        show_production_year_label: "عرض سنة الإنتاج",
        show_pg_rated_label: "إظهار تقييم ص",
        show_cast_and_crew_label: "عرض الممثلين وطاقم العمل",
        show_language_label: "إظهار اللغة",
        show_genre_label: "إظهار النوع",
        show_season_no_label: "عرض رقم الموسم",
        meta_title_label: "عنوان التعريف",
        meta_description_label: "وصف التعريف",
        Select_Field_tooltip: "اختر حقل",
        Screenshot_label: "لقطة الشاشة",
        theme_sub_menu: "الموضوع",
        theme_page_breadcrumb: "الموضوع",
        cta_details_label: "CTA",
        General_details_label: "عام",
        ray_glow_details_label: "صينية متوهجة",
        player_details_label: "اللاعب",
        theme_setting_dialog_header: "إعداد السمة",
        Deal_rights_give_automatically_for_all_channels_label: "تُمنح حقوق الصفقة تلقائيًا لجميع القنوات",
        add_channel_rights_button_tooltip: "إضافة حقوق القناة",
        you_are_not_authorized_to_edit_this_channel_error_message: "غير مصرح لك بتغيير هذه القناة",
        permalink_structure_label: "بنية الرابط الثابت",
        plain_label: "عادي",
        numeric_label: "رقمي",
        post_name_label: "اسم المشاركة",
        excrate_label: "سعر الصرف",
        note_enter_exchange_rate_equal_to_usd_label: "ملاحظة: أدخل سعر الصرف يساوي الدولار الأمريكي",
        excrate_should_not_be_negative_error_message: "سعر الصرف يجب ألا يكون سلبيًا",
        you_delete_this_deal_right_right_from_parent_series_only_media_episode_publishing_error_message: "لقد قمت بحذف هذه الصفقة مباشرة من السلسلة الأصلية فقط...",
        you_delete_this_deal_right_right_from_series_only_media_episode_publishing_error_message: "لقد قمت بحذف هذه الصفقة مباشرة من السلسلة فقط...",
        Agency_type_sub_menu: "نوع الوكالة",
        Agency_type_label: "نوع الوكالة",
        you_are_not_authorized_to_edit_please_go_to_parent_series_error_message: "غير مصرح لك بالتحرير. يرجى الانتقال إلى سلسلة الوالدين",
        you_are_not_authorized_to_edit_please_go_to_series_error_message: "غير مصرح لك بالتحرير. من فضلك اذهب إلى السلسلة",
        create_group_header_dialog: "إنشاء مجموعة",
        Episode_group_page_breadcrumb: "مجموعة الحلقات",
        delete_media_episode_button_tooltip: "حذف حلقة الوسائط",
        Rail_title_details_label: "عنوان السكك الحديدية",
        Menu_details_label: "القائمة",
        section_by_rc_label: "التقسيم حسب آر سي",
        reference_code_column: "الرمز المرجعي",
        two_epiosde_per_day_label: "حلقتان/يوم",
        open_theme_new_tab_label: "فتح المظهر في علامة تبويب جديدة",
        Refresh_theme_label: "تحديث السمة",
        update_slot_duration_label: "مدة فتحة التحديث",
        Duration_updated_success_message: "تم تحديث المدة بنجاح",
        Please_select_duration_error_message: "الرجاء تحديد المدة",
        restricted_genre_label: "النوع المقيد",
        application_configuration_menu: "تكوين التطبيق",
        application_configuration_breadcrumb: "تكوين التطبيق",
        Please_select_genre_error_message: "الرجاء تحديد النوع",
        Font_size_should_be_greater_than_zero_error_message: "يجب أن يكون حجم الخط أكبر من الصفر",
        data_already_exist_error_message: "البيانات موجودة بالفعل",
        you_can_not_delete_in_edit_mode_error_message: "لا يمكنك الحذف في وضع التحرير",
        Please_add_atleast_one_genre_value_error_message: "الرجاء إضافة قيمة نوع واحدة على الأقل",
        valid_short_forms: "نماذج قصيرة غير صالحة",
        valid_tooltip: "غير صالح",
        save_draft_button_tooltip: "حفظ المسودة",
        save_draft_button_title: "حفظ المسودة",
        Publish_button_text: "نشر",
        Program_group_is_mandatory_when_applying_recursive_on_movie_error_message: "يُرجى تحديد مجموعة البرامج لتطبيق عودي على الفيلم/البرنامج",
        Trigger_start_time_label: "وقت بدء التشغيل",
        Trigger_end_time_label: "وقت انتهاء التشغيل",
        Please_select_all_data_while_importing_playlist: "الرجاء تحديد جميع البيانات أثناء استيراد قائمة التشغيل",
        all_days_can_not_be_excluded_error_message: "لا يمكن استبعاد جميع الأيام",
        dont_show_this_message_again: "لا تعرض هذه الرسالة مرة أخرى",
        media_episode_group_grid_note: "ملاحظة: أثناء تطبيق التسلسل العودي، سيكون التسلسل هو نفس التسلسل الموجود في الشبكة أعلاه",
        Please_wait_export_report_message: "الرجاء انتظار تصدير التقرير...",
        section_can_not_be_variation_error_message: "لا يمكن تعيين المقطع كتنوع",
        can_edit_duration_of_segment_error_message: "يمكن تعديل مدة المقطع فقط",
        jobs_schedule_sub_menu: "جدول الوظائف",
        jobs_schedule_page_breadcrumb: "جدول الوظائف",
        Enable_error_log_lebel: "تمكين سجل الأخطاء",
        hourly_button_tooltip: "كل ساعة",
        hourly_button_title: "كل ساعة",
        daily_button_tooltip: "يوميًا",
        daily_button_title: "يوميًا",
        Weekly_button_tooltip: "أسبوعيًا",
        Weekly_button_title: "أسبوعيًا",
        Monthly_button_tooltip: "شهرياً",
        Monthly_button_title: "شهرياً",
        yearly_button_tooltip: "سنويًا",
        yearly_button_title: "سنويًا",
        Quick_schedule_lebel: "جدول سريع",
        create_jobs_schedule_dialog_header: "إنشاء جدول الوظائف",
        valid_input_only_number_and_star_are_allow_error_message: "إدخال غير صالح. يُسمح فقط بالأرقام و ",
        Please_enter_command_error_message: "الرجاء إدخال الأمر",
        can_not_greater_than_error_message: "لا يمكن أن يكون أكبر من",
        variance_sub_menu: "التباين",
        variance_label: "التباين",
        tc_in_without_timecode_label: "ح في",
        tc_out_without_timecode_label: "ح خارج",
        Duration_without_timecode_label: "المدة",
        Minute_label: "الدقيقة (0-59)",
        hour_label: "الساعة (0-23)",
        day_Of_month_label: "اليوم (1-31)",
        week_label: "الأسبوع (1-7)",
        Month_label: "الشهر (1-12)",
        can_not_less_than_error_message: "لا يمكن أن يكون أقل من",
        archive_column: "مؤرشف",
        archive_label: "مؤرشفة",
        Please_upload_doc_error_message: "الرجاء تحميل المستند",
        variation_type_column: "نوع الاختلاف",
        create_variance_dialog_header: "إنشاء التباين",
        global_search_bar_placeholder: "ابحث عن التطبيقات والمحتوى والمزيد. (السيطرة + /)",
        note_variance_link_from_interstitial_edit_form_label: "ملاحظة: يمكنك ربط الإعلان البيني بهذا التباين من نموذج تحرير الإعلان البيني",
        duplicate_item_selected_error_message: "تم تحديد عنصر مكرر",
        Please_select_same_media_category_media_only_global_replacement_error: "الرجاء تحديد نفس فئة الوسائط فقط",
        Restore_schedule_draft_validation_error_message: "لا يمكن استعادة مسودة الجدول للتاريخ الحالي والأيام السابقة للتاريخ الحالي",
        schedul_draft_3_month_auto_delete_note: "*ملاحظة: سيتم تلقائيًا تجاهل المسودات الأقدم من 3 أشهر. احفظ مسودتك في ملف إذا كنت تريد الاحتفاظ بها لفترة أطول",
        delete_planning_log_message: "حذف عنصر التخطيط المحدد",
        edit_using_form_log_message: "تم التعديل باستخدام النموذج",
        add_new_planning_item_log_message: "أضف عنصر تخطيط جديد",
        edited_using_drag_drop_messgae: "تم التعديل باستخدام السحب والإفلات",
        Planning_logs_dialog_header: "سجلات التخطيط",
        slot_column: "فتحة",
        Missing_slot_time_for_error_message: "فتحة مفقودة لـ -",
        Slot_label: "الفتحة",
        Edit_slot_dialog_header: "فتحة التحرير",
        Attached_media_label: "الوسائط",
        time_bound_label: "محدود بالوقت",
        Live_events_label: "الأحداث المباشرة",
        Tournament_label: "البطولة",
        create_event_button_tooltip: "إنشاء حدث",
        create_event_button_text: "إنشاء حدث",
        match_label: "تطابق",
        place_label: "المكان",
        Poster_url_label: "عنوان يو آر إل للملصق",
        Please_select_tournament_error_message: "الرجاء تحديد البطولة",
        Publish_match_header_dialog: "نشر المطابقة",
        un_publish_match_label: "مطابقة غير منشورة",
        Publish_match_label: "نشر المطابقة",
        Selected_days_label: "الأيام المحددة",
        Copy_transfer_schedule_header_dialog: "جدول النسخ/النقل",
        create_date_label: "تاريخ الإنشاء",
        countries_sub_menu: "الدول",
        countries_page_breadcrumb: "الدول",
        pincode_sub_menu: "الرمز السري",
        pincode_page_breadcrumb: "الرمز السري",
        states_sub_menu: "الولايات",
        states_page_breadcrumb: "الدول",
        pincodes_label: "الرموز السرية",
        states_label: "الدول",
        countries_label: "الدول",
        show_media_button_tooltip: "إظهار الوسائط",
        show_media_button_text: "إظهار الوسائط",
        create_genre_button_text: "إنشاء نوع",
        time_zone_page_breadcrumb: "المنطقة الزمنية",
        time_zone_sub_menu: "المنطقة الزمنية",
        is_negative_offset_default_label: "إزاحة سلبية",
        Offset_label: "الإزاحة (ساعة:دقيقة:ثانية ثانية)",
        Please_enter_valid_start_time_message: "الرجاء إدخال وقت بدء صالح",
        time_zone_label: "المنطقة الزمنية",
        date_time_column: "التاريخ والوقت",
        time_zone_column: "المنطقة الزمنية",
        Insert_live_event_actionbutton_menutext: "إدراج حدث مباشر",
        Insert_live_event_actionbutton_menutext_tooltip: "إدراج حدث مباشر",
        virtual_segmentation_actionbutton_menutext: "التقسيم الافتراضي",
        virtual_segmentation_actionbutton_menutext_tooltip: "التقسيم الافتراضي",
        edit_actionbutton_menutext_tooltip: "تحرير",
        Select_all_Header_actionbutton_menutext_tooltip: "تحديد كل الرؤوس",
        delete_header_actionbutton_menutext_tooltip: "حذف الرأس",
        Insert_break_actionbutton_menutext_tooltip: "إدراج فاصل",
        Program_replacement_actionbutton_menutext_tooltip: "استبدال البرنامج",
        expand_all_breaks_actionbutton_menutext_tooltip: "توسيع كافة الفواصل",
        mnimize_all_breaks_actionbutton_menutext_tooltip: "تصغير كافة الفواصل",
        Attach_format_reload_actionbutton_menutext_tooltip: "تنسيق الإرفاق",
        fast_segmentation_actionbutton_menutext_tooltip: "التقسيم السريع",
        Remove_filter_actionbutton_menutext_tooltip: "إزالة الفلتر",
        filter_actionbutton_menutext_tooltip: "تصفية",
        revert_virtual_segmentation_actionbutton_menutext: "إرجاع الجزء الافتراضي",
        revert_virtual_segmentation_actionbutton_menutext_tooltip: "إرجاع الجزء الافتراضي",
        Copy_actionbutton_menutext_tooltip: "نسخ",
        Cut_actionbutton_menutext_tooltip: "قص",
        Paste_actionbutton_menutext_tooltip: "لصق",
        delete_actionbutton_menutext_tooltip: "حذف",
        se_overview_actionbutton_menutext_tooltip: "نظرة عامة على SE",
        global_replacement_actionbutton_menutext_tooltip: "الاستبدال العام",
        delete_Secondary_events_actionbutton_menutext: "حذف الأحداث الثانوية",
        delete_Secondary_events_actionbutton_menutext_tooltip: "حذف الأحداث الثانوية",
        Internal_drag_live_event_error_message: "لا يمكن تغيير الحدث المباشر. يرجى الحذف والنشر مرة أخرى !!",
        search_name_label: "اسم البحث",
        imdb_details_label: "تفاصيل شجونه",
        year_column: "السنة",
        imdb_id_column: "معرف شجونه",
        Poster_column: "ملصق",
        imdb_label: "شجونه",
        actor_label: "ممثل",
        Country_label: "البلد",
        Director_label: "المخرج",
        writer_label: "كاتب",
        wards_label: "الجوائز",
        dvd_label: "دي في دي",
        imdb_votes_label: "أصوات شجونه",
        imdb_id_label: "معرف شجونه",
        production_label: "الإنتاج",
        website_label: "موقع الويب",
        box_office_label: "شباك التذاكر",
        meta_score_label: "نقاط التعريف",
        Release_label: "الإصدار",
        Please_enter_search_name_error_message: "الرجاء إدخال اسم البحث",
        Rails_type_details_dialog_header: "تفاصيل نوع القضبان",
        no_image_found_error_message: "لم يتم العثور على صورة",
        Please_select_item_first_error_message: "يرجى تحديد العنصر أولا!",
        update_imdb_label: "تحديث شجونه",
        scription_label: "الاشتراك",
        Revenue_label: "الإيرادات",
        Total_subscriber_label: "إجمالي المشتركين",
        new_subscriber_label: "المشتركون الجدد",
        Total_deactive_subscriber_label: "المشتركون غير النشطين",
        Total_activation_label: "إجمالي التنشيطات",
        expiring_users_label: "انتهاء صلاحية المشتركين",
        Revenue_by_month_label: "الإيرادات حسب الشهر",
        Revenue_by_platform_label: "الإيرادات حسب النظام الأساسي",
        Revenue_by_Payment_gateway_label: "الإيرادات عن طريق بوابة الدفع",
        Revenue_by_currency_label: "الإيرادات حسب العملة",
        customer_registration_count_graph: "عدد تسجيل المشتركين حسب الشهر",
        Customers_registration_platform_wise: "منصة تسجيل المشتركين الحكيمة",
        buys_by_Payment_gateway: "المشتريات عن طريق بوابة الدفع",
        subscriber_by_platform: "المشترك حسب النظام الأساسي",
        max_devices_label: "الحد الأقصى للأجهزة",
        Please_select_platform_type_error_msg: "الرجاء تحديد النظام الأساسي",
        maximun_device_should_not_be_less_than_one: "يجب ألا يقل الحد الأقصى للأجهزة عن 1",
        Region_details_monetization_dashboard_label: "المنتجات والكوبونات والمشتركون في المنطقة",
        member_by_plan_label: "المشتركون حسب الخطة",
        show_provider_icon_label: "إظهار رمز الموفر",
        subscriber_subscription_history: "سجل الاشتراك",
        Provider_label: "الموفر",
        auto_renew_subscription_label: "حزمة التجديد التلقائي",
        subscriber_login_history: "سجل تسجيل الدخول",
        create_Payment_provider_dialog_header: "إنشاء مزود الدفع",
        currency_code_label: "رمز العملة",
        Branding_name_label: "اسم العلامة التجارية",
        Branding_logo_label: "شعار العلامة التجارية",
        Branding_color_label: "لون العلامة التجارية",
        message_label: "رسالة",
        sand_box_key_id_label: "معرف مفتاح رمل",
        sand_box_secret_key_label: "مفتاح رمل السري",
        Live_key_id_label: "معرف المفتاح المباشر",
        Live_secret_key_label: "المفتاح السري المباشر",
        Success_url_label: "عنوان يو آر إل للنجاح",
        Fail_url_label: "عنوان يو آر إل للفشل",
        Please_enter_live_key_id_error_message: "الرجاء إدخال معرف المفتاح المباشر",
        Please_enter_live_secret_key_error_message: "الرجاء إدخال المفتاح السري المباشر",
        Please_enter_key_id_error_message: "الرجاء إدخال معرف المفتاح",
        Please_enter_secret_key_error_message: "الرجاء إدخال المفتاح السري",
        Please_enter_currency_code_error_message: "الرجاء إدخال رمز العملة",
        Please_enter_branding_name_error_message: "الرجاء إدخال اسم العلامة التجارية",
        Please_enter_branding_logo_error_message: "الرجاء إدخال شعار العلامة التجارية",
        Please_enter_success_url_error_message: "الرجاء إدخال عنوان يو آر إل للنجاح",
        Please_enter_failure_url_error_message: "الرجاء إدخال عنوان يو آر إل للفشل",
        locale_label: "اللغة المحلية",
        Payment_gateway_url_label: "عنوان يو آر إل لبوابة الدفع",
        Please_enter_Payment_gateway_url_error_message: "الرجاء إدخال عنوان يو آر إل لبوابة الدفع",
        some_attached_rails_are_full_page_type_and_can_be_attached_independently_only_error_message: "بعض القضبان المرفقة هي نوع صفحة كامل ويمكن إرفاقها بشكل مستقل فقط",
        session_terminated_label: "تم إنهاء الجلسة",
        your_session_has_been_terminated_label: "تم إنهاء جلستك",
        next_publish_date_label: "تاريخ النشر التالي",
        create_tournament_type_dialog_header: "إنشاء نوع البطولة",
        create_live_event_type_dialog_header: "إنشاء نوع حدث مباشر",
        Please_select_house_number_error_message: "الرجاء اختيار رقم المنزل",
        Success_exported_success_message: "تم التصدير بنجاح",
        Please_enter_cast_and_crew_error_message: "أدخل الفنان في البيانات الوصفية للممثلين والطاقم",
        music_category_sub_menu: "فئة الموسيقى",
        music_category_page_breadcrumb: "فئة الموسيقى",
        create_music_category_dialog_header: "إنشاء فئة موسيقى",
        is_music_label: "هي موسيقى",
        Select_music_category_dialog_header: "اختر فئة الموسيقى",
        music_category_label: "فئة الموسيقى",
        available_music_dialog_header: "الموسيقى المتاحة",
        Please_select_music_category_error_message: "الرجاء تحديد فئة الموسيقى",
        music_menu: "موسيقى",
        more_button_tooltip: "المزيد",
        more_button_text: "المزيد",
        text_color_label: "لون النص",
        Program_time_consumption_report_sub_menu: "تقرير استهلاك وقت البرنامج",
        Program_time_consumption_report_page_breadcrumb: "تقرير استهلاك وقت البرنامج",
        music_report_sub_menu: "تقرير الموسيقى",
        music_report_page_breadcrumb: "تقرير الموسيقى",
        Total_runs_column: "إجمالي مرات التشغيل",
        Total_run_time_column: "إجمالي وقت التشغيل",
        translate_synopsis_level: "ترجمة الملخص",
        tx_mode_sub_menu: "وضع Tx",
        tx_mode_page_breadcrumb: "وضع Tx",
        series_library_label: "مكتبة السلسلة",
        digital_sign_menu: "العلامة الرقمية",
        model_sub_menu: "النموذج",
        model_page_breadcrumb: "النموذج",
        Dimension_label: "الأبعاد",
        model_number_label: "رقم الموديل",
        solution_label: "الحل",
        Display_shape_label: "شكل العرض",
        Brightness_label: "السطوع",
        Display_size_label: "حجم العرض",
        mounting_type_label: "نوع التركيب",
        create_model_dialog_header: "إنشاء نموذج",
        Display_shape_sub_menu: "شكل العرض",
        Display_shape_page_breadcrumb: "شكل العرض",
        solution_sub_menu: "الحل",
        solution_page_breadcrumb: "الحل",
        Please_select_brand_error_message: "الرجاء تحديد العلامة التجارية",
        Please_enter_screen_dimensions_error_message: "الرجاء إدخال أبعاد الشاشة",
        Please_enter_model_number_error_message: "الرجاء إدخال رقم الطراز",
        Please_enter_mounting_type_error_message: "الرجاء إدخال نوع التثبيت",
        Please_select_module_resolution_error_message: "الرجاء تحديد دقة الوحدة",
        Please_select_display_shape_error_message: "الرجاء تحديد شكل العرض",
        Please_enter_brightness_error_message: "الرجاء إدخال السطوع",
        Please_enter_display_size_error_message: "الرجاء إدخال حجم العرض",
        digital_sign_brand_sub_menu: "العلامة التجارية",
        digital_sign_brand_page_breadcrumb: "علامة تجارية رقمية",
        create_node_dialog_header: "إنشاء عقدة",
        parent_node_label: "العقدة الأصلية",
        digital_sign_node_page_breadcrumb: "عقدة الإشارة الرقمية",
        node_sub_menu: "العقدة",
        add_sign_board_button_tooltip: "إضافة لوحة تسجيل",
        digital_sign_board_page_breadcrumb: "لوحة الإشارة الرقمية",
        digital_sign_board_sub_menu: "اللوحة",
        model_label: "النموذج",
        node_label: "العقدة",
        warranty_start_date_label: "تاريخ بدء الضمان",
        warranty_End_date_label: "تاريخ انتهاء الضمان",
        Sign_board_id_label: "معرف لوحة التوقيع",
        model_column: "النموذج",
        Sign_board_id_column: "معرف لوحة التوقيع",
        warranty_date_column: "تاريخ الضمان",
        delete_sign_board_button_tooltip: "حذف لوحة الإشارة",
        date_wise_sheet_label: "ورقة التاريخ الحكيمة",
        tx_status_sub_menu: "حالة الإرسال",
        tx_status_page_breadcrumb: "حالة الإرسال",
        update_txstatus_actionbutton_menutext: "تحديث حالة الإرسال",
        add_comment_actionbutton_menutext: "أضف تعليقات",
        update_comment_actionbutton_menutext: "تحديث التعليق",
        tx_status_label: "حالة تكساس",
        digital_sign_model_page_breadcrumb: "نموذج الإشارة الرقمية",
        Please_enter_dimensions_error_message: "الرجاء إدخال الأبعاد",
        digital_sign_board_label: "لوحة الإشارة الرقمية",
        warranty_end_date_label: "تاريخ انتهاء الضمان",
        create_board_dialog_header: "إنشاء لوحة",
        Please_select_model_error_message: "الرجاء تحديد النموذج",
        Please_enter_sign_board_id_error_message: "الرجاء إدخال معرف لوحة التسجيل",
        create_resolution_dialog_header: "إنشاء دقة",
        length_label: "الطول",
        Please_enter_length_error_message: "يجب أن يكون الطول أكبر من 0",
        Please_width_length_error_message: "يجب أن يكون العرض أكبر من 0",
        Confirm_delete_all_label: "تأكيد حذف الكل",
        are_you_sure_do_you_want_to_delete_all_label: "هل أنت متأكد من رغبتك في حذف الكل",
        serial_number_label: "الرقم التسلسلي",
        Please_enter_serial_number_error_message: "الرجاء إدخال الرقم التسلسلي",
        Aspect_ratio_label: "نسبة العرض إلى الارتفاع",
        width_should_be_greater_than_zero_error_message: "يجب أن يكون العرض أكبر من الصفر",
        height_should_be_greater_than_zero_error_message: "يجب أن يكون الارتفاع أكبر من الصفر",
        playlist_sub_menu: "قائمة التشغيل",
        playlist_page_breadcrumb: "قائمة التشغيل",
        nodes_lable: "العقد",
        digital_sign_overlay_label: "تراكب",
        can_not_add_same_parent_node_error_message: `لا يمكن إضافة نفس العقدة الأصلية`,
        Publish_selected_match_label: "نشر المطابقة المحددة",
        Choose_another_parent_node_error_message: "اختر عقدة أصل أخرى",
        digital_sign_overlay_page_breadcrumb: "تراكب الإشارة الرقمية",
        overlay_page_breadcrumb: "تراكب",
        digital_sign_overlay_sub_menu: "تراكب",
        digital_sign_board_overlay_editpage_header: "تراكب اللوحة",
        Shape_label: "الشكل",
        Position_label: "الموضع",
        text_label: "نص",
        Font_weights_label: "وزن الخط",
        Font_color_label: "لون الخط",
        Please_enter_shape_error_message: "الرجاء إدخال الشكل",
        Font_family_label: "عائلة الخطوط",
        overlay_type_label: "نوع التراكب",
        Font_size_label: "حجم الخط",
        border_radius_label: "نصف قطر الحدود",
        opacity_label: "التعتيم",
        text_marquee_label: "سرادق النص",
        opacity_note: "ملاحظة: يجب أن تتراوح نسبة العتامة بين 0 إلى 1",
        margin_lrtb_text_label: "هامش النص",
        width_percentage_should_be_greater_than_zero_and_less_than_hundred_error_message: "العرض % يجب أن يكون أكبر من 0 وأقل من 100",
        height_percentage_should_be_greater_than_zero_and_less_than_hundred_error_message: "الارتفاع % يجب أن يكون أكبر من 0 وأقل من 100",
        asset_bundle_sub_menu: "حزمة الأصول",
        asset_bundle_page_breadcrumb: "حزمة الأصول",
        edit_asset_bundle_editpage_header: "تحرير حزمة الأصول",
        create_asset_bundle_editpage_header: "إنشاء حزمة أصول",
        add_ott_asset_button_tooltip: "إضافة أصل",
        Channel_number_label: "رقم القناة",
        create_tx_mode_dialog_header: "إنشاء وضع Tx",
        is_type_live_label: "اكتب مباشر",
        sub_genre_label: "الأنواع الفرعية",
        current_active_version_label: "الإصدار النشط الحالي",
        Disable_live_event_section_label: "تعطيل قسم الأحداث المباشرة",
        Export_segmentation_tooltip_button: "تجزئة التصدير",
        text_position_label: "موضع النص",
        text_opacity_label: "عتامة النص",
        digital_sign_board_overlay_page_breadcrumb: "تراكب لوحة الإشارة الرقمية",
        Please_enter_valid_numbers_in_duration: "الرجاء إدخال أرقام صحيحة في المدة",
        text_shape_label: "شكل النص",
        Layer_label: "طبقة",
        Spotify_label: "سبوتيفاي",
        add_blank_label: "إضافة فارغ",
        sync_reference_code_message: "سيتم تحديث الرموز المرجعية للحلقات المرتبطة باستخدام رمز المسلسل كبادئة متبوعة برقم الحلقة.",
        geners_label: "الأجيال",
        sub_geners_label: "الأجيال الفرعية",
        languages_label: "اللغات",
        downloading_please_wait_message: "جاري التنزيل، برجاء الانتظار...",
        format_schedule_sub_menu: "تنسيق الجدول",
        format_schedule_page_breadcrumb: "تنسيق الجدول",
        create_schedule_format_dialog_header: "إنشاء تنسيق الجدول",
        Select_format_dialog_header: "تحديد التنسيق",
        Please_select_format_error_message: "الرجاء تحديد التنسيق",
        Please_enter_valid_from_error_message: "الرجاء إدخال صالح من",
        Please_enter_valid_to_error_message: "الرجاء إدخال صالح لـ",
        Please_select_items_to_update_message: "الرجاء تحديد العناصر المراد تحديثها",
        update_successously_message: "تم التحديث بنجاح",
        Please_select_pg_rated_error_message: "يرجى تحديد تقييم ص",
        Please_select_centric_rated_error_message: "الرجاء تحديد تصنيف الرقيب",
        Please_select_languages_error_message: "يرجى تحديد اللغات",
        Please_select_categories_error_message: "الرجاء تحديد الفئات",
        Please_select_genres_error_message: "الرجاء تحديد الأنواع",
        Please_select_sub_genres_error_message: "الرجاء تحديد الأنواع الفرعية",
        Please_enter_production_year_error_message: "الرجاء إدخال سنة الإنتاج",
        Please_select_technical_prototype_error_message: "الرجاء تحديد النموذج الأولي الفني",
        Please_enter_keywords_error_message: "الرجاء إدخال الكلمات الرئيسية",
        variation_label: "التباين",
        Execute_button_tooltip: "تنفيذ",
        Execute_button_text: "تنفيذ",
        download_summary_tooltip: "ملخص التنزيل",
        from_date_should_be_current_date_error_message: "من تاريخ يجب أن يكون التاريخ الحالي/التاريخ المستقبلي",
        next_number_can_not_be_negative_or_zero_error_meessage: "لا يمكن أن يكون الرقم التالي سالبًا أو صفرًا",
        number_length_should_be_between_1_to_10_error_message: "يجب أن يكون طول الرقم بين 1 إلى 10",
        create_fast_playlist_dialog_header: "إنشاء قائمة تشغيل سريعة",
        digital_sign_screen_group_page_breadcrumb: "مجموعة الشاشة",
        digital_sign_screen_group_sub_menu: "مجموعة الشاشة",
        activate_screen_button_tooltip: "تنشيط الشاشة",
        activate_button_text: "تنشيط",
        activate_button_tooltip: "تنشيط",
        activate_screen_dialog_header: "تنشيط الشاشة",
        Please_enter_screen_name_error_message: "الرجاء إدخال اسم الشاشة",
        Please_enter_otp_error_message: "الرجاء إدخال كلمة المرور لمرة واحدة",
        show_segmentation_actionbutton_menutext: "إظهار التقسيمات",
        show_segmentation_actionbutton_menutext_tooltip: "إظهار التقسيمات",
        screen_page_breadcrumb: "الشاشات",
        create_screen_group_dialog_header: "إنشاء مجموعة شاشة",
        screen_sub_menu: "الشاشات",
        Attach_screen_group_dialog_header: "إرفاق مجموعة الشاشة",
        digital_sign_content_page_breadcrumb: "المحتوى",
        digital_sign_content_sub_menu: "المحتوى",
        create_content_dialog_header: "إنشاء محتوى",
        Please_select_content_type_error_message: "الرجاء تحديد نوع المحتوى",
        Please_select_url_error_message: "الرجاء تحديد عنوان يو آر إل",
        content_type_label: "نوع المحتوى",
        Duration_type_label: "المدة",
        playlist_label: "قائمة التشغيل",
        screen_group_label: "مجموعة الشاشة",
        player_label: "لاعب",
        orientation_label: "الاتجاه",
        play_now_label: "التشغيل الآن",
        Restart_label: "إعادة التشغيل",
        Restart_app_label: "إعادة تشغيل التطبيق",
        cpu_usage_label: "استخدام وحدة المعالجة المركزية",
        do_you_really_want_to_delete_question: "هل تريد حقًا حذف؟",
        percentage_label: "النسبة المئوية",
        digital_sign_content_label: "المحتوى",
        digital_sign_dashboard_sub_menu: "لوحة التحكم",
        digital_sign_dashboard_page_breadcrumb: "لوحة التحكم",
        new_screen_group_button_title: "مجموعة شاشة جديدة",
        new_playlist_button_title: "قائمة تشغيل جديدة",
        new_content_button_title: "محتوى جديد",
        new_screen_button_title: "شاشة جديدة",
        add_screen_group_dialog_header: "إضافة مجموعة شاشة",
        playlist_dialog_header: "قائمة التشغيل",
        Same_screen_group_error_message: "لا يمكن إضافة نفس مجموعة الشاشة",
        add_more_label: "أضف المزيد",
        Mini_column: "صورة مصغرة",
        overlays_column: "التراكبات",
        email_address_label: "عنوان البريد الإلكتروني",
        Sign_up_label: "التسجيل",
        Company_name_label: "اسم الشركة",
        Country_code_label: "رمز البلد",
        Industries_label: "الصناعات",
        Network_screen_size_label: "حجم شاشة الشبكة",
        how_did_you_found_us_label: "كيف وجدتنا",
        Please_enter_password_error_message: "الرجاء إدخال كلمة المرور",
        Please_enter_company_name_error_message: "الرجاء إدخال اسم الشركة",
        Please_select_country_code_error_message: "يرجى تحديد رمز البلد",
        Please_enter_phone_error_message: "الرجاء إدخال الهاتف",
        Please_select_industry_error_message: "الرجاء تحديد الصناعة",
        Please_select_network_screen_size_error_message: "الرجاء تحديد حجم شاشة الشبكة",
        Please_select_how_did_you_found_us_error_message: "الرجاء تحديد كيف وجدتنا",
        Sign_up_dialog_header: "التسجيل",
        login_label: "تسجيل الدخول",
        do_not_have_an_account_label: "ليس لديك حساب؟",
        forgot_password_label: "هل نسيت كلمة المرور؟",
        screen_players_label: "الشاشة/اللاعبون",
        username_label: "اسم المستخدم",
        Manage_underoverrun_schedule_menu_text: "الملء التلقائي للفتحة",
        add_program_menutext: "إضافة برنامج",
        instances_sub_menu: "المثيلات",
        instances_page_breadcrumb: "المثيلات",
        forgot_your_password_label: "هل نسيت كلمة المرور؟",
        enter_email_note: "أدخل بريدك الإلكتروني والرابط وسنرسل لك كلمة المرور الجديدة التي تم إنشاؤها على بريدك الإلكتروني",
        Remember_password_label: "هل تتذكر كلمة المرور؟ ",
        reset_password_button_text: "إعادة تعيين كلمة المرور",
        progress_column: "التقدم",
        Select_interstitial_group_dialoag_header: "حدد مجموعة بينية",
        interstitial_group_button_tooltip: "المجموعة البينية",
        auto_planning_tooltip: "التخطيط التلقائي",
        day_part_sub_menu: "جزء اليوم",
        day_part_page_breadcrumb: "جزء اليوم",
        create_day_part_dialog_header: "إنشاء جزء من اليوم",
        Priority_label: "الأولوية",
        Please_enter_from_time_error_message: "الرجاء الدخول من الوقت",
        Please_enter_to_time_error_message: "الرجاء إدخال الوقت",
        Please_enter_priority_error_message: "الرجاء إدخال أولوية صالحة",
        Please_select_valid_days_error_message: "الرجاء تحديد الأيام الصالحة",
        Please_enter_youtube_link_error_message: "الرجاء إدخال رابط يوتيوب",
        link_label: "الرابط",
        add_new_button_tooltip: "إضافة جديد",
        Attach_screens_column: "إرفاق الشاشات",
        isAllChannel_label: "كل القناة",
        day_part_label: "جزء اليوم",
        Please_select_day_part_error_message: "الرجاء تحديد جزء اليوم",
        Please_enter_reference_code_error_message: "الرجاء إدخال الرمز المرجعي",
        Company_label: "الشركة",
        Please_enter_correct_phone_number_error_message: "الرجاء إدخال رقم الهاتف الصحيح",
        header_address_font_size_label: "حجم خط عنوان الرأس",
        Spots_details_font_size_label: "حجم خط تفاصيل البقع",
        digital_sign_company_plans_page_breadcrumb: "خطط الشركة",
        myrepeatpattern_labe: "تم الإنشاء ذاتيًا",
        style_sheet_dialog_header: "ورقة الأنماط",
        digital_sign_company_plans_sub_menu: "خطط الشركة",
        download_the_app_label: "تنزيل التطبيق",
        in_house_label: "في المنزل",
        digital_sign_admin_dashboard_menu: "لوحة تحكم المشرف",
        digital_sign_admin_dashboard_page_breadcrumb: "لوحة تحكم المشرف",
        last_five_user_login_label: "تسجيل دخول آخر 5 مستخدمين",
        create_content_button_tooltip: "إنشاء محتوى",
        create_genre_button_tooltip: "إنشاء نوع",
        create_sub_genre_button_tooltip: "إنشاء نوع فرعي",
        digital_sign_plans_sub_menu: "الخطط",
        digital_sign_plans_page_breadcrumb: "الخطط",
        edit_image_url_dialog_header: "عنوان يو آر إل لتحرير الصورة",
        Attach_screen_dialog_header: "إرفاق الشاشة",
        Attachments_label: "المرفقات",
        file_attachment_button_tooltip: "مرفق ملف",
        file_column: "ملف",
        file_attachment_dialog_header: "مرفق ملف",
        version_column: "الإصدار",
        target_label: "الأهداف",
        weightage_label: "الوزن",
        weightage_column: "الوزن",
        play_count_label: "عدد مرات التشغيل",
        play_count_column: "عدد مرات التشغيل",
        isplaybycount_label: "التشغيل حسب العدد",
        isplaybycount_column: "التشغيل حسب العدد",
        weightage_should_be_less_than_fifty_error_message: "يجب أن يكون الوزن أقل من 50",
        Please_enter_correct_weightage_error_message: "الرجاء إدخال الوزن الصحيح",
        Please_enter_correct_play_count_error_message: "الرجاء إدخال عدد التشغيل الصحيح",
        play_count_should_be_less_than_fifty_error_message: "يجب أن يكون عدد مرات التشغيل أقل من 50",
        isfetchfromlibrary_label: "جلب من المكتبة",
        create_instance_dialog_header: "إنشاء مثيل",
        base_url_label: "عنوان يو آر إل الأساسي",
        db_name_label: "اسم قاعدة البيانات",
        digisign_base_url_label: "عنوان يو آر إل الأساسي لـ ديجيساين",
        socket_base_url_label: "عنوان يو آر إل الأساسي للمقبس",
        Storage_destination_label: "وجهة التخزين",
        cloud_name_label: "اسم السحابة",
        api_key_label: "مفتاح واجهة برمجة التطبيقات",
        api_secret_label: "سر واجهة برمجة التطبيقات",
        Access_key_id_label: "مفتاح الوصول",
        Secret_access_key_label: "مفتاح الوصول السري",
        Bucket_name_label: "اسم الجرافة",
        Please_enter_base_url_error_message: "الرجاء إدخال عنوان يو آر إل الأساسي",
        Please_enter_bdname_error_message: "الرجاء إدخال اسم القرص الصلب",
        Please_enter_digisign_base_url_error_message: "الرجاء إدخال عنوان يو آر إل الأساسي لـ ديجيساين",
        Please_enter_socket_base_url_error_message: "الرجاء إدخال عنوان يو آر إل لقاعدة المقبس",
        Quality_label: "الجودة",
        Quality_should_be_less_than_100_error_message: "يجب أن تكون الجودة أقل من 100",
        file_label: "ملف",
        keep_org_label: "الاحتفاظ بالأصل",
        cdn_url_label: "عنوان يو آر إل لـ شبكة التنمية المستدامة",
        Please_enter_cdn_url_error_message: "الرجاء إدخال عنوان يو آر إل لـ شبكة التنمية المستدامة",
        Please_cloud_name_error_message: "الرجاء إدخال اسم السحابة",
        Please_api_key_error_message: "الرجاء إدخال مفتاح واجهة برمجة التطبيقات",
        Please_api_secret_error_message: "الرجاء إدخال سر واجهة برمجة التطبيقات",
        Please_access_keyid_error_message: "الرجاء إدخال معرف مفتاح الوصول",
        Please_secret_access_key_error_message: "الرجاء إدخال مفتاح الوصول السري",
        Please_region_error_message: "الرجاء إدخال المنطقة",
        Please_bucket_name_error_message: "الرجاء إدخال اسم المجموعة",
        column_label: "عمود",
        Please_select_column_error_message: "الرجاء تحديد العمود",
        Please_select_operator_error_message: "الرجاء تحديد المشغل",
        fill_gaps_label: "سد الفجوات",
        digital_sign_content_group_sub_menu: "مجموعة المحتوى",
        digital_sign_content_group_page_breadcrumb: "مجموعة المحتوى",
        content_group_editpage_header: "إنشاء مجموعة محتوى",
        add_content_button_tooltip: "إضافة محتوى",
        digital_sign_add_content_dialog_header: "إضافة محتوى",
        Please_attach_atleast_one_content_error_message: "الرجاء إرفاق محتوى واحد على الأقل",
        digital_sign_content_group_label: "مجموعة المحتوى",
        low_gap_label: "الحد الأدنى للفجوة (بالساعات)",
        section_for_channel_rights_label: "سيتم تعطيل بعض المقاطع إذا لم تكن لديك حقوق القناة لنفسها.",
        already_have_an_account_label: "هل لديك حساب بالفعل؟",
        min_gap_error_message: "لا يمكن أن تكون الحد الأدنى من الفجوة سالبة",
        min_gap_invalid_error_message: "الرجاء إدخال الحد الأدنى الصحيح للفجوة",
        set_as_default_label: "تعيين كافتراضي",
        low_gap_in_primary_event_label: "أدنى فجوة (بالأيام)",
        is_tx_status_label: "حالة الإرسال",
        tx_status_column: "حالة الإرسال",
        restricted_pg_rating_label: "تقييم الصفحات المقيدة",
        marker_label: "علامة",
        in_label: "في",
        out_label: "خارج",
        marker_duration_label: "المدة",
        time_code_markers: "علامات الرمز الزمني",
        Duration_label_tooltip: "(س:د:ثث:فف)",
        create_marker_button_tooltip: "إنشاء علامة",
        Please_enter_valid_value_in_error_message: "الرجاء إدخال كلمة صحيحة",
        Please_enter_valid_value_out_error_message: "الرجاء إدخال قيمة صالحة، يجب ألا يكون الدخل أكبر من الخارج",
        in_column: "في",
        out_column: "خارج",
        Tcm: "الطب الصيني التقليدي",
        Please_select_time_code_marker_error_message: "الرجاء تحديد علامة رمز الوقت",
        ott_platform_sub_menu: "النظام الأساسي",
        ott_platform_page_breadcrumb: "النظام الأساسي",
        Module_restrictions_label: "قيود الوحدة",
        action_label: "الإجراء",
        Please_select_segment_header: "الرجاء تحديد المقطع",
        Restriction_actions_label: "إجراءات التقييد",
        no_permission_to_delete_header_info: "ليس لديك إذن بحذف الرأس.",
        Please_contact_admin_message: "الرجاء الاتصال بالمسؤول",
        Privacy_policy_label: "سياسة الخصوصية",
        ott_assets_used_in_archive_confirmation_message: "تم استخدام هذا الأصل في",
        ott_assets_archive_confirmation_message: "هل مازلت ترغب في أرشفته؟",
        ingestion_report_sub_menu: "تقرير العرض",
        ingestion_report_page_breadcrumb: "تقرير العرض",
        cast_and_crew_column: "الممثلون وطاقم العمل",
        censer_ating_column: "تقييم الرقيب",
        production_year_column: "سنة الإنتاج",
        Activity_dropdown_label: "النشاط",
        asset_type_column: "نوع الأصل",
        Provider_column: "الموفر",
        Access_level_column: "مستوى الوصول",
        vod_type_column: "نوع الفود",
        Potrait_image_url_column: "عنوان يو آر إل للصورة الشخصية",
        Landscape_image_url_column: "عنوان يو آر إل للصورة الطبيعية",
        playlist_import_buffer_label: "المخزن المؤقت لاستيراد قائمة التشغيل",
        is_negative_playlist_import_buffer_label: "هل المخزن المؤقت لاستيراد قائمة التشغيل سلبي",
        add_user_dialog_header: "إضافة مستخدم",
        add_new_company_dialog_header: "إضافة شركة جديدة",
        Tenure_label: "الحيازة",
        screens_label: "الشاشات",
        Storage_label: "التخزين",
        Plan_label: "الخطة",
        users_label: "المستخدمون",
        Please_enter_plan_name_error_message: "الرجاء إدخال اسم الخطة",
        Plan_tenure_should_be_greater_than_zero_error_message: "يجب أن تكون المدة أكبر من 0",
        Plan_screens_should_be_greater_than_zero_error_message: "يجب أن تكون الشاشات أكبر من 0",
        Plan_storage_should_be_greater_than_zero_error_message: "يجب أن تكون مساحة التخزين أكبر من 0",
        Please_add_atleast_one_user_error_message: "الرجاء إضافة مستخدم واحد على الأقل",
        enter_your_pin_label: "أدخل رقم التعريف الشخصي الخاص بك",
        Please_select_company_error_message: "الرجاء اختيار الشركة",
        Event_country_level: "بلد الحدث",
        Please_enter_event_country_error_message: "الرجاء إدخال بلد الحدث",
        team_a_poster_url_label: "عنوان يو آر إل لملصق الفريق أ",
        team_b_poster_url_label: "عنوان يو آر إل لملصق الفريق ب",
        Company_type_label: "نوع الشركة",
        Tournament_group_dialog_header: "مجموعة البطولة",
        Tournament_group_page_breadcrumb: "مجموعة البطولة",
        Tournament_group_sub_menu: "مجموعة البطولة",
        Tournament_group_label: "مجموعة البطولة",
        Please_select_tournament_group: "يرجى تحديد مجموعة البطولة",
        add_playlist_button_tooltip: "إضافة قائمة تشغيل",
        Plans_label: "الخطط",
        Change_password_button_tooltip: "تغيير كلمة المرور",
        Change_password_dialog_header: "تغيير كلمة المرور",
        Success_change_password_message: "تم تغيير كلمة المرور بنجاح",
        asrun_report_dialog_header: "تقرير أسرون",
        playlist_name_column: "اسم قائمة التشغيل",
        screen_name_column: "اسم الشاشة",
        serial_number_column: "الرقم التسلسلي",
        every_label: "كل",
        is_auto_restart_enabled_label: "إعادة التشغيل التلقائي",
        daily_reboot_label: "إعادة التشغيل اليومي",
        Restart_time_label: "إعادة التشغيل عند",
        screen_group_column: "مجموعة الشاشة",
        playlist_column: "قائمة التشغيل",
        epg_convertor_sub_menu: "محول دليل البرامج الإلكتروني",
        source_epg_file_label: "ملف دليل البرامج الإلكتروني المصدر",
        opta_file_label: "ملف OPTA",
        image_url_file_label: "ملف عنوان يو آر إل للصورة",
        source_epg_tab_label: "دليل البرامج الإلكتروني المصدر",
        opta_tab_label: "OPTA",
        image_url_tab_label: "عنوان يو آر إل للصورة",
        converter_epg_tab_label: "دليل البرامج الإلكتروني المحول",
        Convert_button_label: "تحويل",
        global_label: "عالمي",
        media_template_sub_menu: "قالب الوسائط",
        media_template_page_breadcrumb: "قالب الوسائط",
        media_template_dialog_header: "قالب الوسائط",
        Select_media_template_collection_header: "حدد قالب الوسائط",
        save_and_create_media_template_button_tooltip: "حفظ وإنشاء قالب الوسائط",
        Select_media_template_button_tooltip: "حدد قالب الوسائط",
        save_as_media_template_button_text: "حفظ كقالب",
        start_button_tooltip: "بدء التشغيل",
        start_button_title: "بدء التشغيل",
        Task_label: "مهمة",
        Please_select_task_error_message: "الرجاء تحديد المهمة",
        Command_label: "الأمر",
        Execute_shell_label: "تنفيذ Shell",
        Disable_lebel: "تعطيل",
        Command_column: "الأمر",
        Execute_shell_column: "تنفيذ Shell",
        schedule_column: "الجدول الزمني",
        Enable_error_log_column: "تمكين سجل الأخطاء",
        Disable_column: "تعطيل",
        Success_count_column: "عدد النجاح",
        last_activity_count_column: "آخر نشاط",
        next_schedule_time_column: "وقت الجدول التالي",
        Please_add_atleast_one_publishing_rights_error_message: "يُرجى إضافة حقوق نشر واحدة على الأقل",
        genres_label: "الأنواع",
        sub_genres_label: "الأنواع الفرعية",
        avod_Configuration_sub_menu: "تكوين أفود",
        avod_Configuration_label: "تكوين أفود",
        ad_tags_column: "علامات الإعلان",
        avod_Configuration_dialog_header: "إنشاء تكوين أفود",
        Features_label: "الميزات",
        Please_select_title_error_message: "الرجاء تحديد العنوان",
        ad_tag_column: "علامة الإعلان",
        avod_configuration_page_breadcrumb: "تكوين أفود",
        avod_feature_label: "ميزة أفود",
        ad_tag_label: "إنشاء علامة إعلانية",
        Please_select_ad_tag_error_message: "يُرجى تحديد علامة الإعلان",
        Linked_channels_label: "القنوات المرتبطة",
        Gender_label: "الجنس",
        Please_select_gender_error_message: "يرجى تحديد الجنس",
        parent_contract_label: "العقد الأصلي",
        Select_contract_collection_header: "تحصيل العقد",
        Non_linear_publishing_label: "النشر غير الخطي",
        video_not_found_error_message: "لم يتم العثور على الفيديو",
        time_line_view_tooltip: "عرض الجدول الزمني",
        Response_area_label: "الاستجابة",
        job_schedule_base_url_label: "عنوان يو آر إل الأساسي لجدول الوظائف",
        Please_enter_job_schedule_base_url_error_message: "الرجاء إدخال عنوان يو آر إل الأساسي لجدول المهام",
        downloading_excel_please_wait_message: "جارٍ تنزيل Excel، برجاء الانتظار...",
        Enable_notification_label: "تمكين الإشعارات",
        show_shedule_dialog_header: "إظهار الجدول الزمني",
        Please_select_atleast_one_item_error_message: "الرجاء تحديد عنصر واحد على الأقل",
        Please_select_item_to_replace_error_message: "الرجاء تحديد العنصر المراد استبداله",
        table_time_column: "جدول الوقت",
        Select_item_to_replace_label: "حدد عنصرًا لاستبداله",
        save_and_run_button_text: "حفظ وتشغيل",
        epg_template_label: "قالب دليل البرامج الإلكتروني",
        message_sub_menu: "رسالة",
        message_provider_sub_menu: "موفر الرسائل",
        message_template_sub_menu: "قالب الرسالة",
        message_configuration_sub_menu: "تكوين الرسالة",
        message_provider_page_breadcrumb: "موفر الرسائل",
        message_template_page_breadcrumb: "قالب الرسالة",
        message_configuration_page_breadcrumb: "تكوين الرسالة",
        message_provider_dialog_header: "إنشاء موفر الرسائل",
        auth_key_lable: "مفتاح المصادقة",
        message_template_dialog_header: "إنشاء قالب رسالة",
        is_unicode_label: "يونيكود",
        is_flash_label: "فلاش",
        sender_id_lable: "معرف المرسل",
        message_configuration_dialog_header: "تكوين الرسالة",
        message_type_label: "نوع الرسالة",
        message_template_label: "قالب الرسالة",
        message_provider_label: "موفر الرسائل",
        Please_enter_auth_key_error_message: "الرجاء إدخال مفتاح المصادقة",
        Please_enter_content_error_message: "الرجاء إدخال المحتوى",
        Please_enter_sender_id_error_message: "الرجاء إدخال معرف المرسل",
        Please_select_message_type_error_message: "الرجاء تحديد نوع الرسالة",
        message_variant_label: "متغير الرسالة",
        devices_label: "الأجهزة",
        Device_name_column: "اسم الجهاز",
        last_login_time_column: "آخر وقت لتسجيل الدخول",
        important_update_successously_message: "تم التحديث المهم بنجاح",
        param_label: "بارام",
        Please_add_atleast_one_Ad_tags_error_message: "يُرجى إضافة علامة إعلانية واحدة على الأقل",
        ingestion_logs_dialog_header: "سجلات العرض",
        ingestion_logs_sub_menu: "سجلات العرض",
        Status_label: "الحالة",
        ingestion_logs_page_breadcrumb: "سجلات العرض",
        Partner_ingestion_template: "نموذج العرض",
        Partner_ingestion_base_url: "عنوان يو آر إل الأساسي للعرض",
        Please_select_ingestion_template: "يُرجى تحديد قالب العرض",
        Please_enter_ingestion_base_url: "الرجاء إدخال عنوان يو آر إل الأساسي للعرض",
        data_column: "بيانات",
        Please_select_status_error_message: "الرجاء تحديد الحالة",
        Please_enter_curl_error_message: "الرجاء إدخال الضفيرة",
        curl_label: "حليقة",
        params_label: "بارامز",
        row_label: "صف",
        table_view_label: "عرض الجدول",
        Please_select_message_variant_error_message: "الرجاء تحديد متغير الرسالة",
        deactive_lebel: "غير نشط",
        parent_genre_label: "النوع الأصلي",
        parent_language_label: "اللغة الأم",
        parent_pg_rated_label: "تقييم ص الأصلي",
        parent_Censor_rated_label: "تقييم الرقابة على الوالدين",
        censer_rated_sub_menu: "تقييم الرقيب",
        pg_rated_dialog_header: "إنشاء تقييم ص ز",
        censer_rated_dialog_header: "إنشاء تصنيف رقيب",
        match_type_label: "نوع المطابقة",
        match_type_page_breadcrumb: "نوع المطابقة",
        match_type_sub_menu: "نوع المطابقة",
        match_type_dialog_header: "إنشاء نوع مطابقة",
        Column_column: "عمود",
        request_label: "طلب",
        sales_dialog_header: "إنشاء مبيعات",
        concurrency_label: "التزامن",
        force_upgrade_label: "فرض الترقية",
        Please_enter_version_error_message: "الرجاء إدخال الإصدار",
        check_every_label: "تحقق من كل",
        analytics_providers_sub_menu: "موفرو التحليلات",
        analytics_providers_page_breadcrumb: "موفرو التحليلات",
        analytics_events_sub_menu: "أحداث التحليلات",
        analytics_events_page_breadcrumb: "أحداث التحليلات",
        create_analytics_provider_dialog_header: "إنشاء موفر التحليلات",
        Please_enter_api_key_error_message: "الرجاء إدخال مفتاح واجهة برمجة التطبيقات",
        analytics_event_page_editpageheader: "حدث التحليلات",
        Please_enter_provider_name_error_message: "الرجاء إدخال اسم الموفر",
        Provider_name_label: "اسم الموفر",
        parental_control_label: "تمكين الرقابة الأبوية",
        code_label: "الرمز",
        Please_enter_symbol_error_message: "الرجاء إدخال الرمز",
        Independent_episode_page_breadcrumb: "حلقات مستقلة",
        subscriber_profile_dialog_header: "ملف تعريف المشترك",
        Enable_pg_restriction_label: "تمكين تقييد ص",
        pin_label: "دبوس",
        Enable_parent_control_label: "تمكين التحكم الأبوي",
        restricted_pgratings_label: "تقييمات الصفحة المقيدة",
        debug_mode_label: "وضع التصحيح",
        auto_restart_percent_label: "إعادة التشغيل التلقائي",
        set_resolution_dialog_header: "ضبط الدقة",
        Please_select_resolution_error_message: "الرجاء تحديد القرار",
        asrun_report_label: "تقرير أسرون",
        asrun_report_tooltip: "تقرير أسرون",
        auto_fill_playlist_dialog_header: "ملء قائمة التشغيل تلقائيًا",
        Apply_fixed_sequence_label: "تطبيق تسلسل ثابت",
        Apply_fixed_start_items_label: "تطبيق عناصر البداية الثابتة",
        auto_manage_footers_label: "إدارة التذييلات تلقائيًا",
        allowed_footers_offset_label: "إزاحة التذييل المسموح به",
        fix_playlist_label: "إصلاح قائمة التشغيل خلال 24 ساعة",
        Categories_required_in_sequence: "الفئات المطلوبة في التسلسل",
        Select_format_label: "حدد التنسيق",
        Select_format_collection_header: "حدد التنسيق",
        Select_media_category_type_collection_header: "حدد نوع فئة الوسائط",
        error_log_column: "سجل الأخطاء",
        Please_wait_loading_error_message: "الرجاء انتظار التحميل...",
        media_management_report_sub_menu: "تقرير إدارة الوسائط",
        media_management_report_dialog_header: "تقرير إدارة الوسائط",
        media_content_report_sub_menu: "تقرير محتوى الوسائط",
        media_content_report_page_breadcrumb: "تقرير محتوى الوسائط",
        long_form_label: "نموذج طويل",
        short_form_label: "نموذج قصير",
        Spot_label: "بقعة",
        play_mode_label: "وضع التشغيل",
        Memory_label: "الذاكرة",
        used_label: "مستعمل",
        free_label: "مجاني",
        delete_storage_button_tooltip: "حذف مساحة التخزين",
        asrun_error_report_dialog_header: "خطأ تشغيل",
        Restart_history_dialog_header: "إعادة تشغيل السجل",
        Enable_asrunlog_label: "تمكين سجل أسرون",
        take_periodic_screenshots_label: "لقطات الشاشة الدورية",
        image_format_label: "تنسيق الصورة",
        video_format_label: "تنسيق الفيديو",
        Restart_type_column: "نوع إعادة التشغيل",
        preset_label: "إعداد مسبق",
        Commercial_schedule_list: "المواقع التجارية المجدولة",
        Disable_profile_selection_label: " تعطيل تحديد ملف التعريف",
        auto_fill_music: "الملء التلقائي للموسيقى",
        content_group_label: "مجموعة المحتوى",
        digital_sign_add_content_group_dialog_header: "إضافة مجموعة محتوى",
        digital_sign_add_overlays_dialog_header: "إضافة تراكبات",
        Restart_screen_label: "إعادة تشغيل الشاشة",
        sports_event_label: "حدث رياضي",
        mam_asset_report: "تقرير أصول مام",
        Success_delete_storage_label: "تم حذف التخزين بنجاح",
        Live_event_details: "تفاصيل الحدث المباشر",
        Please_create_screen_first_label: "الرجاء إنشاء شاشة أولاً...",
        screen_create_description_label: "بعد إضافة شاشة، يمكنك إنشاء محتوى، وبعد ذلك قم بإنشاء قائمة تشغيل.",
        add_screen_button_label: "إضافة شاشة",
        Please_create_content_label: "الرجاء إنشاء محتوى...",
        content_create_description_label: "بعد إضافة محتوى، يمكنك إنشاء قائمة تشغيل.",
        add_content_button_label: "إضافة محتوى",
        Please_create_playlist_label: "الرجاء إنشاء قائمة تشغيل...",
        playlist_create_description_label: "يمكنك إنشاء قائمة تشغيل، انقر فوق إضافة قائمة تشغيل",
        add_playlist_button_label: "إضافة قائمة تشغيل",
        create_content_label: "إنشاء محتوى",
        content_message_label: "هل تريد إضافة محتوى؟",
        create_playlist_label: "إنشاء قائمة تشغيل",
        playlist_message_label: "هل تريد إنشاء قائمة تشغيل؟",
        sync_mam_asset_label: "مزامنة أصول مام",
        localization_dialog_header: "التعريب",
        cast_Type_dialog_header: "نوع الإرسال",
        logon_again_label: "تسجيل الدخول مرة أخرى",
        Please_image_bucket_name_error_message: "الرجاء إدخال اسم مجموعة صور س 3",
        Please_video_bucket_name_error_message: "الرجاء إدخال اسم مجموعة فيديو س 3",
        Please_enter_image_cdn_url_error_message: "الرجاء إدخال عنوان يو آر إل لصورة س 3 ج د ن",
        Please_enter_video_cdn_url_error_message: "الرجاء إدخال عنوان يو آر إل الخاص بـ ج د ن لفيديو س 3",
        s3_access_key_id_label: "معرف مفتاح الوصول س 3",
        s3_region_label: "منطقة س 3",
        s3_video_bucket_name_label: "اسم مجموعة فيديو س 3",
        s3_video_cdn_url_label: "عنوان يو آر إل لفيديو ج د ن لفيديو س 3",
        how_to_create_google_slide: "كيفية إنشاء شريحة جوجل:",
        go_to_google_slide: "انتقل إلى الصفحة الرئيسية لشرائح جوجل بالنقر على الرابط المتوفر.",
        click_on_homepage_template_option_available: "بمجرد الوصول إلى الصفحة الرئيسية، حدد إما قالب الشريحة الفارغ أو قالبًا مصممًا مسبقًا من الخيارات المتاحة.",
        create_presentation: "ابدأ في إنشاء العرض التقديمي الخاص بك عن طريق إضافة النصوص والصور والتصميمات إلى الشرائح وفقًا لاحتياجاتك.",
        Copy_url_of_google_slide: "انقر فوق الزر نشر، وانسخ عنوان يو آر إل للعرض التقديمي، وأضف معلمة الحلقة=false إليه، ثم الصقه في حقل إدخال عنوان يو آر إل.",
        custom_title_1_label: "عنوان مخصص 1",
        custom_title_2_label: "عنوان مخصص 2",
        base_api_key_label: 'مفتاح واجهة برمجة التطبيقات الأساسي',
        s3_secret_access_key_label: "مفتاح الوصول السري س 3",
        s3_image_bucket_name_label: 'اسم مجموعة صور س 3',
        s3_image_cdn_url_label: 'عنوان أور إل لصورة قرص مضغوط ن لصورة س 3',
        ched_playlist_page_breadcrumb: "قائمة التشغيل المجدولة",
        ched_playlist_sub_menu: "قائمة التشغيل المجدولة",
        table_type_label: "نوع الجدول الزمني",
        ched_playlist_header: "قائمة التشغيل المجدولة",
        no_end_date_label: "لا يوجد تاريخ انتهاء",
        digital_sign_report_page_breadcrumb: "تقرير",
        digital_sign_report_menu: "تقرير",
        digital_sign_report_header: "تقرير",
        isRightToLeft: "من اليمين إلى اليسار",
        s3_secret_access_key_label: 'مفتاح الوصول السري لـ S3',
        s3_region_label: 'منطقة S3',
        s3_image_bucket_name_label: 'اسم دلو صورة S3',
        s3_video_bucket_name_label: 'اسم دلو فيديو S3',
        s3_image_cdn_url_label: 'عنوان يو آر إل لشبكة توصيل المحتوى الخاصة بصورة S3',
        s3_video_cdn_url_label: 'عنوان يو آر إل لشبكة توصيل الفيديو S3',
        how_to_create_google_slide: 'كيفية إنشاء شريحة جوجل:',
        go_to_google_slide: 'انتقل إلى الصفحة الرئيسية لـ جوجل الشرائح بالنقر فوق الرابط المقدم.',
        click_on_homepage_template_option_available: 'بمجرد الوصول إلى الصفحة الرئيسية، حدد إما قالب الشريحة الفارغ أو قالب مصمم مسبقًا من الخيارات المتاحة.',
        creating_presentation: 'ابدأ بإنشاء العرض التقديمي الخاص بك عن طريق إضافة النصوص والصور والتصميمات إلى الشرائح وفقًا لاحتياجاتك.',
        copy_url_of_google_slide: 'انقر فوق زر النشر، وانسخ عنوان يو آر إل للعرض التقديمي، وأضف إليه معلمة حلقة = خطأ، ثم ألصقه في حقل إدخال عنوان يو آر إل.',
        custom_title_1_label: 'عنوان مخصص 1',
        custom_title_2_label: 'عنوان مخصص 2',
        schedule_playlist_page_breadcrumb: 'قائمة التشغيل المجدولة',
        Schedule_playlist_sub_menu: 'قائمة التشغيل المجدولة',
        schedule_type_label: 'نوع الجدول',
        schedule_playlist_header: 'قائمة التشغيل المجدولة',
        no_end_date_label: 'لا يوجد تاريخ انتهاء',
        digital_sign_report_page_breadcrumb: 'تقرير',
        digital_sign_report_menu: 'تقرير',
        digital_sign_report_header: 'تقرير',
        isRightToLeft: 'من اليمين إلى اليسار',
        show_deal_label: 'عرض الصفقة',
        acquition_report_sub_menu: 'تقرير الاستحواذ',
        acquire_report_page_breadcrumb: 'تقرير الاستحواذ',
        budget_column: 'الميزانية',
        licensor_column: 'المرخص',
        payee_column: 'المستفيد',
        contract_media_library_label: 'مكتبة الوسائط التعاقدية',
        total_acq_label: 'إجمالي المساحة',
        total_budget_label: 'إجمالي الميزانية',
        amortization_rule_sub_menu: 'قاعدة الاستهلاك',
        amortization_rule_page_breadcrumb: 'قاعدة الاستهلاك',
        amortization_rule_dialog_header: 'قاعدة الاستهلاك',
        rule_text_label: 'نص القاعدة',
        please_select_amortization_rule_message: 'الرجاء تحديد قاعدة الاستهلاك',
        please_enter_rule_text_message: 'الرجاء إدخال نص القاعدة',
        amortization_rule_label: 'قاعدة الاستهلاك',
        amortization_rule_report_button_tooltip: 'تقرير الاستهلاك',
        amortization_rule_report_dialog_header: 'تقرير الاستهلاك',
        rule_text_instruction: 'أدخل قيم النسب المئوية مفصولة بفاصلة مع التأكد من أن الإجمالي هو 100% (على سبيل المثال، 10، 60، 30).',
        invalid_rule_text_total_error_message: 'يجب أن يكون إجمالي قيم نص القاعدة 100%.',
        amortization_rule_column: 'قاعدة الاستهلاك',
        amortization_value_column: 'قيمة الاستهلاك',
        detach_mam_asset_confirmation_msg: "هل تريد حقًا فصل هذا الأصل عن هذه الوسائط؟",
        logo_height_label: 'ارتفاع الشعار',
        select_custom_date_range: 'تحديد نطاق تاريخ مخصص',
        exhibition_used_label: 'معرض مستعمل',
        total_runs_label: 'إجمالي الجولات',
        exhibition_number_label: 'رقم المعرض',
        amortized_value_label: 'القيمة المستهلكة',
        exhibition_schedule_label: 'المعرض مُجدول',
        trailer_label: 'مقطورات',
        switch_to_planning_view_tooltip: 'التبديل إلى عرض التخطيط',
        switch_to_series_timeline_view_tooltip: 'التبديل إلى عرض الجدول الزمني للسلسلة',
        coming_events_page_breadcrumb: 'الأحداث القادمة',
        coming_events_sub_menu: 'الأحداث القادمة',
        coming_events_header: 'الأحداث القادمة',
        start_date_lable: 'تاريخ البدء',
        launch_date_label: 'تاريخ الإطلاق',
        ott_asset_label: 'الأصول',
        coming_event_dialog_header: 'الحدث القادم',
        social_media_menu: 'وسائل التواصل الاجتماعي',
        budget_sub_menu: 'الميزانيات',
        budget_page_breadcrumb: 'الميزانية',
        budget_dialog_header: 'الميزانية',
        client_po_no_label: 'رقم طلب شراء العميل.',
        agency_commission_label: 'عمولة الوكالة',
        can_only_be_in_Percentage: 'لا يمكن أن يكون إلا بنسبة مئوية (%)',
        ad_status_column: 'حالة الإعلان',
        objective_column: 'الهدف',
        daily_budget_column: 'الميزانية اليومية',
        spend_cap_column: 'حد الإنفاق',
        buying_type_column: 'نوع الشراء',
        please_enter_description_error_message: 'الرجاء إدخال الوصف',
        please_enter_client_po_no_error_message: 'الرجاء إدخال رقم طلب شراء العميل.',
        please_select_status_error_message: 'الرجاء تحديد الحالة',
        please_enter_order_date_error_message: 'الرجاء تحديد تاريخ الطلب',
        please_enter_from_date_error_message: 'الرجاء تحديد التاريخ',
        please_enter_to_date_error_message: 'الرجاء تحديد التاريخ',
        please_enter_agency_error_message: 'الرجاء إدخال الوكالة',
        please_enter_client_error_message: 'الرجاء إدخال العميل',
        please_enter_currency_error_message: 'الرجاء تحديد العملة',
        please_enter_targetAmount_error_message: 'الرجاء إدخال المبلغ المستهدف',
        please_enter_target_amount_error_message: 'لا يمكن أن يكون المبلغ المستهدف أقل من الحد الأقصى للإنفاق الإجمالي للحملة',
        please_enter_agency_comission_error_message: 'لا يمكن أن تكون عمولة الوكالة سلبية',
        Budget_label: "الميزانية",
        campaign_dialog_header: 'الحملة',
        objective_label: 'الهدف',
        buying_type_label: 'نوع الشراء',
        bid_strategy_label: 'استراتيجية العطاءات',
        spend_cap_label: 'الحد الأقصى للإنفاق',
        daily_budget_label: 'الميزانية اليومية',
        special_ad_categories_label: 'فئات الإعلانات الخاصة',
        only_two_special_ad_categories: 'يمكن تحديد فئتين إعلانيتين خاصتين فقط.',
        audience_column: 'الجمهور',
        please_select_budget_error_message: 'الرجاء تحديد الميزانية',
        please_enter_start_time_error_message: 'الرجاء إدخال وقت البدء',
        please_enter_end_time_error_message: 'الرجاء إدخال وقت الانتهاء',
        please_select_objective_error_message: 'الرجاء تحديد الهدف',
        please_select_buying_type_error_message: 'الرجاء تحديد نوع الشراء',
        please_select_bid_strategy_error_message: 'الرجاء تحديد استراتيجية المزايدة',
        please_select_spend_cap_error_message: 'الرجاء تحديد الحد الأقصى للإنفاق',
        please_enter_spend_cap_cannot_exceed_available_budget_error_message: 'لا يمكن أن يتجاوز الحد الأقصى للإنفاق الميزانية المتاحة',
        please_enter_daily_budget_error_message: 'الرجاء إدخال الميزانية اليومية',
        please_enter_daily_budget_cannot_exceed_spend_cap_error_message: 'لا يمكن للميزانية اليومية أن تتجاوز الحد الأقصى للإنفاق',
        please_enter_valid_targetAmount_error_message: 'الرجاء إدخال مبلغ مستهدف صالح',
        sm_ads_page_breadcrumb: 'الإعلانات',
        asset_id_label: 'معرف الأصل',
        title_label: 'العنوان',
        ad_dialog_header: 'إعلان',
        image_column: 'صورة',
        file_name_column: 'اسم الملف',
        format_column: 'تنسيق',
        delete_button_tooltip: 'حذف',
        please_enter_asset_id_error_message: 'الرجاء إدخال معرف الأصل',
        please_enter_title_error_message: 'الرجاء إدخال العنوان',
        please_select_product_error_message: 'الرجاء تحديد المنتج',
        please_select_brand_error_message: 'الرجاء تحديد العلامة التجارية',
        please_attach_at_least_one_asset_error_message: 'الرجاء إرفاق أصل واحد على الأقل',
        ads_sub_menu: 'الإعلانات',
        sm_audience_page_breadcrumb: 'الجمهور',
        audience_sub_menu: 'الجمهور',
        please_enter_name_error_message: 'الرجاء إدخال الاسم',
        please_enter_description_error_message: 'الرجاء إدخال الوصف',
        please_select_geo_location_error_message: 'الرجاء تحديد الموقع الجغرافي',
        please_select_interest_error_message: 'الرجاء تحديد الاهتمام',
        please_select_gender_error_message: 'الرجاء تحديد الجنس',
        please_enter_minimum_age_error_message: 'الرجاء إدخال الحد الأدنى للعمر',
        please_enter_maximum_age_error_message: 'الرجاء إدخال الحد الأقصى للعمر',
        sm_channels_sub_menu: 'القنوات',
        sm_channels_page_breadcrumb: 'القنوات',
        publish_button_tooltip: 'نشر',
        un_publish_button_tooltip: 'إلغاء النشر',
        spotsperTRP_label: "النقاط لكل الحزب الراديكالي الراديكالي",
        target_trp_label: "الحزب الراديكالي الراديكالي المستهدف",
        upate_target_spots_button_tooltip: "تحديث مواقع الأهداف",
        advertising_channel_type_lable: "نوع قناة الإعلان",
        spand_cap_label: "الحد الأقصى للإنفاق",
        please_select_advertising_type_error_message: "الرجاء تحديد نوع قناة الإعلان",
        please_enter_cpc_bid_micros_error_message: "الرجاء إدخال الحد الأقصى للإنفاق",
        to_date_cannot_be_earlier_than_from_date_message: 'لا يمكن أن يكون تاريخ "إلى" أقدم من تاريخ "من".',
        end_time_cannot_be_earlier_than_start_time_message: 'لا يمكن أن يكون وقت الانتهاء أقدم من وقت البدء.',
        stop_date_label: 'تاريخ التوقف',
        impressions_label: 'الانطباعات',
        clicks_label: 'النقرات',
        spends_label: 'إنفاق',
        cpc_label: 'تكلفة النقرة',
        cpm_label: 'التكلفة لكل ألف ظهور',
        ctr_label: 'نسبة النقر إلى الظهور',
        show_insight_button_tooltip: 'إظهار الرؤى',
        create_audience_button_tooltip: 'إنشاء جمهور',
        audience_created_successfully: 'تم إنشاء الجمهور بنجاح',
        audience_updated_successfully: 'تم تحديث الجمهور بنجاح',
        error_fetching_insights: 'خطأ في جلب الرؤى لهذه الحملة',
        sm_dashboard_sub_menu: 'لوحة التحكم',
        social_media_dashboard_page_breadcrumb: 'لوحة المعلومات',
        campaign_active_label: 'الحملات النشطة',
        campaign_inactive_label: 'الحملات غير النشطة',
        publish_ads_label: 'نشر الإعلانات',
        unpublish_ads_label: 'إلغاء نشر الإعلانات',
        campaign_insights_label: 'رؤى الحملة',
        spent_column: 'مُنْفَق',
        bid_strategy_column: 'استراتيجية العطاءات',
        skednetwork_attribution_column: 'إسناد Skadnetwork',
        split_test_variable_column: 'متغير اختبار الانقسام',
        cpc_column: 'تكلفة النقرة',
        cpm_column: 'التكلفة لكل ألف ظهور',
        ctr_column: 'نسبة النقر إلى الظهور',
        sm_campaigns_sub_menu: 'الحملات',
        sm_campaigns_page_breadcrumb: 'الحملات',
        insight_dialog_header: 'رؤية ثاقبة',
        facebook_access_token_invalid_message: 'رمز وصول فيسبوك غير صالح أو منتهي الصلاحية. يُرجى إعادة المصادقة',
        failed_to_fetch_facebook_pages_message: 'فشل في جلب صفحات فيسبوك',
        please_enter_daily_budget_error_message: 'الرجاء تحديد الميزانية اليومية',
        objective_type_label: 'نوع الهدف',
        please_select_linkedin_objective_type_error_message: 'الرجاء تحديد نوع الهدف',
        please_select_linkedin_type_error_message: 'الرجاء تحديد النوع',
        coming_campaigns_label: 'الحملات القادمة',
        share_post_label: 'مشاركة في منشور',
        create_post_button: 'إنشاء منشور',
        quote_label: 'اقتباس',
        hashtag_label: 'هاشتاج',
        share_on_facebook_button: 'مشاركة على الفيسبوك',
        share_on_linkedin_button: 'مشاركة على ينكدين',
        share_url_label: 'مشاركة عنوان يو آر إل',
        share_this_link_via_label: 'مشاركة هذا الرابط عبر',
        cost_type_label: 'نوع التكلفة',
        add_program_sub_menu: "إضافة برنامج",
        search_program_sub_menu: "البحث عن البرنامج",
        create_add_program_dialog_header: "إنشاء برنامج",
        inputs_sub_menu: "المدخلات",
        dai_configuration_sub_menu: "التكوين",
        dai_configuration_page_breadcrumb: 'التكوين',
        output_configuration_setting_label: 'تكوين الإخراج',
        segment_length_label: 'طول القطعة',
        admarkers_label: 'علامات الإعلان',
        caption_language_mappings_label: 'تعيينات لغة التسمية التوضيحية',
        caption_language_setting_label: 'إعداد لغة التسمية التوضيحية',
        client_cache: 'ذاكرة التخزين المؤقت للعميل',
        codec_specification_label: 'مواصفات الترميز',
        directory_structure_label: 'بنية الدليل',
        discontinuity_tags_label: 'علامات عدم الاستمرارية',
        hlsId3_segment_tagging_label: 'وضع علامات على شريحة HlsId3',
        iframe_only_playlists_label: 'قوائم التشغيل أنا إطار فقط',
        incomplete_segment_behavior_label: 'سلوك القطعة غير المكتمل',
        Indexn_segments_label: 'مقاطع الفهرس',
        input_loss_action_label: 'إجراء فقدان الإدخال',
        ivin_manifest_label: 'بيان إيفين',
        iv_source_label: 'المصدر الرابع',
        keep_segments_label: 'الاحتفاظ بالأجزاء',
        manifest_compression_label: "ضغط البيان",
        manifest_duration_format_label: 'تنسيق مدة البيان',
        matchMediaode_label: 'الوضع',
        output_selection_label: 'اختيار الإخراج',
        program_datetime_label: 'تاريخ البرنامج والوقت',
        program_datetimeclock_label: "برنامج التاريخ والوقت والساعة",
        program_datetime_period_label: 'تاريخ البرنامج والفترة الزمنية',
        redundantManifest_label: 'بيان زائد',
        segmentation_mode_label: 'وضع التجزئة',
        segmentsPer_subdirectory_label: 'الأجزاء لكل دليل فرعي',
        satisfiestreaminf_resolution_label: 'تدفق إنفر ريزوليوشن',
        timed_metadataid3frame_label: 'إطار بيانات التعريف الوصفية الموقوت معرف3',
        timed_metadataid3period_label: 'فترة معرف التعريف التعريفي للتعريف المحدد بوقت',
        tsFile_mode_label: 'وضع ملف نهاية الخبر',
        avail_configuration_label: 'التكوين المتاح',
        no_regional_blackout_flag_label: 'لا يوجد علم انقطاع التيار الكهربائي الإقليمي',
        web_delivery_allowed_flag_label: 'علم التسليم عبر الويب المسموح به',
        scte35_segmentation_scope_label: 'نطاق تجزئة إس سي تي إي 35',
        media_configuration_label: 'تكوين مقطع الوسائط',
        enableAd_markerpassthrough_label: 'تمكين مرور علامة الإعلان',
        ad_insertionmode_label: 'وضع إدراج الإعلان',
        avail_suppression_mode_label: 'وضع قمع الإتاحة',
        avail_suppression_valie_label: 'قيمة قمع الاستفادة',
        input_configuration_label: 'تكوين الإدخال',
        audio_selectors_label: 'محددات الصوت',
        caption_selectors_label: 'محددات التسمية التوضيحية',
        deblock_filter_label: 'إزالة حظر الفلتر',
        denoise_filter_label: 'فلتر إزالة الضوضاء',
        filter_strength_label: 'قوة الفلتر',
        input_filter_label: 'مرشح الإدخال',
        buffer_segments_label: 'أجزاء المخزن المؤقت',
        retries_label: 'إعادة المحاولة',
        retry_interval_label: 'فترة إعادة المحاولة',
        scte35_source_label: 'مصدر إس سي تي إي 35',
        server_validation_label: 'التحقق من صحة الخادم',
        smpte2038_data_preference_label: 'تفضيلات بيانات سمبتي2038',
        source_end_behavior_label: 'سلوك نهاية المصدر',
        deblock_kilter_label: 'إزالة حظر المرشح',
        dai_input_page_breadCrumb: 'إدخال',
        dai_input_dialog_header: 'إدخال',
        input_class_label: 'فئة الإدخال',
        password_param_label: 'كلمة المرور',
        outputs_sub_menu: 'المخرجات',
        dai_output_page_breadCrumb: 'الإخراج',
        dai_output_dialog_header: 'الإخراج',
        dai_add_output_dialog_header: 'إضافة إخراج',
        please_select_output_name_error_message: 'الرجاء تحديد اسم الإخراج',
        name_modifier_label: "مُعدِّل الاسم",
        audio_rendition_sets_label: "مجموعات تجسيد الصوت",
        audio_frames_per_pes_label: "إطارات الصوت لكل بيس",
        audio_pids_label: "معرفات معرف المنتج الصوتية",
        klv_behavior_label: "سلوك ك ل ف",
        nielsen_id3_behavior_label: "سلوك نيلسن معرف3",
        pcr_control_label: "التحكم في تفاعل البوليميراز المتسلسل",
        pmt_pid_label: "بي إم تي معرف المنتج",
        program_num_label: "رقم البرنامج",
        scte35_behavior_label: "سلوك إس سي تي إي 35",
        scte35_pid_label: "معرف إس سي تي إي 35 معرف المنتج",
        timed_metadata_behavior_label: "سلوك البيانات الوصفية الموقوت",
        timed_metadata_pid_label: "معرف بيانات التعريف الموقوتة",
        video_pid_label: "معرف معرف المنتج للفيديو",
        video_descriptions_title: "أوصاف الفيديو",
        h264_settings_title: "إعدادات ح264",
        name_label: "الاسم",
        height_label: "الارتفاع",
        width_label: "العرض",
        afd_signaling_label: "إشارات الوكالة الفرنسية للتنمية",
        bitrate_label: "معدل البت",
        framerate_control_label: "التحكم في معدل الإطارات",
        gop_size_label: "حجم الحزب الجمهوري",
        gop_size_units_label: "وحدات حجم الحزب الجمهوري",
        rate_control_mode_label: "وضع التحكم في المعدل",
        scan_type_label: "نوع المسح الضوئي",
        scene_change_detect_label: "اكتشاف تغيير المشهد",
        timecode_insertion_label: "إدراج رمز الوقت",
        audio_descriptions_title: 'الأوصاف الصوتية',
        audio_name_label: 'الاسم',
        audio_type_control_label: 'التحكم في نوع الصوت',
        aac_settings_title: 'إعدادات الجميح للسيارات',
        bitrate_label: 'معدل البت',
        coding_mode_label: 'وضع الترميز',
        input_type_label: 'نوع الإدخال',
        profile_label: 'الملف الشخصي',
        rate_control_mode_label: 'وضع التحكم في المعدل',
        raw_format_label: 'تنسيق خام',
        sample_rate_label: 'معدل العينة',
        specification_label: 'المواصفات',
        output_name_label: 'اسم الإخراج',
        addition_timezone_label: 'المنطقة الزمنية الإضافية',
        enable_additional_timezone_label: 'تمكين المنطقة الزمنية الإضافية',
        inputs_sub_menu: "المدخلات",
        dai_channels_sub_menu: "القنوات",
        dai_channels_page_breadcrumb: "القنوات",
        dai_channel_dialog_header: "إنشاء قناة",
        input_label: 'إدخال',
        output_label: 'الإخراج',
        configuration_label: 'التكوين',
        please_select_input_error_message: 'الرجاء تحديد الإدخال',
        please_select_output_error_message: 'الرجاء تحديد الإخراج',
        please_select_configuration_error_message: 'الرجاء تحديد التكوين',
        please_enter_destination_s3_url_error_message: 'الرجاء إدخال عنوان يو آر إل للوجهة S3',
        destinatio_s3_url_label: 'عنوان يو آر إل الخاص بـ S3',
        avail_suppression_fill_policy_label: 'سياسة تعبئة قمع الإتاحة',
        dai_inputs_page_breadCrumb: 'المدخلات',
        dai_outputs_page_breadCrumb: 'المخرجات',
        add_avail_offset_label: "إزاحة الإتاحة",
        avail_suppression_value_label: 'قيمة قمع الاستفادة',
        preview_label: 'معاينة',
        ad_decision_server_url_label: 'عنوان يو آر إل لخادم قرار الإعلان',
        video_content_source_url_label: 'عنوان يو آر إل لمصدر محتوى الفيديو',
        hls_url_label: 'عنوان يو آر إل لـ ح ل س',
        dash_url_label: 'عنوان يو آر إل الخاص بـ داش',
        file_name_label: 'اسم الملف',
        please_enter_file_name_error_message: 'الرجاء إدخال اسم الملف',
        no_preview_available_label: 'لا توجد معاينة متاحة',
        create_input_button_tooltip: 'إنشاء إدخال',
        create_output_button_tooltip: 'إنشاء إخراج',
        create_configuration_button_tooltip: 'إنشاء التكوين',
        outputs_label: 'المخرجات',
        edit_input_button_tooltip: 'تحرير الإدخال',
        edit_output_button_tooltip: 'تحرير الإخراج',
        edit_configuration_button_tooltip: 'تحرير التكوين'
    }
};


